import type { Translations } from '../index';

export const pt: Translations = {
  errors: {
    generic: {
      unknownTitle: 'Não foi possível concluir a ação',
      unknownMessage: 'Seu trabalho está seguro. Tente a ação novamente em um momento.',
      badRequestTitle: 'Não conseguimos processar essa solicitação',
      badRequestMessage: 'Revise os dados destacados e tente novamente.',
      notFoundTitle: 'Não encontrado',
      notFoundMessage: 'Não encontramos o que você procurava. Pode ter sido movido ou removido.',
      conflictTitle: 'Isto já existe',
      conflictMessage: 'Este item já existe ou foi alterado em outro lugar. Atualize e tente novamente.',
      unsupportedFileTitle: 'Arquivo não suportado',
      unsupportedFileMessage: 'Esse tipo de arquivo não é suportado aqui. Tente outro arquivo.',
      fileTooLargeTitle: 'Arquivo muito grande',
      fileTooLargeMessage: 'Esse arquivo excede o tamanho permitido. Tente um arquivo menor.',
      retry: 'Tentar novamente',
      dismiss: 'Fechar',
    },
    network: {
      offlineTitle: 'Você parece estar offline',
      offlineMessage: 'Verifique sua conexão com a internet e tente novamente.',
      timeoutTitle: 'Isto está demorando mais do que o esperado',
      timeoutMessage: 'A solicitação expirou. Seu trabalho está salvo — tente novamente.',
      serviceUnavailableTitle: 'Serviço temporariamente indisponível',
      serviceUnavailableMessage: 'Estamos brevemente indisponíveis. Tente novamente em alguns segundos.',
      serverErrorTitle: 'Nosso serviço está com problemas',
      serverErrorMessage: 'Já fomos notificados e estamos trabalhando nisso. Tente novamente em breve.',
    },
    auth: {
      sessionExpiredTitle: 'Sua sessão expirou',
      sessionExpiredMessage: 'Para sua segurança, faça login novamente para continuar.',
      signInCta: 'Entrar',
      invalidCredentialsTitle: 'E-mail ou senha incorretos',
      invalidCredentialsMessage: 'Verifique suas credenciais e tente novamente.',
      accountLockedTitle: 'Conta temporariamente bloqueada',
      accountLockedMessage: 'Muitas tentativas. Tente novamente em alguns minutos.',
      accountDeactivatedTitle: 'Conta desativada',
      accountDeactivatedMessage: 'Esta conta está desativada. Entre em contato com seu administrador.',
      forbiddenTitle: 'Você não tem acesso',
      forbiddenMessage: 'Você não tem permissão para esta ação.',
      invalidCodeTitle: 'Esse código não funcionou',
      invalidCodeMessage: 'O código de verificação é inválido ou expirou. Solicite um novo.',
      currentPasswordWrongTitle: 'A senha atual está incorreta',
      currentPasswordWrongMessage: 'Digite novamente sua senha atual e tente novamente.',
      userExistsTitle: 'A conta já existe',
      userExistsMessage: 'Já existe uma conta com este e-mail. Tente fazer login.',
    },
    credits: {
      insufficientTitle: 'Créditos insuficientes',
      insufficientMessage: 'Você não tem créditos suficientes para concluir isto. Adicione créditos ou faça upgrade do seu plano para continuar.',
      buyCreditsCta: 'Comprar créditos',
      minAmountTitle: 'Quantidade muito baixa',
      minAmountMessage: 'A compra mínima é de 10 créditos.',
      invalidAmountTitle: 'Insira uma quantidade válida',
      invalidAmountMessage: 'Insira um número válido de créditos.',
      noPaymentMethodTitle: 'Adicione uma forma de pagamento',
      noPaymentMethodMessage: 'Adicione uma forma de pagamento antes de continuar.',
      checkoutFailedTitle: 'Não foi possível iniciar o pagamento',
      checkoutFailedMessage: 'Não conseguimos abrir o pagamento. Tente novamente.',
      subscriptionRequiredTitle: 'Assinatura necessária',
      subscriptionRequiredMessage: 'Você precisa de um plano pago ativo para comprar créditos. Assine um plano primeiro.',
      subscribeCta: 'Ver planos',
    },
    orders: {
      notFoundTitle: 'Pedido não encontrado',
      notFoundMessage: 'Este pedido não existe ou você não tem acesso a ele.',
      accessDeniedTitle: 'Acesso negado',
      accessDeniedMessage: 'Você não tem acesso a este pedido.',
      readOnlyTitle: 'Acesso somente leitura',
      readOnlyMessage: 'Seu acesso é somente leitura: você pode ver o pedido, mas não avançá-lo',
      createFailedTitle: 'Não conseguimos criar seu pedido',
      createFailedMessage: 'Algo interrompeu a criação do pedido. Seu arquivo ainda está aqui — tente novamente.',
    },
    corpus: {
      notFoundTitle: 'Corpus não encontrado',
      notFoundMessage: 'Este corpus não existe ou foi removido.',
      duplicateTermTitle: 'Termo duplicado',
      duplicateTermMessage: 'Este termo já está no glossário.',
    },
    plan: {
      limitTitle: 'Limite do seu plano atingido',
      limitMessage: 'Você atingiu o que seu plano atual permite. Faça upgrade para continuar.',
      upgradeCta: 'Atualizar plano',
      alreadyFreeTitle: 'Você está no plano Grátis',
      alreadyFreeMessage: 'Você já está no plano Grátis. Escolha um plano pago para desbloquear mais.',
    },
    processing: {
      timeoutTitle: 'O processamento está demorando demais',
      timeoutMessage: 'O serviço de documentos expirou. Seu upload está seguro — tente novamente.',
      failedTitle: 'Não conseguimos concluir o processamento',
      failedMessage: 'Algo interrompeu o processamento. Tente novamente.',
    },
  },
  formatTemplates: {
    title: 'Modelos de formato',
    subtitle: "Defina folha, margens, fonte, cabeçalho, numeração, traços de preenchimento e fórmula de encerramento. O modelo é aplicado na Opção 4 ao revisar um pedido.",
    adminTitle: 'Modelos de formato globais',
    adminSubtitle: "Modelos da EZDocu disponíveis para todas as contas. Cada conta escolhe qual ativar (ou nenhum); nunca se aplicam sozinhos.",
    newTemplate: 'Novo modelo',
    newGlobalTemplate: 'Novo modelo global',
    duplicateBtn: 'Duplicar',
    duplicateFromGlobalHint: 'Cria uma cópia própria editável a partir deste modelo da EZDocu',
    editBtn: 'Editar',
    deleteBtn: 'Excluir',
    confirmDeleteBtn: 'Excluir?',
    setDefaultBtn: 'Definir como padrão',
    defaultBadge: 'Padrão',
    globalBadge: 'EZDocu',
    ownBadge: 'Próprio',
    myTemplates: 'Meus modelos',
    globalTemplates: 'Modelos da EZDocu',
    filterAll: 'Todos',
    filterGlobal: 'Globais',
    filterAccounts: 'De contas',
    loading: 'Carregando modelos…',
    empty: 'Você ainda não tem modelos próprios. Duplique um da EZDocu ou crie um novo.',
    emptyAdmin: 'Não há modelos.',
    copySuffix: '(cópia)',
    errorGeneric: 'Não foi possível salvar o modelo',
    summaryHeader: 'Cabeçalho',
    summaryNumbering: 'Numeração',
    summaryFill: 'Traços',
    summaryClosing: 'Encerramento',
    yes: 'sim',
    off: 'não',
    sectionGeneral: 'Geral',
    sectionPage: 'Folha, margens e tipografia',
    sectionTypography: 'Tipografia',
    sectionHeaderFooter: 'Cabeçalho e rodapé',
    sectionNumbering: 'Numeração de páginas',
    sectionFill: 'Preenchimento de linhas curtas',
    sectionClosing: 'Fórmula de encerramento',
    fieldName: 'Nome',
    fieldDescription: 'Descrição',
    fieldPageFormat: 'Tamanho da folha',
    fieldOrientation: 'Orientação',
    portrait: 'Vertical',
    landscape: 'Horizontal',
    a4: 'A4',
    letter: 'Carta',
    legal: 'Ofício',
    fieldMarginTop: 'Superior (mm)',
    fieldMarginBottom: 'Inferior (mm)',
    fieldMarginLeft: 'Esquerda (mm)',
    fieldMarginRight: 'Direita (mm)',
    fieldFontFamily: 'Fonte',
    fieldFontSize: 'Tamanho (pt)',
    fieldLineHeight: 'Entrelinha',
    fieldTextAlign: 'Alinhamento',
    alignJustify: 'Justificado',
    alignLeft: 'Esquerda',
    alignCenter: 'Centro',
    alignRight: 'Direita',
    fieldParagraphSpaceAfter: 'Após parágrafo (pt)',
    fieldHeaderEnabled: 'Cabeçalho nas folhas',
    fieldHeaderText: 'Texto do cabeçalho',
    fieldHeaderAlign: 'Alinhamento',
    fieldHeaderMode: 'Em quais folhas',
    headerModeAll: 'Todas',
    headerModeFirst: 'Só a primeira',
    headerModeRest: 'Todas menos a primeira',
    fieldHeaderFontSize: 'Tamanho da letra (pt)',
    fieldHeaderFontSizeHint: 'Igual ao corpo',
    fieldFooterEnabled: 'Rodapé',
    fieldFooterText: 'Texto do rodapé',
    fieldPageNumbering: 'Numerar páginas',
    fieldPageNumberFormat: 'Formato',
    numberFormatN: '1, 2, 3',
    numberFormatNdeM: 'Página 1 de N',
    numberFormat00n: '001, 002',
    fieldPageNumberStart: 'Começar em',
    fieldPageNumberPosition: 'Posição',
    posFooterCenter: 'Rodapé, centralizado',
    posFooterRight: 'Rodapé, direita',
    posHeaderRight: 'Cabeçalho, direita',
    fieldFillShortLines: 'Completar as linhas curtas com traços',
    fieldFillChar: 'Caractere',
    fieldFillScope: 'Onde',
    fillScopeParagraphEnd: 'Última linha de cada parágrafo',
    fillScopeLine: 'Toda linha curta',
    fillScopeBlankOnly: 'Só linhas vazias',
    fieldClosingEnabled: 'Adicionar fórmula de encerramento',
    fieldClosingHtml: 'Texto (HTML simples)',
    fieldClosingKeepTogether: 'Mantê-la junto ao último parágrafo (nunca sozinha em folha nova)',
    variablesHint: 'Variáveis disponíveis (clique para copiar):',
    previewTitle: "Pré-visualização",
    previewDocxBtn: "Word de amostra",
    previewDocxError: "Não foi possível gerar o Word de amostra",
    mirrorMakeEditable: "Editar como formato próprio",
    mirrorSheetNote: "O documento sai exatamente como é hoje",
    verifiedBadge: "Verificado",
    alreadyInMenu: "Já no seu menu",
    detectSaveDirect: "Salvar como está",
    swipeForMore: "Deslize para ver mais formatos →",
    orderFormatLabel: "Formato de saída",
    orderFormatHint: "Decide como sai a Opção 4. Também pode mudá-lo na Revisão, sem reprocessar.",
    previewRealLoading: "Gerando visualização real…",
    closingLangLabel: "Idioma da fórmula de juramento",
    closingLangEs: "Tal como está escrita no modelo (sem traduzir)",
    closingLangTarget: "Traduzida para o idioma de destino do pedido",
    smallMarginWarn: "Margens menores que 10 mm podem ser cortadas na impressão.",
    colEmpty: "Vazia",
    colText: "Texto",
    colPageNum: "Número de página",
    colTextPlaceholder: "Texto da coluna",
    colRemove: "Remover",
    colAdd: "Adicionar coluna",
    colSwitchToColumns: "Construir por colunas (até 4)",
    fieldFooterRule: "Linha impressa acima do rodapé",
    sectionRules: "Regras do documento",
    fieldLineNumbering: "Numerar as linhas (formato judicial)",
    fieldLinesPerPage: "Linhas por página",
    fieldLineNumberRule: "Régua vertical",
    lineNumberingHint: "Os números se recalculam sozinhos ao editar o Word: vivem na seção, nunca escritos como texto.",
    pinBtn: "Fixar",
    pinnedBadge: "Fixado",
    pinHint: "O que está fixado aparece ao preparar um pedido",
    addToMenuBtn: "Adicionar ao meu menu",
    deleteInUseConfirm: "Este formato foi usado em {n} pedido(s). Pedidos entregues não mudam. Excluir mesmo assim?",
    deleteInUseConfirmOne: "Este formato foi usado em {n} pedido. Pedidos entregues não mudam. Excluir mesmo assim?",
    deleteInUseConfirmOther: "Este formato foi usado em {n} pedidos. Pedidos entregues não mudam. Excluir mesmo assim?",
    searchPlaceholder: "Buscar um formato…",
    catAll: "Todos",
    catGeneral: "Geral",
    catCertified: "Juramentada",
    catCourt: "Tribunais",
    pickerNoPinned: "Você não tem formatos fixados. Fixe os que usa em Formatos para vê-los aqui.",
    uploadWordBtn: "Enviar seu Word",
    detectTitle: "Isto é o que o seu Word contém",
    detectReading: "Lendo o arquivo…",
    detectIntro: "Estas propriedades foram lidas de {file}. O que não foi encontrado aparece marcado — nada é preenchido às escondidas.",
    detectNotFound: "Não encontrado",
    detectYes: "Sim",
    detectNo: "Não",
    detectHint: "No editor você pode completar o que falta e ver o resultado no papel, ao vivo.",
    detectOpenEditor: "Abrir no editor",
    detectFailed: "Não foi possível ler o arquivo. É um .docx de até 20 MB?",
    previewPageOf: "Página {n} de {m}",
    previewTabScreen: "Tela",
    previewTabWord: "Word",
    previewTabPdf: "PDF",
    previewAllMatch: "Tela, Word e PDF saem iguais",
    previewGuides: "Mostrar guias",
    previewGuideHeader: "Cabeçalho",
    previewGuideFooter: "Rodapé",
    previewGuideContent: "Conteúdo",
    previewRuler: "Régua",
    previewRulerDrag: "Arraste para alterar a margem",
    previewSample1: "CERTIDÃO DE NASCIMENTO",
    previewSample2: "Certifico que a presente é tradução fiel do documento original que tive diante de mim. O interessado nasceu na cidade indicada e seus dados constam do registro correspondente.",
    previewSample3: "Os dados do assento conferem com os do documento apresentado, e o original não apresenta emendas nem rasuras.",
    previewClosingSignature: "Assinatura e carimbo do tradutor",
    previewPageBreak: "quebra de página",
    mirrorNotice: "Espelho do original: este formato reproduz o documento tal como sai hoje. Página, tipografia e regras não se aplicam.",
    saveBtn: 'Salvar',
    savingBtn: 'Salvando…',
    cancelBtn: 'Cancelar',
    backBtn: 'Voltar',
    unsavedConfirm: 'Você tem alterações não salvas. Sair sem salvar?',
    savedOk: 'Salvo',
    unsavedTitle: 'Alterações não salvas',
    unsavedStay: 'Ficar',
    unsavedLeave: 'Sair sem salvar',
    variablesLangHint: "As variáveis de idioma, mês e data são escritas automaticamente no idioma de destino da tradução.",
    closingSignatureToggle: "Adicionar assinatura e carimbo (imagem)",
    closingSignatureUpload: "Enviar imagem de assinatura/carimbo",
    closingSignatureRemove: "Remover imagem",
    createBtn: 'Criar',
    defaultCardLabel: 'Modelo de formato padrão',
    defaultCardHint: "Ative-o para que seus pedidos tenham também a Opção 4 com este formato",
    defaultNone: "Sem modelo (a Opção 4 não é gerada)",
    defaultManageLink: 'Gerenciar modelos',
    defaultSaved: 'Salvo',
    pickerLabel: 'Modelo',
    pickerApplying: 'Aplicando…',
    pickerError: 'Não foi possível aplicar o modelo',
    pickerNone: "Original",
    wordOnly: "O arquivo deve ser um documento do Word (.docx).",
    noMatches: "Nenhum formato corresponde a “{q}”.",
    dropWordHere: "Solte o .docx para ler a formatação",
    dragWordOrClick: "Arraste um arquivo do Word para cá ou clique para enviá-lo ({btn})",
    privacyNote: "O arquivo é usado apenas para ler a formatação: o conteúdo não é guardado e é excluído ao terminar.",
    fieldUnit: "Unidade",
    unitCm: "Centímetros (cm)",
    unitIn: "Polegadas (in)",
    ruleRepeatSeal: "Repetir carimbo e assinatura em todas as páginas",
    ruleDescribeIllegible: "Descrever carimbos/assinaturas ilegíveis",
    ruleInvalidateBack: "Invalidar o verso",
    ruleSingleSided: "Impressão em um só lado",
    colImage: "Imagem",
    colImageLogo: "Logotipo",
    colImageSignature: "Assinatura",
    colImageSeal: "Carimbo",
    colImageRemove: "Remover imagem própria",
    colImageUpload: "Enviar imagem",
    colImageUploading: "Enviando…",
    colImageTooBig: "Máx. 2 MB",
    colImageUploadError: "Não foi possível enviar a imagem",
    colSizeS: "Pequena",
    colSizeM: "Média",
    colSizeL: "Grande",
    colSizeCustom: "Personalizada",
    detectHeaderImage: "Imagem do cabeçalho",
    detectFooterImage: "Imagem do rodapé",
    sampleFileName: "{name} (amostra {time})",
    sampleDefaultName: "formato",
    errHeaderEmpty: "O cabeçalho está ativado, mas não tem texto nem colunas.",
    errClosingEmpty: "A fórmula de encerramento está ativada, mas não tem texto.",
    errNameRequired: "O nome é obrigatório.",
    errInvalidValue: "Há um valor fora do intervalo. Verifique margens, tamanhos, entrelinha e numeração.",
    lockedNotice: "Este formato é verificado: a norma não permite alterar esses campos. Duplique-o se precisar de outra configuração.",
    marginsBox: "Margens",
    marginsLink: "Iguais",
    marginsLinkHint: "Deixa as quatro margens iguais; enquanto estiver ativo, ao mudar uma mudam todas",
    bandToolbarLabel: "Editar blocos",
    blockMoveLeft: "Mover para a esquerda",
    blockMoveRight: "Mover para a direita",
    blockDelete: "Excluir bloco",
    blockDrag: "Arraste para reordenar (ou pressione espaço e use as setas)",
    blockDragInstructions: "Para reordenar com o teclado, pressione espaço, mova com as setas e pressione espaço de novo para soltar.",
    blockTextLabel: "Texto do bloco",
    blockTextPlaceholder: "Digite aqui",
    blockTextEditorHint: "Esc para concluir",
    blockImageHeight: "Altura (mm)",
    blockImageResize: "Altura da imagem",
    blockImageProfile: "{img} do perfil",
    bandEmpty: "Nenhum bloco ainda. Adicione texto, uma imagem ou o número da página.",
    bandHeaderEmptyWarn: "O cabeçalho está ativado, mas vazio: escreva algo ou desative-o.",
    bandAutoPageNum: "Número de página automático: ajuste em “Numeração de páginas”",
    bandOrderHint: "Da esquerda para a direita, como aparecem na folha. Você também pode editá-los na pré-visualização.",
    bandClickToEdit: "Clique para editar",
    blocksHeader: "Blocos do cabeçalho",
    blocksFooter: "Blocos do rodapé",
    bandSheetHint: "Clique no cabeçalho ou no rodapé da folha para editá-los",
    blockMaxReached: "Máximo de 4 blocos por faixa",
    blockPageNumExists: "Esta faixa já tem o número da página",
    blockImageLocked: "A norma deste formato não permite imagens aqui",
    blockDeleted: "Bloco excluído",
    blockUndo: "Desfazer",
    blockImageChange: "Trocar imagem…",
    blockImageUploadNew: "Enviar imagem…",
    previewEditingMockup: "Editando na maquete",
    previewShowReal: "Ver folha real",
    previewZoom: "Zoom da pré-visualização",
    previewZoomOut: "Diminuir zoom",
    previewZoomIn: "Aumentar zoom",
    previewZoomActual: "Tamanho real (100%)",
    previewZoomFit: "Ajustar à largura",
    fieldHeaderDistance: "Distância do cabeçalho até a borda ({unit})",
    fieldFooterDistance: "Distância do rodapé até a borda ({unit})",
    bandDistanceHint: "Como no Word: se o cabeçalho ou o rodapé não couber na margem, o texto se desloca para dar espaço. Nas guias, a linha pontilhada marca essa distância.",
    bandDistanceTooBig: "A distância não cabe nesta folha: pode ser no máximo {max} da borda.",
    bandHeaderPushes: "O cabeçalho não cabe na margem: o texto começa a {x}, igual ao Word e ao PDF.",
    bandFooterPushes: "O rodapé não cabe na margem: o texto termina a {x} da borda, igual ao Word e ao PDF.",
    marginsTooBig: "As margens não cabem nesta folha: deixe pelo menos {min} de área de texto na largura e na altura.",
    bandFieldPlaceholderHeader: "Digite o cabeçalho…",
    bandFieldPlaceholderFooter: "Digite o rodapé…",
    bandFieldHint: "O que você vê aqui é o que sai na folha, no PDF e no Word. Clique na folha para voltar a este campo.",
    bandAlignLeft: "Alinhar à esquerda",
    bandAlignCenter: "Centralizar",
    bandAlignRight: "Alinhar à direita",
    bandImage: "Imagem",
    bandImageHeightTitle: "Altura da imagem",
    bandImageHeightField: "Altura em mm (de 5 a 60)",
    bandImageSmaller: "Menor",
    bandImageBigger: "Maior",
    bandImageRemove: "Remover imagem",
    bandImagesMax: "Máximo de {n} imagens por cabeçalho ou rodapé",
    bandImageNotAllowed: "Essa imagem não pode ser usada aqui: envie-a do seu computador.",
    bandPageNumber: "Número da página",
    bandColumns: "Colunas",
    bandColumns2: "2 colunas",
    bandColumns3: "3 colunas",
    bandColumnsRemove: "Remover colunas",
    bandColumnsOnlyOne: "Este cabeçalho ou rodapé já tem uma linha de colunas",
    bandLinesMax: "O cabeçalho ou rodapé já tem o máximo de linhas",
    bandNumberOff: "A numeração está desativada: este número não será impresso.",
    bandNumberInBand: "O número da página fica onde você o colocou no cabeçalho ou no rodapé.",
    bandNumberTwice: "Há número de página no cabeçalho e no rodapé.",
    bandEditorFailed: "O editor não carregou. Recarregue a página para editar; o que foi salvo não muda.",
    bandEditorRetry: "Tentar de novo",
    bandRichNotSaved: "O servidor ainda não aceita este cabeçalho ou rodapé: só o texto foi salvo. Salve de novo em alguns minutos.",
    bandDialogApply: "Aplicar",
    bandDialogCancel: "Cancelar",
    bandTooLong: "Este cabeçalho ou rodapé tem formatação demais: tire um pouco de negrito, itálico ou sublinhado.",
    bandImagesTooTall: "As imagens já ocupam a altura máxima ({mm} mm).",
    bandNumberNotAllPages: "O cabeçalho não sai em todas as folhas: o número da página também não.",
  },
  sidebar: {
    formatTemplates: 'Formatação',
    hubspot: 'HubSpot',
    payments: 'Pagamentos',
    aiCosts: 'Custos de IA',
    campaignCodes: 'Códigos',
    ambassadorApplications: 'Candidaturas de embaixadores',
    ambassadors: 'Embaixadores',
    applications: 'Candidaturas',
    invite: 'Convidar',
    ambassadorAccount: 'Conta de embaixador',
    adminAccount: 'Painel de administração',
    ambassadorHome: 'Início',
    ambassadorReferrals: 'Minhas indicações',
    ambassadorCommissions: 'Comissões',
    ambassadorNetwork: 'Minha rede',
    asistente: 'Assistente',
    overview: 'Visão Geral',
    accounts: 'Contas',
    users: 'Usuários',
    logs: 'Registros',
    waitlist: 'Waitlist',
    templates: 'Modelos',
    analytics: 'Análises',
    dashboard: 'Painel',
    orders: 'Pedidos',
    team: 'Equipe',
    credits: 'Créditos',
    certificate: 'Certificado',
    settings: 'Configurações',
    myTasks: 'Minhas Tarefas',
    myWorkspace: 'Meu Espaço',
    account: 'Conta',
    activity: 'Atividade',
    plans: 'Planos',
    features: 'Recursos',
    signOut: 'Sair',
    closeSidebar: 'Fechar barra lateral',
    openSidebar: 'Abrir barra lateral',
    accountMenu: 'Menu da conta',
    corpus: 'Glossário',
    myTerms: 'Meus Termos',
    companySettings: 'Empresa',
    companyDataDesc: 'Dados da empresa da conta',
    blog: 'Blog',
    landingPages: 'Landing Pages',
    navMenu: 'Menu de navegação',
    glossary: 'Glossários',
    siteCopy: 'Textos do site',
    seo: 'SEO',
    apiKeys: 'API Keys',
    support: 'Suporte',
    knowledge: 'Conhecimento',
    eventRegistrations: 'Sorteios / Eventos',
    content: 'Conteúdo',
    events: 'Eventos',
  },
  dashboard: {
    welcome: 'Bem-vindo de volta',
    subtitle: 'Veja o que está acontecendo com seus pedidos hoje.',
    newOrder: 'Novo Pedido',
    lowCredits: 'Créditos baixos: {n} restantes',
    creditsBalance: 'Saldo',
    ordersInProgress: 'Pedidos em andamento',
    completedOrders: 'Pedidos concluídos',
    teamMembers: 'Membros da equipe',
    available: 'Disponível',
    low: 'Baixo',
    active: 'Ativo',
    recentOrders: 'Pedidos Recentes',
    viewAll: 'Ver tudo',
    noOrdersYet: 'Nenhum pedido ainda',
    createFirstOrder: 'Crie seu primeiro pedido',
    quickActions: 'Ações Rápidas',
    uploadDocument: 'Enviar Documento',
    startNewTranslation: 'Iniciar uma nova tradução',
    buyCredits: 'Comprar Créditos',
    addToBalance: 'Adicionar ao seu saldo',
    inviteTeam: 'Convidar Equipe',
    addTeamMembers: 'Adicionar membros à equipe',
    companyOverview: 'Visão Geral da Empresa',
    thisMonth: 'Este mês',
    totalOrders: 'Total de pedidos',
    inProgress: 'Em andamento',
    completed: 'Concluídos',
    recentActivity: 'Atividade Recente',
    translation: 'Tradução',
    translationEdit: 'Edição de Tradução',
    lastActivity: 'Última atividade',
    noActivityYet: 'Sem atividade ainda',
    pages: 'Páginas',
    topLanguages: 'Idiomas Principais',
    creditActivity: 'Atividade de Créditos',
    document: 'Documento',
    languages: 'Idioma',
    date: 'Data',
    ordersCount: 'pedidos',
    archivedCount: '{n} arquivados',
    prev: 'Anterior',
    next: 'Próximo',
    noTransactions: 'Sem transações ainda',
    status: 'Status',
    ocrGenerated: 'OCR',
    ocrEdit: 'Edição OCR',
    download: 'Download',
    txTranslationCompleted: 'Pedido {order}: Tradução concluída ({pages} págs)',
    txCreditsPurchased: 'Créditos comprados',
    txCreditsRefunded: 'Créditos reembolsados',
    txCreditsAdjusted: 'Créditos ajustados',
    txAutoRecharge: 'Recarga automática',
    hideHeader: 'Ocultar cabeçalho',
  },
  statuses: {
    uploaded: 'Enviado',
    processing: 'Processando',
    ocrreview: 'Revisão OCR',
    translationreview: 'Revisão de Tradução',
    completed: 'Concluído',
    cancelled: 'Cancelado',
    unknown: 'Desconhecido',
  },
  notifications: {
    title: 'Notificações',
    markAllRead: 'Marcar tudo lido',
    noNotifications: 'Nenhuma notificação ainda',
    dismiss: 'Dispensar',
    close: 'Fechar',
    orderAssignedTitle: 'Novo pedido atribuído',
    orderAssignedMessage: '{by} atribuiu a você “{doc}”',
    orderCompletedTitle: 'Pedido concluído',
    orderCompletedMessage: '“{doc}” foi concluído',
    orderReassignedTitle: 'Pedido reatribuído',
    orderReassignedMessage: '“{doc}” foi reatribuído a {to}',
    projectCompletedTitle: 'Projeto concluído',
    projectCompletedMessage: '“{project}” está concluído. O download consolidado já está disponível.',
    finalizationRequestedTitle: 'Pedido aguardando finalização',
    finalizationRequestedMessage: '{by} pediu para finalizar “{doc}”',
    finalizationReturnedTitle: 'Pedido devolvido',
    finalizationReturnedMessage: '{by} devolveu “{doc}” para ajustes',
  },
  time: {
    justNow: 'Agora mesmo',
    minAgo: 'há {n} min',
    hourAgo: 'há {n} hora',
    hoursAgo: 'há {n} horas',
    yesterday: 'Ontem',
    daysAgo: 'há {n} dias',
    mAgo: 'há {n}m',
    hAgo: 'há {n}h',
    dAgo: 'há {n}d',
  },
  orders: {
    title: 'Pedidos',
    subtitle: 'Gerencie seus pedidos de tradução',
    newOrder: 'Novo Pedido',
    total: 'Total',
    uploaded: 'Enviados',
    inProgress: 'Em Andamento',
    completed: 'Concluídos',
    thisMonth: 'Este Mês',
    noOrdersFound: 'Nenhum pedido encontrado',
    tryAdjusting: 'Tente ajustar sua busca ou filtros',
    createFirst: 'Crie seu primeiro pedido de tradução para começar',
    order: 'Pedido',
    document: 'Documento',
    type: 'Tipo',
    pagesCol: 'Páginas',
    creditsCol: 'Créditos',
    qualityCol: 'Qualidade',
    languageCol: 'Idioma',
    status: 'Status',
    createdBy: 'Criado Por',
    assignedTo: 'Atribuído A',
    client: 'Cliente',
    date: 'Data',
    actions: 'Ações',
    showing: 'Mostrando',
    of: 'de',
    image: 'Imagem',
    text: 'Texto',
    handwritten: 'Manuscrito',
    modeTranslate: 'Tradução',
    modeLayout: 'Diagramação',
    searchPlaceholder: 'Buscar por nome do documento, criador, cliente ou número do pedido...',
    allStatus: 'Todos os Status',
    allTypes: 'Todos os Tipos',
    allDocTypes: 'Tipo de documento',
    allWorkTypes: 'Tipo de trabalho',
    view: 'Ver',
    clearDates: 'Limpar datas',
    verifiedBy: 'Verificado por',
    due: 'Prazo',
    open: 'Abrir',
    filterProjects: 'Projetos',
    filterSingle: 'Pedidos avulsos',
    archived: 'Arquivados',
    toSetUp: 'A configurar',
    cancelled: 'Cancelado',
    completedOf: '{pct}% concluído · {done} de {total}',
    moveToProject: 'Mover para um projeto…',
    removeFromProject: 'Remover do projeto',
    notAssigned: 'Não atribuído',
    trash: 'Lixeira',
    trashAction: 'Excluir',
    trashConfirmTitle: 'Mover para a lixeira?',
    trashConfirmMessage: 'Ele vai desaparecer das listas, do painel e dos projetos para toda a sua equipe. Você poderá restaurá-lo pela Lixeira durante 7 dias. Nenhum arquivo ou dado é excluído.',
    trashConfirmButton: 'Mover para a lixeira',
    restore: 'Restaurar',
    deletePermanently: 'Excluir permanentemente',
    deletePermanentlyConfirmTitle: 'Excluir permanentemente?',
    deletePermanentlyConfirmMessage: 'Ele deixará de estar disponível para toda a sua equipe, inclusive na Lixeira. Esta ação não pode ser desfeita.',
    emptyTrash: 'Esvaziar lixeira',
    emptyTrashConfirmTitle: 'Esvaziar a lixeira?',
    emptyTrashConfirmMessage: 'Todos os pedidos da lixeira serão excluídos permanentemente e deixarão de estar disponíveis para sua equipe. Esta ação não pode ser desfeita.',
    trashNotice: 'Os pedidos na lixeira são excluídos permanentemente após 7 dias.',
    trashEmpty: 'A lixeira está vazia',
    trashDaysLeft: 'Restam {days} d',
    trashActionFailed: 'Não foi possível concluir a ação. Tente novamente.',
    trashNoPermission: 'Você não tem permissão para excluir pedidos.',
    readOnlyNotice: 'Seu acesso é somente leitura: você pode ver seus pedidos e baixar o que já está pronto, mas não avançá-los nem alterá-los',
    readOnlyActionHint: 'Somente leitura: você não pode alterar este pedido',
    working: 'Processando...',
    purgedBadge: 'Dados excluídos',
    archiveAction: 'Arquivar',
    unarchiveAction: 'Desarquivar',
    archivedEmpty: 'Não há pedidos nem projetos arquivados',
    archiveFailed: 'Não foi possível arquivar o pedido. Tente novamente.',
    archivedBadge: 'Arquivado',
  },
  projects: {
    createOrder: 'Criar pedido',
    createOrderHint: 'Um documento',
    createProject: 'Criar projeto',
    createProjectHint: 'Vários documentos do mesmo caso',
    newProject: 'Novo projeto',
    name: 'Nome do projeto',
    namePlaceholder: 'ex. Caso Maria Roldan',
    client: 'Cliente',
    clientPlaceholder: 'Nome do cliente',
    reference: 'Reference #',
    referencePlaceholder: 'Seu próprio número',
    dueDate: 'Data de entrega',
    addNote: '+ Adicionar nota',
    notePlaceholder: 'Notas deste caso',
    defaults: 'Padrões para cada documento',
    task: 'O que você precisa?',
    translation: 'Tradução',
    layout: 'Diagramação',
    decidePerDocument: 'Decidir por documento',
    assignProject: 'Atribuir o projeto inteiro a',
    dropFiles: 'Solte arquivos aqui ou escolha arquivos',
    chooseFiles: 'Escolher arquivos',
    createCta: 'Criar projeto',
    creating: 'Criando…',
    pastDate: 'Esta data já passou.',
    afterProjectDue: 'Isto é depois da data do projeto ({date}).',
    prepTitle: 'Preparação',
    addDocuments: 'Adicionar documentos',
    addNDocuments: 'Adicionar {n} documentos',
    languages: 'Idiomas',
    assignTo: 'Atribuir a',
    apply: 'Aplicar',
    statusReady: 'Pronto',
    statusToSetUp: 'A configurar',
    createNOrders: 'Criar {n} pedidos',
    estimated: 'Estimado: {n} créditos',
    remainingPrep: '{n} documentos permanecerão em preparação',
    archive: 'Arquivar projeto',
    archiveConfirm: 'Arquivar este projeto? Você pode desarquivar depois.',
    unarchive: 'Desarquivar',
    downloadZip: 'Baixar tudo',
    setTaskToContinue: 'Defina a tarefa de cada documento para continuar',
    creditsForXN: 'Você tem créditos para {x} de {n} pedidos.',
    createX: 'Criar {x}',
    recharge: 'Adicionar créditos',
    position: '#',
    auto: 'Auto',
    removePrep: 'Remover este documento da preparação?',
  },
  teamPage: {
    title: 'Equipe',
    subtitle: 'Gerencie os membros da equipe e convites',
    inviteMember: 'Convidar Membro',
    teamMembers: 'Membros da Equipe',
    pendingInvites: 'Convites Pendentes',
    noMembers: 'Nenhum membro ainda. Convide alguém para começar.',
    owner: 'Proprietário',
    active: 'Ativo',
    inactive: 'Inativo',
    remove: 'Remover',
    joined: 'Entrou',
    pendingInvitations: 'Convites Pendentes',
    expires: 'Expira',
    sent: 'Enviado',
    link: 'Link',
    copied: 'Copiado',
    resend: 'Reenviar',
    cancel: 'Cancelar',
    teamRoles: 'Funções da Equipe',
    teamRolesDesc: 'Membros <strong>Team</strong> podem criar e gerenciar pedidos. <strong>Members</strong> podem trabalhar em pedidos atribuídos. Apenas proprietários podem convidar novos membros e gerenciar cobrança.',
    inviteTeamMember: 'Convidar Membro da Equipe',
    invitationSent: 'Convite Enviado',
    firstName: 'Nome',
    lastName: 'Sobrenome',
    emailAddress: 'Endereço de E-mail',
    sending: 'Enviando...',
    sendInvitation: 'Enviar Convite',
    invitationSentTo: 'Convite enviado para',
    inviteLink: 'Link do Convite',
    shareLinkDesc: 'Compartilhe este link com a pessoa para entrar na equipe.',
    done: 'Pronto',
    copy: 'Copiar',
    member: 'Membro',
    role: 'Função',
    status: 'Status',
    email: 'E-mail',
    removeTeamMember: 'Remover Membro da Equipe',
    removeConfirmMsg: 'Tem certeza que deseja remover <strong>{name}</strong> da equipe? Esta ação não pode ser desfeita. O membro perderá acesso a todos os recursos da equipe imediatamente.',
    removeMember: 'Remover Membro',
    thisMonth: 'Este Mês',
    roleOwner: 'Proprietário',
    roleManager: 'Gerente',
    roleReviewer: 'Revisor',
    roleMember: 'Membro',
    roleManagerDesc: 'Cuida do dia a dia da conta',
    roleReviewerDesc: 'Vê e aprova o trabalho da equipe',
    roleMemberDesc: 'Apenas seus documentos e os atribuídos',
    whatWillTheyDo: 'O que fará na conta?',
    permissionsHint: 'Permissões sobre TODA a conta, não apenas sobre o próprio trabalho: o que esta pessoa editar, toda a equipe verá. Só o que você ajustar é salvo.',
    whatThisAllows: 'O que esta permissão abrange',
    scopeDocsViewAll: 'Vê e atribui TODAS as ordens da empresa, não apenas as suas.',
    scopeDocsApprove: 'Aprova e finaliza os pedidos da conta, inclusive os que não fez. Sem esta permissão, o pedido é enviado para revisão e quem pode finalizá-lo é avisado.',
    scopeDocsDelete: 'Entra em qualquer ordem e exclui seus dados e arquivos; não são recuperáveis.',
    scopeCorpusEdit: 'O corpus e os glossários são da empresa: as mudanças afetam as traduções de toda a equipe.',
    scopeCertManage: 'Os modelos de certificado são da empresa: todos os membros os usam.',
    scopeBilling: 'Vê o saldo e COMPRA créditos com o meio de pagamento da empresa.',
    scopeTeam: 'Convida, ativa/desativa e edita outros membros da conta.',
    scopeAccountEdit: 'Altera os dados da empresa (nome, razão social, CNPJ, logo) para todos.',
    scopeLogs: 'Vê a atividade de TODOS os usuários da conta, não apenas a sua.',
    scopeDocsCreate: 'Cria novos pedidos na conta; ao processá-los, os créditos da empresa são gastos.',
    scopeCertAttach: 'Anexa o certificado de tradução da empresa ao documento final.',
    adjustedBadge: 'Ajustado',
    permDocsViewAll: 'Ver e atribuir todos os documentos',
    permDocsApprove: 'Aprovar e finalizar pedidos',
    permDocsDelete: 'Excluir documentos',
    permCorpusEdit: 'Editar corpus e glossários',
    permCertManage: 'Editar modelos de certificado',
    permBilling: 'Ver e comprar créditos',
    permTeam: 'Convidar e desativar membros',
    permAccountEdit: 'Editar dados da empresa',
    permLogs: 'Ver registro de atividades',
    permDocsCreate: 'Criar pedidos',
    permCertAttach: 'Adicionar certificado ao finalizar',
    readOnlyBadge: 'Somente leitura',
    adjustedOne: 'ajustado',
    adjustedMany: 'ajustados',
    permCountOne: 'permissão',
    permCountMany: 'permissões',
    edit: 'Editar',
    editMemberTitle: 'Editar membro',
    saveChanges: 'Salvar alterações',
    saving: 'Salvando...',
    readOnlyLabel: 'Somente leitura',
    readOnlyHint: 'Pode ver o trabalho da equipe, mas não alterá-lo.',
    firstNamePlaceholder: 'Ana',
    lastNamePlaceholder: 'Silva',
    emailPlaceholder: 'colega@empresa.com',
  },
  creditsPage: {
    title: 'Créditos',
    subtitle: 'Gerencie seus créditos e cobrança',
    availableBalance: 'Saldo Disponível',
    creditsInfo: 'créditos',
    usedThisMonth: 'Usados Este Mês',
    totalPurchased: 'Total Comprados',
    yourSubscription: 'Sua Assinatura',
    cancelSubscription: 'Cancelar Assinatura',
    currentPlan: 'Plano Atual',
    unknown: 'Desconhecido',
    subscriptionEnds: 'Assinatura Termina',
    nextBillingDate: 'Próxima Data de Cobrança',
    willNotRenew: 'Não será renovado',
    paymentMethod: 'Método de Pagamento',
    change: 'Alterar',
    card: 'Cartão',
    expiresDate: 'Expira',
    autoRenew: 'Renovação Automática',
    on: 'Ativado',
    off: 'Desativado',
    updating: 'Atualizando...',
    subscriptionEndingSoon: 'Assinatura terminando em breve',
    subscriptionEndingDesc: 'Sua assinatura terminará em {date}. Reative para manter seus benefícios.',
    reactivateNow: 'Reativar Agora',
    cancelSubscriptionQ: 'Cancelar Assinatura?',
    cancelSubscriptionDesc: 'Tem certeza que deseja cancelar sua assinatura <strong>{plan}</strong>? Você continuará tendo acesso até <strong>{date}</strong>.',
    keepSubscription: 'Manter Assinatura',
    yesCancel: 'Sim, Cancelar',
    changePlanQ: 'Mudar Plano?',
    newPlan: 'Novo Plano',
    changePlanDesc: 'Você paga o <strong>{new}</strong> hoje e os créditos entram no seu saldo no momento do pagamento, sem esperar a renovação. Seu plano atual <strong>{current}</strong> continua ativo até você pagar e é cancelado quando o pagamento é confirmado.',
    changePlan: 'Mudar Plano',
    alreadySubscribed: 'Já Assinado',
    alreadySubscribedDesc: 'Você já está inscrito no plano <strong>{plan}</strong>.',
    gotIt: 'Entendi',
    autoRechargeCredits: 'Recarga Automática de Créditos',
    whenBalanceBelow: 'Quando o Saldo Ficar Abaixo de',
    credits: 'créditos',
    rechargeAmount: 'Valor da Recarga',
    autoRecharge: 'Recarga Automática',
    willAdd: 'Adicionará <strong>{amount} créditos</strong> quando o saldo ficar abaixo de <strong>{threshold}</strong>',
    autoRechargeDisabled: 'Recarga automática está desativada',
    saveChanges: 'Salvar Alterações',
    saving: 'Salvando...',
    noPaymentMethod: 'Sem método de pagamento',
    addPaymentMethodFirst: 'Você precisa adicionar um método de pagamento primeiro. Faça uma compra ou assine um plano para habilitar a recarga automática.',
    addPaymentMethodForRenewal: 'Adicionar método de pagamento para renovar',
    addPaymentMethodTitle: 'Adicione um método de pagamento para renovar',
    addPaymentMethodForRenewalDesc:
      'Seu plano está ativo neste período. Adicione um cartão para que o próximo ciclo possa ser cobrado — você não será cobrado hoje.',
    pendingPaymentMethodStatus: 'Ativo — falta método de pagamento',
    nextBillingAfterPaymentMethod: 'Depois de adicionar um cartão',
    buyCreditPackages: 'Comprar Pacotes de Créditos',
    subscriptionRequiredToBuy: 'É necessária uma assinatura paga ativa para comprar créditos. Escolha um plano para liberar as compras.',
    noPackagesAvailable: 'Nenhum pacote de créditos disponível',
    mostPopular: 'Mais Popular',
    pricingFrom: 'A partir de',
    contactSalesPrice: 'Sob medida',
    buyNow: 'Comprar Agora',
    buyCustomAmount: 'Comprar Valor Personalizado',
    buyCustomDesc: 'Precisa de um valor específico? Digite quantos créditos você quer (1 crédito = $1 USD)',
    enterCreditsMin: 'Digite créditos (mín. 10)',
    subscriptionPlans: 'Planos de Assinatura',
    monthly: 'Mensal',
    yearly: 'Anual',
    saveUpTo: 'Economize até 20%',
    noPlansAvailable: 'Nenhum plano de assinatura disponível',
    year: 'ano',
    month: 'mês',
    orMonthly: 'ou ${price}/mês cobrado mensalmente',
    orYearly: 'ou ${price}/ano (economize {discount}%)',
    creditsIncluded: '{n} créditos',
    noCreditsIncluded: 'Sem créditos incluídos',
    imageBasedPages: 'Páginas Baseadas em Imagem',
    creditPerPage: '1 crédito / página',
    imageBasedDesc: 'Documentos digitalizados, imagens, PDFs que requerem OCR',
    textBasedPages: 'Páginas Baseadas em Texto',
    textBasedDesc: 'PDFs digitais e documentos com camadas de texto',
    transactionHistory: 'Histórico de Transações',
    noTransactions: 'Nenhuma transação ainda',
    noTransactionsFilter: 'Sem transações neste período',
    showLess: 'Ver menos',
    txFilterAll: 'Tudo',
    txFilterToday: 'Hoje',
    txFilterWeek: 'Esta Semana',
    txFilterMonth: 'Este Mês',
    exportCSV: 'Exportar CSV',
    txCount: 'transações',
    txNet: 'Líquido',
    purchased: 'Comprou {n} créditos',
    used: 'Usou {n} créditos',
    subscriptionHelp: 'Os planos de assinatura fornecem uma quantidade fixa de créditos mensal ou anualmente para processar seus documentos. Esses créditos são adicionados ao seu saldo no início de cada período de faturamento.',
    subscriptionHelpTitle: 'Sobre as Assinaturas',
    subscriptionHelpContent: 'Os planos de assinatura fornecem uma quantidade fixa de créditos que são adicionados ao seu saldo no início de cada período de faturamento (mensal ou anual). Esses créditos podem ser usados para processar documentos através de OCR, tradução e outros serviços.\n\nSua assinatura é renovada automaticamente em cada data de cobrança. Você pode cancelar a qualquer momento e manter o acesso até o final do período atual. Se precisar de mais créditos além do que seu plano inclui, você pode comprar pacotes adicionais ou ativar a recarga automática.',
    autoRechargeHelp: 'A recarga automática adiciona créditos ao seu saldo automaticamente quando ele fica abaixo de um limite definido, garantindo que você nunca fique sem créditos durante o processamento. Você pode personalizar o limite e o valor da recarga.',
    autoRechargeHelpTitle: 'Sobre a Recarga Automática',
    autoRechargeHelpContent: 'A recarga automática monitora seu saldo de créditos e compra créditos adicionais automaticamente quando ele cai abaixo do limite que você definiu. Isso garante o processamento ininterrupto de documentos sem intervenção manual.\n\nVocê escolhe dois valores: o saldo mínimo (quando recarregar) e o valor da recarga (quantos créditos adicionar). Seu método de pagamento salvo será cobrado automaticamente cada vez que uma recarga for acionada.',
    viewPlans: 'Ver Planos de Assinatura',
    close: 'Fechar',
    redeemCode: 'Código promocional',
    redeemPlaceholder: 'Insira seu código',
    redeemApply: 'Aplicar',
    redeemApplying: 'Aplicando…',
    redeemSuccess: 'Código aplicado',
    redeemError: 'Não foi possível aplicar o código',
    redeemHint: 'Um código de campanha por conta, para sempre. Resgate aqui extras de trial. Os benefícios de compra aplicam-se automaticamente no checkout.',
    redeemPreviewTrial: '{c} créditos de bônus',
    redeemPreviewDiscount: '{p}% de desconto no preço do plano no Stripe',
    redeemPreviewDiscountMonths: ' por {n} meses',
    redeemPreviewPurchase: 'x{x} créditos incluídos no plano',
    redeemApplied: 'Já resgataste {code}',
    redeemAppliedDiscount: 'O desconto de {p}% já está no preço dos planos.',
    redeemAppliedMultiplier: 'Vais receber x{x} créditos incluídos quando ativares um plano.',
    redeemAppliedPacks: 'pacotes de créditos',
    redeemAppliedPlans: 'planos {plans}',
    redeemAppliedNone: 'Já usaste o teu resgate. Os códigos são um benefício único por conta.',
    planCardCodeDiscount: 'Preço com o teu código {code}: {p}% de desconto',
    planCardCodeMultiplier: 'O teu código {code} multiplica os créditos do plano x{x}',
  },
  paywall: {
    teamTitle: 'Equipe está incluída no plano Team',
    teamMessage: 'Você precisa ativar um plano Team para convidar membros e gerenciar sua equipe.',
    corpusTitle: 'Os glossários estão incluídos no plano Team',
    corpusMessage: 'Você precisa ativar um plano Team para criar conjuntos de termos e usá-los nas traduções.',
    cta: 'Ativar um plano Team',
    openingCheckout: 'Abrindo o Stripe…',
  },
  planGate: {
    teamTitle: 'Ative um plano Team para usar Equipe',
    teamBody: 'O plano Grátis não inclui gestão de equipe. Escolha Team para convidar membros e colaborar.',
    activityTitle: 'Ative um plano Team para ver a atividade da equipe',
    activityBody: 'O plano Grátis não inclui o histórico de atividade da equipe. Ative Team para desbloquear.',
    activateTeamCta: 'Ativar plano Team',
    openingCheckout: 'Abrindo o Stripe…',
    memberTitle: 'Sua equipe precisa de um plano',
    memberBody: 'Esta conta está no plano Grátis. Peça ao administrador da equipe para adquirir um plano para você continuar trabalhando.',
  },
  settingsPage: {
    unsavedTitle: "Você tem alterações não salvas",
    unsavedMessage: "Se sair agora, as alterações desta tela serão perdidas.",
    unsavedSaveAndLeave: "Salvar e sair",
    unsavedLeave: "Sair sem salvar",
    unsavedStay: "Ficar aqui",
    personalInfo: 'Informações Pessoais',
    personalInfoDesc: 'Informações básicas da conta',
    whatsappAvailable: 'Disponível no WhatsApp',
    dateFormat: 'Formato de Data',
    dateFormatHint: 'Para a interface. As certificações usam o formato do país de destino.',
    markerStyleLabel: 'Notação de elementos visuais',
    seccionEmpresa: 'Empresa',
    correoEmpresa: 'E-mail da empresa',
    telefonoEmpresa: 'Telefone da empresa',
    seccionEmpresaDesc: 'Dados da empresa, compartilhados por toda a equipe',
    seccionPerfil: 'Perfil',
    seccionPerfilDesc: 'Seus dados pessoais e preferências',
    managedByAgency: 'Gerenciado pela sua agência',
    usarLaDeLaEmpresa: 'Usar o da empresa',
    perfilNoCargado: 'Não foi possível carregar seu perfil. Recarregue a página antes de salvar.',
    markerStyleHint: 'Estilo do delimitador para logos, selos e assinaturas nas suas traduções.',
    markerBrackets: 'Colchetes',
    markerBraces: 'Chaves',
    interfaceLanguage: 'Idioma da Interface',
    legalName: 'Razão Social',
    legalNamePlaceholder: 'Razão social para faturas',
    taxId: 'Identificação Fiscal',
    taxIdHint: 'Para faturas corporativas',
    website: 'Site',
    jobTitle: 'Seu cargo',
    jobTitlePlaceholder: 'CEO, Gerente de projetos...',
    linkedinCompanyPage: 'Página do LinkedIn da empresa',
    preferredContactMethod: 'Método de contato preferido',
    preferredContactNone: 'Sem preferência',
    preferredContactCall: 'Ligação',
    emailVerifyBannerTitle: 'Verifique seu endereço de e-mail',
    emailVerifyBannerDesc: 'Confirme que este é o seu e-mail:',
    emailVerifySendCode: 'Enviar código',
    emailVerifySending: 'Enviando…',
    emailVerifyCta: 'Verificar',
    emailVerifyVerifying: 'Verificando…',
    emailVerifyError: 'Não foi possível enviar o código. Tente novamente.',
    title: 'Configurações',
    subtitle: 'Gerencie sua conta e preferências',
    saveChanges: 'Salvar Alterações',
    saving: 'Salvando...',
    saved: 'Salvo!',
    profile: 'Perfil',
    firstName: 'Nome',
    lastName: 'Sobrenome',
    email: 'E-mail',
    accountSection: 'Conta',
    companyName: 'Nome da Empresa',
    changeLogo: 'Alterar Logo',
    uploadLogo: 'Enviar Logo',
    uploading: 'Enviando...',
    remove: 'Remover',
    notificationsSection: 'Notificações',
    orderStatusUpdates: 'Atualizações de status de pedidos',
    orderStatusUpdatesDesc: 'Receba notificações quando o status do pedido mudar',
    teamActivity: 'Atividade da equipe',
    teamActivityDesc: 'Notificações sobre ações dos membros da equipe',
    lowCreditAlerts: 'Alertas de créditos baixos',
    lowCreditAlertsDesc: 'Alerta quando os créditos ficarem abaixo de 50',
    marketingEmails: 'E-mails de marketing',
    marketingEmailsDesc: 'Dicas, atualizações e ofertas',
    timezone: 'Fuso Horário',
    timezoneDesc: 'Configure seu fuso horário para exibir datas e horas corretamente.',
    current: 'Atual',
    security: 'Segurança',
    changePassword: 'Alterar Senha',
    sessions: 'Sessões',
    activeSession: '1 sessão ativa',
    signOutAllDevices: 'Sair de todos os dispositivos',
    billing: 'Cobrança',
    currentPlan: 'Plano Atual',
    payAsYouGo: 'Pague conforme o uso',
    noPlanActive: 'Sem plano ativo',
    noPlanDesc: 'Contacte o administrador da sua empresa para acesso a um plano',
    noPlanDescFreelancer: 'Compre créditos para começar a traduzir',
    viewInvoices: 'Ver Faturas',
    changePasswordModal: 'Alterar Senha',
    changePasswordDesc: 'Digite sua senha atual e escolha uma nova.',
    currentPassword: 'Senha Atual',
    enterCurrentPassword: 'Digite a senha atual',
    newPassword: 'Nova Senha',
    minChars: 'Mín. 8 caracteres',
    confirmNewPassword: 'Confirmar Nova Senha',
    confirmYourPassword: 'Confirme sua senha',
    changingPassword: 'Alterando senha...',
    passwordChanged: 'Senha Alterada!',
    passwordChangedDesc: 'Sua senha foi alterada com sucesso.',
    done: 'Pronto',
    passwordsNoMatch: 'As senhas não coincidem',
    passwordMinLength: 'A senha deve ter pelo menos 8 caracteres',
    logoMaxSize: 'O logo deve ter menos de 5MB',
    logoFormatHint: 'JPG, PNG ou WEBP. Máx. 5MB.',
    helpTitle: 'Precisa de Ajuda?',
    helpDesc: 'Nossa equipe está aqui para ajudá-lo com qualquer dúvida.',
    helpEmail: 'Contatar Suporte',
    helpDocs: 'Documentação',
    privacyPolicy: 'Política de Privacidade',
    termsConditions: 'Termos e Condições',
    allRightsReserved: 'Todos os direitos reservados.',
    // Privacy & Data Retention
    privacyRetention: 'Privacidade e Retenção de Dados',
    privacyRetentionDesc: 'Configure a exclusão automática de dados de pedidos concluídos após um período de retenção.',
    retentionPolicy: 'Política de Retenção',
    retentionPolicyDesc: 'Pedidos concluídos serão automaticamente purgados após o período selecionado. Um certificado de exclusão assinado com KMS é gerado para cada purga.',
    retentionDisabled: 'Desativado',
    retentionDays: '{n} dias',
    retentionSaving: 'Salvando...',
    retentionSaved: 'Salvo!',
    retentionNone: 'Sem auto-exclusão',
    retentionDay: '{n} dia',
    retentionDaysLabel: '{n} dias',
    retentionWarning: 'Alterar a retenção irá reprogramar todos os temporizadores de purga pendentes para pedidos concluídos.',
    retentionImmediate: 'Imediato',
    retentionImmediateWarning: 'Quando um pedido é concluído, todos os seus dados e arquivos serão excluídos permanentemente de imediato. Um certificado de exclusão será gerado como comprovante.',
    retentionActive: 'Ativa',
    retentionInactive: 'Inativa',
    deletionCertificates: 'Certificados de Exclusão',
    deletionCertificatesDesc: 'Ver certificados assinados criptograficamente para pedidos purgados.',
    viewCertificates: 'Ver Certificados',
    noCertificates: 'Ainda não há certificados de exclusão.',
    downloadCertificate: 'Baixar PDF',
    previewCertificate: 'Visualizar',
    // Timezone picker
    searchCity: 'Buscar cidade...',
    noResults: 'Sem resultados',
    // Deletion certificate detail modal
    certDetail: {
      certificateOne: 'certificado',
      certificateMany: 'certificados',
      backToList: 'Voltar à lista',
      order: 'Pedido',
      document: 'Documento',
      account: 'Conta',
      deletedAt: 'Excluído em',
      method: 'Método',
      retention: 'Retenção',
      retentionDaysTpl: '{n} dias',
      integrity: 'Integridade',
      valid: 'Válido',
      invalid: 'Inválido',
      deletedFilesTpl: 'Arquivos excluídos ({n})',
      purgedFieldsTpl: 'Campos excluídos ({n})',
      prev: 'Anterior',
      next: 'Próximo',
    },
    professionalProfile: 'Perfil Profissional',
    professionalProfileDesc: 'Informações utilizadas em certificados e documentos oficiais',
    phone: 'Telefone',
    phonePlaceholder: '+1234567890',
    phoneHint: 'Formato internacional (E.164)',
    address: 'Endereço',
    addressPlaceholder: 'Cidade, Estado, País',
    association: 'Associação Profissional',
    associationNoneOption: 'Nenhuma',
    associationOther: 'Outra',
    associationCustomLabel: 'Nome da Associação',
    certificationNumber: 'Número de Certificação / Membro',
    languagePairs: 'Pares de Idiomas',
    languagePairsDesc: 'Idiomas de origem e destino que você traduz',
    addLanguagePair: 'Adicionar Par',
    sourceLanguage: 'Origem',
    targetLanguage: 'Destino',
    noLanguagePairs: 'Adicione pelo menos um par de idiomas',
    removePair: 'Remover',
    signatureImage: 'Imagem de Assinatura',
    signatureHint: 'JPG ou PNG. Máx 2MB.',
    signatureInvalidFormat: 'A assinatura deve ser JPG ou PNG',
    signatureMaxSize: 'A assinatura deve ter menos de 2MB',
    uploadSignature: 'Enviar Assinatura',
    changeSignature: 'Alterar',
    removeSignature: 'Remover',
    saveProfile: 'Salvar Perfil',
    adminAccount: 'Administrador da conta',
    adminAccountDesc: 'Dados de contato principais da conta',
    role: 'Função',
    subStatusActive: 'Ativa',
    subStatusTrialing: 'Em teste',
    subStatusPastDue: 'Pagamento em atraso',
    subStatusUnpaid: 'Não paga',
    subStatusCanceled: 'Cancelada',
    subStatusIncomplete: 'Incompleta',
    subStatusPaused: 'Pausada',
    searchCountry: 'Buscar país…',
    noCountriesFound: 'Nenhum país encontrado',
    companyWebsitePlaceholder: 'www.empresa.com',
    companyEmailPlaceholder: 'contato@empresa.com',
    personalWebsitePlaceholder: 'www.minhatraducao.com',
    linkedinProfilePlaceholder: 'seu-perfil',
  },
  certificatePage: {
    title: 'Certificado',
    subtitle: 'Este certificado é adicionado automaticamente como última página de cada PDF traduzido',
    uploadDocx: 'Enviar .docx',
    newTemplate: 'Novo Modelo',
    editingTemplate: 'Editando modelo de certificado',
    variables: 'Variáveis',
    saveAndClose: 'Salvar e Fechar',
    saving: 'Salvando...',
    insertVariable: 'Inserir variável:',
    dynamicVariables: 'Variáveis Dinâmicas',
    variablesDesc: 'Clique para copiar · São substituídas automaticamente no certificado final',
    clickToCopy: 'Clique em qualquer variável para copiar para a área de transferência',
    hideExamples: 'Ocultar exemplos',
    showExamples: 'Mostrar exemplos',
    defaultTemplates: 'Modelos Padrão',
    myTemplates: 'Meus Modelos',
    otherTemplates: 'Outros modelos',
    setActive: 'Definir Ativo',
    active: 'Ativo',
    global: 'Global',
    noTemplate: 'Sem modelo de certificado',
    noTemplateDesc: 'Crie um para adicioná-lo automaticamente aos seus PDFs traduzidos',
    createTemplate: 'Criar Modelo',
    uploadTemplate: 'Enviar Modelo',
    name: 'Nome',
    namePlaceholder: 'ex. Certificação de Exatidão',
    descriptionOptional: 'Descrição (opcional)',
    descriptionPlaceholder: 'Breve descrição deste modelo...',
    category: 'Categoria',
    general: 'Geral',
    legal: 'Jurídico',
    immigration: 'Imigração',
    academic: 'Acadêmico',
    cancel: 'Cancelar',
    creating: 'Criando...',
    createAndEdit: 'Criar e Editar',
    opening: 'Abrindo...',
    editTemplate: 'Editar Modelo',
    activateHint: 'Ative um modelo para adicioná-lo à sua coleção',
    templateLibrary: 'Biblioteca de Modelos',
    willBeAppended: 'Este certificado será anexado a todos os pedidos concluídos',
    language: 'Idioma',
    anyLanguage: 'Qualquer idioma',
    english: 'Inglês',
    spanish: 'Espanhol',
    portuguese: 'Português',
    german: 'Alemão',
    french: 'Francês',
    clickToRename: "Clique para renomear",
    activeTemplate: "Modelo ativo",
    copyHint: "Clique para copiar → Ctrl+V",
    copiedHint: "✓ Copiado! Agora pressione Ctrl+V (ou Cmd+V) para colar",
    copyVarTitle: "Clique para copiar → {desc}",
    view: "Ver",
    all: "Todos",
    close: "Fechar",
    deleteTemplate: "Excluir modelo",
  },
  orderDetail: {
    backToOrders: 'Voltar aos Pedidos',
    continueOrder: 'Continuar Pedido',
    error: 'Erro',
    orderNotFound: 'Pedido não encontrado',
    failedToLoad: 'Falha ao carregar o pedido',
    orderDetails: 'Detalhes do Pedido',
    documentType: 'Tipo de Documento',
    category: 'Categoria',
    sourceCountry: 'País de Origem',
    targetCountry: 'País de Destino',
    sourceLanguage: 'Idioma de Origem',
    targetLanguage: 'Idioma de Destino',
    totalPages: 'Total de Páginas',
    formatTemplate: 'Modelo de formato',
    noFormatTemplate: 'Original',
    credits: 'Créditos',
    consumed: 'consumidos',
    estimated: 'estimados',
    created: 'Criado',
    createdBy: 'Criado Por',
    assignedTo: 'Atribuído A',
    completed: 'Concluído',
    exportFormat: 'Formato de Exportação',
    originalFile: 'Arquivo Original',
    view: 'Ver',
    openInNewTab: 'Abrir em nova aba',
    download: 'Baixar',
    close: 'Fechar',
    accessDenied: 'Acesso Negado',
    adminNoAccess: 'Os administradores da plataforma não podem visualizar o conteúdo dos documentos por segurança e privacidade. Apenas proprietários, membros e freelancers podem acessar documentos.',
    translatedDocument: 'Documento Traduzido',
    finalDocument: 'Documento Diagramado',
    deletionCertificate: 'Certificado de Exclusão',
    translationCertificate: 'Certificado de Tradução',
    fileDeleted: 'Este arquivo foi excluído',
    sizeUnknown: 'Tamanho desconhecido',
    uploadAndDetails: 'Envio e Detalhes',
    ocr: 'OCR',
    review: 'Revisão',
    final: 'Final',
    deleteData: 'Excluir Dados',
    deleteOrderData: 'Excluir Dados do Pedido',
    deleteOrderDesc: 'Isso excluirá permanentemente todos os arquivos (enviados e concluídos) de:',
    deleteOrderPreserved: 'O registro do pedido e o certificado de exclusão serão preservados. Esta ação não pode ser desfeita.',
    cancel: 'Cancelar',
    dataDeletedSuccess: 'Dados excluídos com sucesso',
    dataDeletedFailed: 'Falha ao excluir dados',
    certificateLabel: 'Certificado',
    // Human verification
    humanVerified: 'Verificado por Humano',
    verify: 'Verificar tradução',
    verifyConfirmTitle: 'Verificar tradução',
    verifyConfirmDesc: 'Você está certificando que esta tradução foi revisada e aprovada por um tradutor humano. Esta ação adicionará um selo de verificação ao documento.',
    verifyNotes: 'Notas (opcional)',
    verifySuccess: 'Tradução verificada com sucesso',
    verifyFailed: 'Falha ao verificar a tradução',
    verifiedBy: 'Verificado por',
    verifiedOn: 'Verificado em',
    viewVerification: 'Ver verificação pública',
    // Data purged / deletion box
    dataPurged: 'Dados Excluídos',
    loadingCertificate: 'Carregando certificado...',
    allDataDeleted: 'Todos os arquivos e dados sensíveis foram excluídos permanentemente.',
    filesDeletedTpl: '{n} arquivos excluídos',
    autoPurgeNoticeTpl: 'Exclusão automática ativada — Os arquivos serão excluídos automaticamente {time} após a conclusão',
    retentionMin: 'min',
    retentionHour: 'hora',
    retentionHours: 'horas',
    retentionDay: 'dia',
    retentionDays: 'dias',
    inTrashBanner: 'Este pedido está na lixeira. Será excluído permanentemente em {date}.',
    restoreOrder: 'Restaurar pedido',
    readOnlyNotice: 'Seu acesso é somente leitura: você pode ver o pedido, mas não avançá-lo',
    finalizationPendingApprover: '{name} pediu para finalizar este pedido em {date}.',
    reviewAndFinalize: 'Revisar e finalizar',
    returnToRequester: 'Devolver',
    returnNotePlaceholder: 'O que precisa ser corrigido (opcional)',
    returnConfirm: 'Devolver pedido',
    returnFailed: 'Não conseguimos devolver o pedido. Tente novamente.',
    finalizationPendingRequester: 'Enviado para revisão em {date}. Quem pode finalizá-lo já foi avisado.',
    finalizationReturned: '{name} devolveu o pedido em {date}.',
    finalizationReturnedNote: 'Observação: “{note}”',
    someoneFromTeam: 'Alguém da equipe',
    // Localized document type & category labels
    documentTypes: { image: 'Imagem', text: 'Texto', handwritten: 'Manuscrito' },
    categories: {
      birth_certificate: 'Certidão de Nascimento',
      certificate: 'Certificado',
      diploma: 'Diploma',
      passport: 'Passaporte',
      marriage_license: 'Certidão de Casamento',
      medical: 'Registro Médico',
      legal: 'Documento Jurídico',
      immigration: 'Formulário de Imigração',
      other: 'Outro',
      academic_transcript: 'Histórico Escolar',
      civil_registry: 'Registro Civil',
      death_certificate: 'Certidão de Óbito',
      power_of_attorney: 'Procuração',
      general: 'Geral',
    },
  },
  workspace: {
    title: 'Meu Espaço',
    welcomeBack: 'Bem-vindo de volta, {name}. Você tem {n} tarefas atribuídas.',
    welcomeBackOne: 'Bem-vindo de volta, {name}. Você tem {n} tarefa atribuída.',
    welcomeBackOther: 'Bem-vindo de volta, {name}. Você tem {n} tarefas atribuídas.',
    assigned: 'Atribuído',
    tasksToComplete: 'Tarefas para completar',
    active: 'Ativo',
    inProgress: 'Em andamento',
    completed: 'Concluídas',
    thisMonth: 'Este mês',
    pendingTasks: 'Tarefas Pendentes',
    pendingTasksDesc: 'Pedidos pendentes de sua revisão e processamento',
    noOrdersAssigned: 'Nenhum pedido atribuído a você ainda',
    ordersWillAppear: 'Os pedidos aparecerão aqui quando forem atribuídos a você.',
    page: 'página',
    pages: 'páginas',
    workflowTip: 'Dica de Fluxo',
    workflowTipDesc: 'Cada pedido segue um fluxo: <strong>Envio → Revisão OCR → Tradução → Concluir</strong>. Você deve verificar e aprovar cada etapa antes de prosseguir para a próxima.',
    startOrder: 'Iniciar Pedido',
    continueAction: 'Continuar',
    reviewAction: 'Revisar',
    viewAction: 'Ver',
    myOrders: 'Meus Pedidos',
    myOrdersSubtitle: 'Todos os pedidos atribuídos a você',
    searchPlaceholder: 'Buscar pedidos...',
    totalAssigned: 'Total Atribuídos',
    noOrdersFound: 'Nenhum pedido encontrado',
    ordersAssignedAppear: 'Os pedidos atribuídos aparecerão aqui.',
    document: 'Documento',
    pagesCol: 'Páginas',
    languages: 'Idiomas',
    status: 'Status',
    createdCol: 'Criado',
    action: 'Ação',
    pageOf: 'Página {p} de {total}',
    orders: 'pedidos',
    creditPackages: 'Pacotes de Créditos',
    purchaseCreditsDesc: 'Compre créditos para processar seus documentos',
    viewAll: 'Ver Tudo',
    uploadPhoto: 'Enviar Foto',
    managePreferences: 'Gerencie suas preferências de conta',
    notifications: 'Notificações',
    newTaskAssignments: 'Novas atribuições de tarefas',
    newTaskAssignmentsDesc: 'Receba notificações quando uma nova tarefa for atribuída a você',
    taskDeadlines: 'Prazos de tarefas',
    taskDeadlinesDesc: 'Lembretes de prazos próximos',
    commentsAndFeedback: 'Comentários e feedback',
    commentsAndFeedbackDesc: 'Notificações quando alguém comentar no seu trabalho',
    dailySummary: 'Resumo diário',
    dailySummaryDesc: 'Receba um resumo diário de suas tarefas',
    account: 'Conta',
    organization: 'Organização',
    role: 'Função',
    yourStats: 'Suas Estatísticas',
    tasksCompleted: 'Tarefas Concluídas',
    pagesTranslated: 'Páginas Traduzidas',
    avgQualityScore: 'Pontuação Média',
    loadError: 'Não foi possível carregar seus pedidos. Tente novamente em alguns segundos.',
  },
  newOrder: {
    loadingOrder: 'Carregando pedido...',
    restoreProgress: 'Por favor aguarde enquanto restauramos seu progresso',
    stepProgress: 'Etapa {step} de {total}',
    stepUploadDetails: 'Envio e Detalhes',
    stepProcessing: 'Processamento',
    stepReview: 'Revisão',
    stepTranslation: 'Tradução',
    stepDownload: 'Baixar',
    modeLabel: 'Modo',
    modeTranslate: 'Traduzir',
    modeLayout: 'Diagramar',
    modeTranslateHint: 'Traduz o documento para outro idioma, com certificação.',
    modeLayoutHint: 'Apenas diagramação: reconstrói o documento no idioma original, sem traduzir.',
    layoutReadyTitle: 'Documento pronto',
    layoutReadyDesc: 'Seu documento diagramado está pronto para baixar no idioma original.',
    downloadDocument: 'Baixar documento',
    preparingDownload: 'Preparando…',
    error: 'Erro',
    uploadDocument: 'Enviar Documento',
    acceptedFileTypes: 'PDF, Word (DOC, DOCX), JPG, PNG, TIFF, WebP',
    analyzingDocument: 'Analisando documento...',
    classifyingDocument: 'Classificando documento...',
    loadingPreview: 'Carregando pré-visualização...',
    fileTypePdf: 'PDF',
    fileTypeWord: 'Word',
    docxTooLargeToCount: 'Muito grande para contar páginas — verifique',
    fileTypeImage: 'Imagem',
    page: 'página',
    pages: 'páginas',
    hasText: 'Tem texto',
    scanned: 'Digitalizado',
    fileAnalysis: 'Análise do Arquivo',
    complete: 'Completa',
    textLabel: 'Texto:',
    selectable: 'Selecionável',
    methodLabel: 'Método:',
    ocrMethod: 'OCR (1 cr/pág)',
    directMethod: 'Direto (1 cr/pág)',
    paperLetter: "Carta",
    paperA4: "A4",
    paperLegal: "Ofício",
    paperPortrait: "vertical",
    paperLandscape: "horizontal",
    handwritten: 'Manuscrito',
    mixedContent: 'Misto (impresso + manuscrito)',
    disableHandwritten: 'Clique para processar como imagem digitalizada',
    enableHandwritten: 'Clique para restaurar modo manuscrito',
    manuscriptSuggestionTitle: 'Isto parece uma imagem digitalizada',
    manuscriptSuggestionBody: 'Para o resultado mais limpo, use o Modo Manuscrito. Ele transforma o seu documento em texto claro e editável, com um layout fiel ao original. Se pular esta etapa, o texto é colocado sobre a imagem digitalizada, fica com uma aparência menos cuidada e mais difícil de editar.',
    manuscriptSuggestionConfirm: 'Usar o Modo Manuscrito',
    manuscriptSuggestionDismiss: 'Continuar sem usar',
    manuscriptSuggestionBadge: 'Recomendado',
    pageFormat: 'Formato do papel',
    pageFormatLetter: 'Carta',
    pageFormatLegal: 'Ofício',
    orientationLabel: 'Orientação',
    orientationPortrait: 'Vertical',
    orientationLandscape: 'Horizontal',
    orientationSuggested: 'sugerida',
    readAloud: 'Ler',
    stopReading: 'Parar',
    loadingAudio: 'Carregando...',
    viewTranscript: 'Ver transcrição',
    transcriptTitle: 'Texto transcrito',
    copyText: 'Copiar',
    transcribingHandwriting: 'Transcrevendo texto manuscrito...',
    readingHandwriting: 'Lendo texto manuscrito com IA...',
    processingPages: 'Processando páginas...',
    generatingDocument: 'Gerando documento...',
    clientName: 'Nome do Cliente',
    clientNamePlaceholder: 'ex., João Silva',
    reference: 'Reference #',
    dueDate: 'Data de entrega',
    addInstructions: '+ Adicionar instruções',
    detailsSection: 'Detalhes',
    languagesSection: 'Idiomas e localização',
    teamSection: 'Equipe',
    documentName: 'Nome do Documento',
    documentNamePlaceholder: 'ex., Certidão de Nascimento - Garcia',
    documentCategory: 'Categoria do Documento',
    sourceCountry: 'País de Origem',
    targetCountry: 'País de Destino',
    sourceLanguage: 'Idioma de Origem',
    targetLanguage: 'Idioma de Destino',
    chooseTargetLanguage: 'Escolher idioma',
    targetLanguageRequired: 'Escolha o idioma de destino para continuar',
    searchLanguage: 'Buscar idioma…',
    searchCountry: 'Buscar país…',
    noSearchResults: 'Sem resultados',
    sameLanguageBlocked: 'O idioma de destino é o mesmo do idioma de origem, então não há nada para traduzir. Verifique o idioma de destino do pedido.',
    autoDeleteLabel: 'Excluir arquivos automaticamente após',
    autoDeleteAccountDefault: 'Usar padrão da conta',
    autoDeleteImmediate: 'Imediato',
    autoDelete20min: '20 minutos',
    autoDelete1h: '1 hora',
    autoDelete6h: '6 horas',
    autoDelete1d: '1 dia',
    autoDelete7d: '7 dias',
    autoDelete30d: '30 dias',
    autoDelete90d: '90 dias',
    estimatedCredits: 'Créditos Estimados',
    creditCalculation: '1 crédito por página × {pages}',
    assignToTeamMember: 'Atribuir a Membro da Equipe',
    notAssigned: 'Não atribuído',
    notesInstructions: 'Notas / Instruções',
    teamNotesPlaceholder: 'Adicionar instruções para o membro da equipe atribuído...',
    assigning: 'Atribuindo...',
    analyzing: 'Analisando...',
    assignNotify: 'Atribuir e Notificar',
    questionOnPage: 'Folha',
    questionNoPosition: 'não localizado',
    fileTooLargeDetail: 'O documento tem {size} e o máximo é {max}. Divida-o em partes ou use uma versão mais leve e tente novamente.',
    unsupportedFileDetail: 'Formatos aceitos: PDF, Word (.doc, .docx) e imagens (JPG, PNG, TIFF, WEBP).',
    uploadingOriginal: 'Enviando o documento…',
    uploadFailedMessage: 'O pedido foi criado e atribuído, mas o documento não pôde ser enviado. Tente novamente; se continuar falhando, verifique sua conexão.',
    retryUpload: 'Tentar enviar novamente',
    originalUploadFailed: 'Não foi possível enviar o arquivo. Verifique sua conexão e tente novamente.',
    originalIncomplete: 'O arquivo não chegou completo. Envie-o novamente.',
    originalMissingTitle: 'Escolha o arquivo novamente',
    originalMissingMessage: 'Não encontramos o arquivo deste pedido. Escolha novamente «{name}» ({size}) para continuar; o resto do que você escolheu é mantido.',
    originalMissingShort: 'Este pedido não tem o seu arquivo. Escolha-o novamente para continuar.',
    originalDamaged: 'Não conseguimos ler o arquivo: parece danificado ou protegido por senha. Salve-o novamente sem senha e envie-o de novo.',
    originalDifferentFile: 'Esse não é o arquivo deste pedido, então um novo pedido é iniciado com ele.',
    originalCopyPendingTitle: 'Cópia do original pendente',
    originalCopyPending: 'Não conseguimos salvar uma cópia do original; seguimos com o seu documento e tentaremos salvá-la novamente.',
    startOrder: 'Iniciar Pedido',
    analyzeContinue: 'Analisar e Continuar',
    documentPreview: 'Pré-visualização do Documento',
    wordDocument: 'Documento Word',
    contentPreview: 'Pré-visualização do conteúdo:',
    noPreviewAvailable: 'Sem pré-visualização disponível',
    processing: 'Processando...',
    resumingProcessing: 'Retomando processamento...',
    convertingDocument: 'Convertendo documento...',
    generatingPreview: 'Gerando pré-visualização...',
    editDocument: 'Editar Documento',
    viewOriginal: 'Ver Original',
    saving: 'Salvando...',
    backToReview: 'Voltar à Revisão',
    originalDocument: 'Documento Original',
    back: 'Voltar',
    exitOrderTitle: 'Sair do pedido?',
    exitOrderMessage: 'Você voltará à lista de pedidos. Seu progresso fica salvo — você pode retomar este pedido a qualquer momento.',
    exitOrderConfirm: 'Sim, sair',
    exitOrderCancel: 'Continuar com o pedido',
    documentReview: 'Revisão do Documento',
    of: 'de',
    stopAutoscroll: 'Parar rolagem automática',
    autoscroll: 'Rolagem automática',
    translating: 'Traduzindo...',
    loadingOriginal: 'Carregando original...',
    loadingShort: 'Carregando...',
    downloadDocx: 'Baixar DOCX',
    closeOrderTitle: 'Concluir a ordem?',
    closeOrderDesc: 'Você já baixou o documento diagramado. Pode dar a ordem por concluída aqui mesmo, sem passar para a tradução, para que não fique aberta.',
    closeOrderYes: 'Concluir ordem',
    closeOrderNo: 'Continuar na ordem',
    closeOrderFailed: 'Não foi possível concluir a ordem. Tente novamente.',
    closeOrderSaving: 'Salvando o documento…',
    reflowPagesBtn: 'Reorganizar páginas',
    reflowPagesError: 'Não foi possível reorganizar as páginas. Tente novamente.',
    rotatePage: "Girar documento",
    prevPage: "Página anterior",
    nextPage: "Próxima página",
    dropHere: "Arraste e solte seu documento aqui",
    clickBrowse: "ou clique para procurar no seu computador",
    selectFile: "Selecionar arquivo",
    supportedLabel: "Compatíveis",
    progressMessages: {
      "Converting PDF to editable format...": "Convertendo o PDF para formato edit\u00e1vel\u2026",
      "Creating order...": "Criando o pedido\u2026",
      "Loading manuscript...": "Carregando o manuscrito\u2026",
      "Loading order...": "Carregando o pedido\u2026",
      "Loading preview...": "Carregando a pr\u00e9-visualiza\u00e7\u00e3o\u2026",
      "Resuming processing...": "Retomando o processamento\u2026",
      "Generating preview...": "Gerando a pr\u00e9-visualiza\u00e7\u00e3o\u2026",
      "Converting document...": "Convertendo o documento\u2026",
      "Preparing document...": "Preparando o documento\u2026",
      "Converting document to base64...": "Preparando o arquivo\u2026",
      "Applying crop...": "Aplicando o recorte\u2026",
      "Saving order details...": "Salvando os detalhes\u2026",
      "Uploading file to cloud storage...": "Enviando o arquivo\u2026",
      "Analyzing document structure...": "Analisando a estrutura\u2026",
      "Complete! Loading results...": "Pronto! Carregando resultados\u2026",
      "Finalizing...": "Finalizando\u2026",
      "Almost ready...": "Quase pronto\u2026",
      "Exporting images and formats...": "Exportando imagens e formatos\u2026",
      "Analyzing document...": "Analisando o documento\u2026",
      "OCR complete! Deducting credits...": "OCR conclu\u00eddo, descontando cr\u00e9ditos\u2026",
      "Processing complete! Loading results...": "Processamento conclu\u00eddo, carregando\u2026",
      "Extracting text and formatting...": "Extraindo texto e formata\u00e7\u00e3o\u2026",
      "Detecting document styles...": "Detectando os estilos\u2026",
      "Analyzing paragraphs...": "Analisando par\u00e1grafos\u2026",
      "Merging text blocks...": "Unindo blocos de texto\u2026",
      "Optimizing layout...": "Otimizando o layout\u2026",
      "Finalizing document structure...": "Finalizando a estrutura\u2026",
      "OCR complete, assembling result...": "OCR conclu\u00eddo, montando o resultado\u2026",
      "Deducting credits, almost ready...": "Descontando cr\u00e9ditos, quase pronto\u2026",
      "Converting to editable format...": "Convertendo para formato edit\u00e1vel\u2026",
      "Processing document layout...": "Processando o layout do documento\u2026",
      "Running OCR engines...": "Executando os mecanismos de OCR\u2026",
      "Running text extraction...": "Extraindo o texto\u2026",
      "Processing with OCR engines...": "Processando com os mecanismos de OCR\u2026",
      "Detecting text styles...": "Detectando os estilos do texto\u2026",
      "Finalizing results...": "Finalizando os resultados\u2026",
    } as Record<string, string>,
    zoomIn: 'Ampliar',
    zoomOut: 'Reduzir',
    fitToWidth: 'Ajustar à largura',
    pdfPreviewError: 'Não foi possível carregar a visualização do PDF',
    continueToTranslation: 'Continuar para Tradução',
    panelOriginal: 'ORIGINAL',
    panelPreview: 'PRÉ-VISUALIZAÇÃO',
    edit: 'Editar',
    previewNotAvailable: 'Pré-visualização não disponível',
    ocrResultsComparison: 'Resultados OCR - Comparação Visual',
    textBlocksDetected: 'blocos de texto detectados',
    accuracy: 'precisão',
    backToComparison: 'Voltar à Comparação',
    editTranslation: 'Editar Tradução',
    translation: 'Tradução',
    panelTranslation: 'TRADUÇÃO',
    updatingPreview: 'Atualizando pré-visualização...',
    translationPreviewNotAvailable: 'Pré-visualização da tradução não disponível',
    finishOrder: 'Finalizar Pedido',
    orderCompleted: 'Pedido Concluído!',
    orderDownloaded: 'Seu documento traduzido foi baixado.',
    orderDownloadedLayout: 'Seu documento diagramado foi baixado.',
    redirecting: 'Redirecionando...',
    finishOrderDesc: 'Baixar e concluir esta tradução',
    finishOrderDescLayout: 'Baixar seu documento diagramado',
    document: 'Documento',
    exportFormat: 'Formato de exportação',
    formatPdf: 'PDF',
    formatOdt: 'ODT (texto editável)',
    translationLabel: 'Tradução',
    autoLanguage: 'Auto',
    creditsToCharge: 'Créditos a cobrar',
    creditsCharged: 'Créditos utilizados',
    currentBalanceLabel: 'Saldo atual: {balance} créditos. Debitados ao iniciar a revisão de OCR.',
    credits: 'créditos',
    creditBalance: 'Seu saldo: {balance} créditos. Após conclusão: {remaining} créditos.',
    cancel: 'Cancelar',
    downloadComplete: 'Baixar e Concluir',
    insufficientCredits: 'Créditos Insuficientes',
    insufficientCreditsDesc: 'Este pedido precisa de {required} créditos e você tem atualmente {available}. Para concluí-lo, compre mais créditos ou faça upgrade do seu plano.',
    insufficientCreditsDescOne: 'Este pedido precisa de {required} crédito e você tem atualmente {available}. Para concluí-lo, compre mais créditos ou faça upgrade do seu plano.',
    creditsNeeded: 'Créditos necessários:',
    yourBalance: 'Seu saldo:',
    shortfall: 'Faltam:',
    buyCredits: 'Comprar Créditos',
    upgradePlan: 'Atualizar Plano',
    bestValue: 'Melhor opção',
    contactOwner: 'Entre em contato com o proprietário da conta para adicionar mais créditos.',
    preparingTexts: 'Preparando textos para tradução...',
    translatingBlocks: 'Traduzindo {count} blocos...',
    translatingBlocksOne: 'Traduzindo {count} bloco...',
    applyingTranslations: 'Aplicando traduções...',
    includeCertificate: 'Incluir Certificado',
    savingDocument: 'Salvando documento...',
    autosavePending: 'Alterações não salvas',
    autosaveSaving: 'Salvando…',
    autosaveSaved: 'Salvo',
    autosaveError: 'Não foi possível salvar, tentando de novo',
    translatingProgress: 'Traduzindo... ({completed}/{total})',
    generatingTranslatedPreview: 'Gerando pré-visualização...',
    finalizingTranslation: 'Finalizando...',
    translationFailed: 'Não foi possível traduzir o documento. Tente novamente em alguns minutos.',
    wordSinTexto: 'Este Word não tem texto editável (desenho ou fontes sem mapa de caracteres): use a Opção 2.',
    translationPartialTitle: 'Algumas opções não foram traduzidas',
    translationPartialMessage: 'Mostramos as opções que foram traduzidas.',
    yes: 'Sim',
    no: 'Não',
    protectPdf: 'Assinatura digital e proteção',
    protectPdfHint: 'Desative se for assinar com seu próprio token',
    outputOptions: 'Opções de saída',
    certificateTemplate: 'Certificado',
    selectTemplate: 'Selecionar modelo',
    noTemplates: 'Nenhum modelo nesta categoria',
    addTemplate: 'Gerenciar modelos',
    humanVerifiedSeal: 'Selo Human Verified',
    attachOriginal: 'Anexar documento original',
    attachOriginalHint: 'Anexa o arquivo enviado no início ou no final da tradução',
    attachOriginalPosition: 'Posição do original',
    attachOriginalAtStart: 'No início',
    attachOriginalAtEnd: 'No final',
    downloadPdf: 'Baixar PDF',
    downloadDoc: 'Baixar DOC',
    reviewDocument: 'Revisar Documento',
    chooseFormat: 'Escolha o formato',
    optionWord: 'Opção 1',
    optionHtml: 'Opção 2',
    optionMix: 'Opção 3',
    optionFormat: 'Opção 4',
    optionFormatHint: 'Opção 2 com o modelo de formato do pedido',
    optionFormatImages: 'imagens',
    docHeaderLabel: 'CABEÇALHO DO DOCUMENTO — será repetido em todas as páginas do Word/PDF',
    docFooterLabel: 'RODAPÉ DO DOCUMENTO — será repetido em todas as páginas do Word/PDF',
    panelTranscription: 'TRANSCRIÇÃO',
    hideEditorToolbar: 'Ocultar barra de edição',
    showEditorToolbar: 'Mostrar barra de edição',
    verifyDocumentTitle: 'Verificar documento',
    verifyDocumentDesc: 'Revise o documento original à esquerda e confirme os campos à direita',
    verificationLabel: 'Verificação',
    correctionPlaceholder: 'Digite a correção aqui...',
    detectedLabel: 'Detectado',
    hidePin: 'Ocultar marcador no documento',
    showPin: 'Mostrar marcador no documento',
    editedIndicator: 'Editado',
    skip: 'Pular',
    confirm: 'Confirmar',
    localizationNoticeTitle: 'Adaptar datas e números ao país de destino',
    localizationNoticeIntro: 'País de destino: {country}. Lá as datas e os números seguem outra convenção; podemos ajustá-los para que a leitura seja natural.',
    localizationNoticeSummaryTpl: 'Encontramos {items}.',
    localizationNoticeSummaryAnd: 'e',
    localizationNoticeDatesOne: '1 data',
    localizationNoticeDatesMany: '{n} datas',
    localizationNoticeFiguresOne: '1 número',
    localizationNoticeFiguresMany: '{n} números',
    localizationNoticeExamplesTitle: 'Como ficariam',
    localizationNoticeChecking: 'Verificando o documento…',
    localizationNoticeMoreTpl: 'e mais {n} ocorrências',
    localizationNoticeTimesMany: '{n} vezes',
    localizationNoticeTypeDate: 'Data',
    localizationNoticeTypeFigure: 'Número',
    localizationNoticeSafeTitle: 'Nada disso é alterado:',
    localizationNoticeSafeBody: 'os números de documento de identidade, de lei, de processo e de telefone são copiados dígito a dígito, exatamente como no original.',
    localizationNoticeAdapt: 'Adaptar',
    localizationNoticeKeep: 'Manter como no original',
    localizationNoticeRemember: 'Não perguntar novamente nesta conta',
    localizationNoticeRememberHint: 'Sua escolha passa a ser o padrão da conta.',
    localizationNoticeClose: 'Fechar',
    localizationNoticeIdsLabel: 'Identificações',
    localizationNoticeIdsOne: '1 identificação',
    localizationNoticeIdsMany: '{n} identificações',
    localizationNoticeIdsUnchanged: 'Sem alteração',
    localizationNoticeShowExamples: 'Ver exemplos',
    localizationNoticeHideExamples: 'Ocultar exemplos',
    noCreatePermissionTitle: 'Você não pode criar pedidos',
    noCreatePermissionDesc: 'Sua função nesta conta não inclui a permissão “Criar pedidos”. Peça ao proprietário ou a um gerente para ativá-la. Você pode continuar trabalhando nos pedidos atribuídos a você.',
    goToMyOrders: 'Ir para meus pedidos',
    finishNoPermissionTitle: 'Você não tem permissão para finalizar',
    finishNoPermissionDesc: 'Enviar para revisão? Avisaremos o proprietário e quem pode finalizar pedidos para que o revisem e o concluam.',
    finishReadOnlyDesc: 'Seu acesso a esta conta é somente leitura: você pode ver o pedido, mas não finalizá-lo nem enviá-lo para revisão.',
    sendForReview: 'Enviar para revisão',
    sendingForReview: 'Enviando…',
    reviewRequestSent: 'Pedido enviado para revisão. Quem pode finalizá-lo já foi avisado.',
    reviewRequestSentNoNotice: 'Pedido enviado para revisão. Não conseguimos enviar os avisos agora; quem pode finalizá-lo verá ao abrir o pedido.',
    reviewAlreadyPending: 'Este pedido aguarda revisão desde {date}.',
    reviewRequestFailed: 'Não conseguimos enviar o pedido para revisão. Tente novamente.',
    certificateNoPermission: 'Sua função não inclui a permissão “Adicionar certificado ao finalizar”.',
  },
  certVars: {
    translatorName: 'Nome do Tradutor',
    translatorNameDesc: 'Nome completo do tradutor/pessoa atribu\u00edda',
    translatorEmail: 'Email do Tradutor',
    translatorEmailDesc: 'Email do tradutor/pessoa atribu\u00edda',
    requesterName: 'Nome do Solicitante',
    requesterNameDesc: 'Nome de quem criou o pedido',
    certificationDate: 'Data de Certifica\u00e7\u00e3o',
    certificationDateDesc: 'Data da certifica\u00e7\u00e3o',
    orderDate: 'Data do Pedido',
    orderDateDesc: 'Data em que o pedido foi criado',
    completionDate: 'Data de Conclus\u00e3o',
    completionDateDesc: 'Data em que o pedido foi conclu\u00eddo',
    sourceLanguage: 'Idioma de Origem',
    sourceLanguageDesc: 'Idioma original do documento',
    targetLanguage: 'Idioma de Destino',
    targetLanguageDesc: 'Idioma destino da tradu\u00e7\u00e3o',
    sourceCountry: 'Pa\u00eds de Origem',
    sourceCountryDesc: 'Pa\u00eds do documento original',
    targetCountry: 'Pa\u00eds de Destino',
    targetCountryDesc: 'Pa\u00eds destino da tradu\u00e7\u00e3o',
    documentTitle: 'T\u00edtulo do Documento',
    documentTitleDesc: 'Nome do documento',
    documentType: 'Tipo de Documento',
    documentTypeDesc: 'Categoria do documento',
    originalFile: 'Arquivo Original',
    originalFileDesc: 'Nome do arquivo original enviado',
    pageCount: 'Contagem de P\u00e1ginas',
    pageCountDesc: 'N\u00famero de p\u00e1ginas traduzidas',
    orderNumber: 'N\u00famero do Pedido',
    orderNumberDesc: 'S\u00f3 o id do pedido (ex. RR0124-1). N\u00e3o se combina com o do projeto.',
    projectNumber: 'N\u00famero do Projeto',
    projectNumberDesc: 'Refer\u00eancia personalizada do projeto se existir, sen\u00e3o o nome do projeto',
    companyName: 'Nome da Empresa',
    companyNameDesc: 'Nome da empresa/ag\u00eancia de tradu\u00e7\u00e3o',
    orderNotes: 'Notas do Pedido',
    orderNotesDesc: 'Notas anexadas ao pedido',
    translatorPhone: 'Telefone do Tradutor',
    translatorPhoneDesc: 'Número de telefone do perfil do tradutor',
    associationName: 'Associação',
    associationNameDesc: 'Associação profissional (ATA, NAJIT, etc.)',
    certificationNumber: 'Número de Certificação',
    certificationNumberDesc: 'Número de certificação ou membro profissional',
    languagePairs: 'Pares de Idiomas',
    languagePairsDesc: 'Pares de idiomas do tradutor (ex. Inglês → Espanhol)',
    translatorAddress: 'Endereço do Tradutor',
    translatorAddressDesc: 'Endereço completo do perfil do tradutor',
    translatorCity: 'Cidade',
    translatorCityDesc: 'Cidade do endereço do tradutor',
    translatorState: 'Estado',
    translatorStateDesc: 'Estado/província do endereço do tradutor',
    translatorCountry: 'País',
    translatorCountryDesc: 'País do endereço do tradutor',
    translatorZip: 'CEP',
    translatorZipDesc: 'Código postal do endereço do tradutor',
  },
  auth: {
    invalidCredentials: 'E-mail ou senha incorretos',
    userExists: 'Já existe uma conta com este e-mail',
    accountDeactivated: 'Sua conta foi desativada. Entre em contato com seu administrador.',
    accountLocked: 'Conta temporariamente bloqueada. Tente novamente em {n} minuto(s).',
    accountLockedOne: 'Conta temporariamente bloqueada. Tente novamente em {n} minuto.',
    accountLockedOther: 'Conta temporariamente bloqueada. Tente novamente em {n} minutos.',
    tooManyAttemptsLocked: 'Muitas tentativas falhas. Conta bloqueada por {n} minutos.',
    tooManyAttemptsLockedOne: 'Muitas tentativas falhas. Conta bloqueada por {n} minuto.',
    tooManyAttemptsLockedOther: 'Muitas tentativas falhas. Conta bloqueada por {n} minutos.',
    verifyEmailTitle: 'Verifique seu e-mail',
    verifyEmailDesc: 'Enviamos um código de 6 dígitos para',
    verifyEmailCta: 'Verificar e continuar',
    verifyEmailWrong: 'E-mail errado? Voltar',
    welcomeBack: 'Bem-vindo de volta',
    signInSubtitle: 'Entre para continuar ao seu painel',
    createAccount: 'Crie sua conta',
    startFreeTrial: 'Comece sua avaliação gratuita hoje',
    firstName: 'Nome',
    firstNamePlaceholder: 'Maria',
    lastName: 'Sobrenome',
    lastNamePlaceholder: 'Silva',
    registerAsCompany: 'Registrar como empresa',
    companyName: 'Nome da empresa',
    companyNamePlaceholder: 'Nome da sua empresa',
    companyLogo: 'Logo da empresa',
    emailAddress: 'Endereço de e-mail',
    emailPlaceholder: 'voce@exemplo.com',
    password: 'Senha',
    passwordPlaceholder: 'Mín. 8 caracteres',
    enterPassword: 'Digite sua senha',
    signIn: 'Entrar',
    signingIn: 'Entrando...',
    creatingAccount: 'Criando conta...',
    uploadingLogo: 'Enviando logo...',
    forgotPassword: 'Esqueceu a senha?',
    noAccount: 'Não tem uma conta?',
    createAnAccount: 'Criar uma conta',
    alreadyHaveAccount: 'Já tem uma conta?',
    signInLink: 'Entrar',
    continueWithGoogle: 'Continuar com o Google',
    continueWithLinkedIn: 'Continuar com o LinkedIn',
    orEmailPassword: 'ou continuar com',
    oauthFailed: 'Não foi possível entrar com essa conta. Tente de novo.',
    oauthGoogleOriginError: 'O Google rejeitou esta origem ({origin}). No Google Cloud Console → Credenciais → cliente Web, adicione exatamente essa URL em origens JavaScript autorizadas. Um Client ID que não seja Web também causa Error 401.',
    authFailed: 'Falha na autenticação',
    connectionError: 'Erro de conexão. Tente novamente.',
    tooManyRequests: 'Muitas tentativas. Aguarde alguns minutos antes de tentar novamente.',
    sessionError: 'Falha ao criar sessão',
    // Password requirements
    pwdMinLength: 'Mínimo 8 caracteres',
    pwdUppercase: 'Pelo menos uma letra maiúscula',
    pwdLowercase: 'Pelo menos uma letra minúscula',
    pwdNumber: 'Pelo menos um número',
    pwdSpecialChar: 'Pelo menos um caractere especial (!@#$%^&*)',
    pwdStrengthWeak: 'Fraca',
    pwdStrengthFair: 'Regular',
    pwdStrengthGood: 'Boa',
    pwdStrengthStrong: 'Forte',
    // Forgot password
    forgotPasswordTitle: 'Redefinir senha',
    forgotPasswordDesc: 'Digite seu e-mail e enviaremos um código de verificação.',
    sendCode: 'Enviar código',
    sendingCode: 'Enviando...',
    verificationCode: 'Digite o código de verificação',
    verificationCodeDesc: 'Enviamos um código de 6 dígitos para',
    verifyCode: 'Verificar código',
    verifyingCode: 'Verificando...',
    resendCode: 'Reenviar código',
    resendIn: 'Reenviar em {n}s',
    newPassword: 'Nova senha',
    confirmPassword: 'Confirmar senha',
    confirmPasswordPlaceholder: 'Confirme sua senha',
    resetPassword: 'Definir senha',
    resettingPassword: 'Redefinindo...',
    passwordResetSuccess: 'Senha redefinida!',
    passwordResetSuccessDesc: 'Sua senha foi alterada com sucesso. Agora você pode entrar com sua nova senha.',
    backToSignIn: 'Voltar para o login',
    passwordsNoMatch: 'As senhas não coincidem',
    passwordMinLength: 'A senha deve ter pelo menos 8 caracteres',
    // Inactivity
    sessionExpired: 'Sessão expirada',
    sessionExpiredDesc: 'Sua sessão foi encerrada por inatividade. Entre novamente.',
    // Success
    accountCreatedSuccess: 'Conta criada com sucesso! Faça login.',
    // Auth page chrome + mockup
    backToHome: 'Voltar ao início',
    mockupTitleOrders: 'Gerencie todos os seus pedidos',
    mockupDescOrders: 'Acompanhe documentos, idiomas e status em um só lugar.',
    mockupTitleEditor: 'Editor de tradução com IA',
    mockupDescEditor: 'Revisão OCR lado a lado com tradução em tempo real.',
    mockupTitleTeam: 'Feito para equipes e empresas',
    mockupDescTeam: 'Gerencie tradutores, revisores e administradores juntos.',
    mockupTitleCredits: 'Créditos e faturamento em um olhar',
    mockupDescCredits: 'Monitore o uso, compre créditos e acompanhe despesas.',
    mockupTabOrders: 'Pedidos',
    mockupTabEditor: 'Editor',
    mockupTabTeam: 'Equipe',
    mockupTabCredits: 'Créditos',
    mockupNavOrders: 'Pedidos',
    mockupNavWorkspace: 'Espaço',
    mockupNavTeam: 'Equipe',
    mockupNavCredits: 'Créditos',
    mockupNavSettings: 'Configurações',
    mockupHeaderOrders: 'Pedidos',
    mockupHeaderWorkspace: 'Espaço de trabalho',
    mockupHeaderCompanyDashboard: 'Painel da empresa',
    mockupHeaderCreditsBilling: 'Créditos e faturamento',
    mockupSearchOrders: 'Buscar pedidos...',
    mockupNewOrder: '+ Novo pedido',
    mockupColDocument: 'Documento',
    mockupColLanguage: 'Idioma',
    mockupColStatus: 'Status',
    mockupColDate: 'Data',
    mockupStatusCompleted: 'Concluído',
    mockupStatusInReview: 'Em revisão',
    mockupStatusProcessing: 'Processando',
    mockupStatusPending: 'Pendente',
    mockupStepUpload: 'Enviar',
    mockupStepOcr: 'OCR',
    mockupStepReview: 'Revisar',
    mockupStepExport: 'Exportar',
    mockupOriginalLabel: 'Original (ES)',
    mockupTranslationLabel: 'Tradução (EN)',
    mockupTotalOrders: 'Total de pedidos',
    mockupTeamMembers: 'Membros da equipe',
    mockupThisMonth: 'Este mês',
    mockupTeamActivity: 'Atividade da equipe',
    mockupRoleTranslator: 'Tradutor',
    mockupRoleReviewer: 'Revisor',
    mockupRoleAdmin: 'Admin',
    mockupRowOrders: 'pedidos',
    mockupAvailableCredits: 'Créditos disponíveis',
    mockupProPlan: 'Plano Pro',
    mockupBusinessPlan: 'Plano Empresa',
    mockupRecentTransactions: 'Transações recentes',
    mockupCredits: 'créditos',
    logoTooLarge: 'O logo deve ter menos de 5 MB.',
    mockupCompanyAdmin: 'Admin. da empresa',
    mockupDocBirthCertificate: 'Certidão de nascimento',
    mockupDocMarriageLicense: 'Certidão de casamento',
    mockupDocDiploma: 'Diploma',
    mockupDocMedicalRecord: 'Prontuário médico',
    mockupDocPowerOfAttorney: 'Procuração',
    mockupTxBirthCertificate: 'Tradução de certidão de nascimento',
    mockupTxCreditPurchase: 'Compra de créditos ({n})',
    mockupTxDiplomaOcr: 'OCR + tradução de diploma',
  },
  activityPage: {
    title: 'Atividade da Equipe',
    subtitle: 'Acompanhe o que os membros da equipe estão fazendo',
    exportCSV: 'Exportar CSV',
    totalActivities: 'Total de Atividades',
    clients: 'Clientes',
    ocrOperations: 'Operações OCR',
    translations: 'Traduções',
    searchPlaceholder: 'Buscar por nome do membro, ID do pedido, nome do cliente...',
    allActions: 'Todas as Ações',
    ocrGenerated: 'OCR Gerado',
    ocrEdited: 'OCR Editado',
    translationGenerated: 'Tradução Gerada',
    translationEdited: 'Tradução Editada',
    downloadAction: 'Download',
    statusCompleted: 'Status Completado',
    member: 'Membro',
    time: 'Hora',
    order: 'Pedido',
    action: 'Ação',
    details: 'Detalhes',
    loading: 'Carregando atividade...',
    noActivity: 'Nenhuma atividade encontrada',
    showing: 'Mostrando',
    of: 'de',
    total: 'total',
    orderCreated: 'Pedido Criado',
    ocrCompleted: 'OCR Completado',
    translationGen: 'Tradução Gen',
    translationEdit: 'Tradução Edit',
    processing: 'Processando',
    completed: 'Completado',
    translationReview: 'Revisão Tradução',
    ocrReview: 'Revisão OCR',
    orderAssigned: 'Tarefa Atribuída',
    tasksAssigned: 'Tarefas Atribuídas',
    allMembers: 'Todos os Membros',
    client: 'Cliente',
    noClient: 'N/A',
    clearDates: 'Limpar datas',
    role: 'Função',
    orderTrashed: 'Movido para a lixeira',
    orderRestored: 'Restaurado da lixeira',
    orderArchived: 'Arquivado',
    orderUnarchived: 'Desarquivado',
    orderDeleted: 'Excluído permanentemente',
    orderDeletedAuto: 'Excluído permanentemente (automático, 7 dias)',
    trashEmptied: 'Lixeira esvaziada',
    orderReassigned: 'Tarefa reatribuída',
    orderUnassigned: 'Atribuição removida',
    referenceChanged: 'Referência alterada',
    orderCancelled: 'Pedido cancelado',
    humanVerification: 'Verificação humana',
    projectCreated: 'Projeto criado',
    otherAction: 'Outra ação',
    loadError: 'Não foi possível carregar a atividade. Tente novamente em alguns minutos.',
    finalizationRequested: 'Enviou para revisão',
    finalizationReturned: 'Devolveu o pedido',
    creditClaimSubmitted: 'Contestou créditos',
    creditClaimFileOpened: 'O suporte abriu um arquivo da contestação',
    languagesConfirmed: 'Idiomas do documento confirmados',
    languagesDecided: 'Opções de idiomas para traduzir',
  },
  corpus: {
    title: 'Meus Termos',
    subtitle: 'Gerencie seus termos de tradução por idioma e categoria.',
    folders: 'Pastas',
    createFolder: 'Nova Pasta',
    createCorpus: 'Novo Conjunto de Termos',
    createError: 'Não foi possível criar o conjunto de termos. Tente novamente.',
    glossary: 'Termos',
    documents: 'Documentos',
    style: 'Estilo',
    knowledge: 'Base de Conhecimento',
    sourceTerm: 'Termo Origem',
    targetTerm: 'Termo Destino',
    context: 'Contexto / Notas',
    addTerm: 'Adicionar Termo',
    importCsv: 'Importar CSV',
    exportCsv: 'Exportar CSV',
    importPreview: 'Pré-visualização',
    importConfirm: 'Importar',
    importSuccess: 'importados',
    importDuplicates: 'duplicados ignorados',
    importErrors: 'erros',
    importTotal: 'entradas totais',
    importDragOrClick: 'Arraste um arquivo CSV aqui ou clique para procurar',
    importCsvFormat: "Formato: coluna A = termo de origem, B = termo de destino, C = contexto (opcional). A linha de cabeçalho é opcional.",
    importing: 'Importando...',
    export: 'Exportar',
    terms: 'termos',
    noCorpus: 'Sem termos ainda',
    selectCorpus: 'Selecionar Conjunto de Termos',
    formal: 'Formal',
    neutral: 'Neutro',
    plain: 'Simples',
    noFolders: 'Sem pastas ainda. Crie uma para organizar seus termos.',
    noEntries: 'Sem termos ainda. Adicione seu primeiro termo.',
    search: 'Buscar...',
    name: 'Nome',
    description: 'Descrição',
    sourceLanguage: 'Idioma Origem',
    targetLanguage: 'Idioma Destino',
    customInstructions: 'Instruções personalizadas',
    save: 'Salvar',
    cancel: 'Cancelar',
    delete: 'Excluir',
    edit: 'Editar',
    active: 'Ativo',
    inactive: 'Inativo',
    corpora: 'Conjuntos de Termos',
    folder: 'Pasta',
    back: 'Voltar',
    create: 'Criar',
    showing: 'Mostrando',
    of: 'de',
    noResults: 'Sem resultados',
    confirmDeleteFolder: 'Excluir esta pasta? Os conjuntos de termos dentro serão movidos para "Sem pasta".',
    confirmDeleteCorpus: 'Excluir este conjunto de termos e todas as suas entradas? Esta ação não pode ser desfeita.',
    confirmDeleteTerm: 'Excluir este termo?',
    prev: 'Anterior',
    next: 'Próximo',
    comingSoonMilestone: 'Disponível em breve',
    folderPlaceholder: 'Jurídico, Médico, Acadêmico...',
    corpusNamePlaceholder: 'Certificados Jurídicos ES→EN',
    instructionsPlaceholder: 'Ex: Usar "você" em vez de "tu". Manter formato de datas DD/MM/AAAA...',
    noFolder: 'Sem pasta',
    color: 'Cor',
    whatIsCorpus: 'O que são Meus Termos?',
    whatIsCorpusDesc: 'Sua biblioteca pessoal de termos. Adicione termos, documentos de exemplo e regras de estilo para que a IA traduza usando seu vocabulário.',
    corpusInFolder: 'conjuntos de termos nesta pasta',
    shared: 'Compartilhado',
    category: 'Categoria',
    writingStyle: 'Estilo de escrita',
    formalDesc: 'Vocabulário técnico preciso, frases estruturadas.',
    neutralDesc: 'Equilíbrio entre formalidade e acessibilidade.',
    plainDesc: 'Frases curtas, vocabulário simples.',
    createNewCorpus: 'Criar novo conjunto de termos',
    configureDesc: 'Configure sua biblioteca de referência e adicione seu conteúdo.',
    corpusNameRequired: 'Nome do conjunto de termos *',
    corpusNameExample: 'Ex: Direito Penal, Cardiologia, Diplomas...',
    corpusUseDesc: 'Para que você vai usar este conjunto de termos',
    exampleDocs: 'Documentos exemplo',
    exampleDocsDesc: 'Envie traduções anteriores suas como referência de estilo e formato.',
    originalDoc: 'Original',
    translatedDoc: 'Tradução',
    docPairTip: 'Melhores resultados com o par completo (original + tradução). Pode enviar apenas um.',
    knowledgeDesc: 'Artigos, guias ou material de consulta que a IA usará como referência ao traduzir.',
    uploadArticle: 'Enviar artigo',
    acceptedFormats: 'Formatos aceitos: PDF, DOCX, TXT. Máximo 10 MB por arquivo.',
    dragFileHere: 'Arraste seu arquivo aqui',
    tmxCsvFormat: 'TMX, CSV ou Excel (Col A = original, Col B = tradução)',
    addManually: 'adicione termos manualmente',
    generateAI: 'Gerar com IA',
    share: 'Compartilhar',
    viewTabs: 'Abas',
    viewScroll: 'Lista',
    unorganized: 'Sem pasta',
    add: 'Adicionar',
    styleExtracted: 'Estilo extraído',
    noDocuments: 'Nenhum documento de exemplo ainda. Envie um par para melhorar a precisão.',
    noKnowledge: 'Nenhum artigo ainda. Envie material de referência para a IA consultar.',
    articles: 'artigos',
    uploadPair: 'Enviar par',
    notes: 'Notas',
    found: 'encontrados',
    sourceColumn: 'Origem',
    targetColumn: 'Destino',
    removeFile: 'Remover',
    glossaryFileError: 'Formato não suportado. Envie o glossário em Excel, CSV, TSV ou TMX.',
    glossarySpreadsheetError: 'Esse formato de planilha não pode ser lido. Abra-o e salve-o como .xlsx ou CSV; depois envie-o.',
    glossaryTooManyTerms: "O arquivo tem {count} termos e o máximo por arquivo é 100.000. Divida-o em vários arquivos.",
    glossaryEmptyError: 'Nenhuma entrada válida encontrada no arquivo.',
    docFileError: 'Envie um arquivo de texto (PDF, DOCX, TXT).',
    knowledgeFileError: 'Envie um arquivo de texto (PDF, DOCX, TXT).',
    fileTooLarge: 'O arquivo deve ter menos de 10 MB.',
    uploadingGlossary: 'Importando glossário...',
    uploadingDocuments: 'Enviando documentos...',
    uploadingKnowledge: 'Enviando',
    quickStartTitle: 'Como funciona',
    step1Title: '1. Crie um Glossário',
    step1Desc: 'Adicione seus termos de glossário (CSV, TSV ou TMX) para que a IA use suas traduções preferidas.',
    step2Title: '2. Adicione documentos de exemplo',
    step2Desc: 'Envie documentos previamente traduzidos para que a IA aprenda seu estilo e tom.',
    step3Title: '3. Traduza',
    step3Desc: 'Selecione seu glossário ao criar um pedido. Seus termos serão aplicados automaticamente.',
    termsTotal: "{terms} no total",
    pageRange: "Mostrando {from}–{to} de {total}",
    importConfirmTerms: "Importar {terms}",
    close: "Fechar",
    badgeAi: "IA",
    badgeLearned: "Aprendido",
    confirmDeleteDocument: "Excluir este documento de exemplo?",
    confirmDeleteKnowledge: "Excluir este arquivo da base de conhecimento?",
    loadError: "Não foi possível carregar este conjunto de termos. Ele pode ter sido excluído ou você pode não ter acesso.",
    planLimitError: "Seu plano não permite criar mais conjuntos de termos. Faça upgrade do plano para criar mais.",
    uploadingFile: "Enviando {file}…",
    deleteFolder: "Excluir pasta",
  },
  admin: {
    asistente: {
      title: 'Assistente de dados',
      subtitle: 'Pergunte em linguagem natural sobre segmentos, consumo e risco de cancelamento.',
      inputPlaceholder: 'Digite sua pergunta...',
      send: 'Enviar',
      thinking: 'Pensando...',
      suggestedTitle: 'Perguntas sugeridas',
      suggestion1: 'Quantos usuários novos houve hoje?',
      suggestion2: 'Me dê o relatório de hoje.',
      suggestion3: 'Faça um relatório dos usuários que entraram e não consumiram 10% do plano.',
      suggestion4: 'Quais clientes pagantes estão há mais de 10 dias sem entrar?',
      suggestion5: 'Há contas duplicadas pelo nome?',
      exportButton: 'Exportar para XLSX',
      emptyState: 'Faça uma pergunta sobre seus clientes para começar.',
      errorGeneric: 'Não consegui processar a pergunta. Tente novamente.',
      sendReportNow: 'Enviar relatório agora',
      sendReportSending: 'Enviando...',
      sendReportSuccess: 'Relatório enviado.',
      sendReportError: 'Não foi possível enviar o relatório.',
      dashboardSegments: 'Segmentos de hoje',
      dashboardAlerts: 'Alertas e anomalias',
      dashboardLoadError: 'Não foi possível carregar o resumo de hoje.',
      chatSectionTitle: 'Pergunte ao assistente',
      segmentTrial: 'Trial ativo',
      segmentNoUsage: 'Sem consumo',
      segmentPartial: 'Consumo parcial',
      segmentFull: 'Consumo total',
      newAccountsToday: 'Contas novas hoje',
      ambassadors: 'Embaixadores',
      alertInactive: 'Inativas há 10+ dias',
      alertUsageDrop: 'Queda de consumo',
      alertLowConsumption: 'Baixo consumo',
      alertUncharged: 'Pedidos sem cobrança',
      alertDuplicates: 'Cadastros duplicados',
      alertScheduledCancellation: 'Cancelamento agendado',
      downloadReport: 'Baixar relatório',
      downloadingReport: 'Gerando...',
      downloadReportError: 'Não foi possível gerar o relatório.',
      promptSegmentListTpl: '{segment}: me dê a lista de contas.',
      promptNewAccounts: 'Quantas contas novas houve hoje? Me dê a lista.',
      promptAmbassadors: 'Me dê o resumo dos embaixadores.',
      promptScheduledCancellation: 'Me dê a lista de contas com cancelamento agendado.',
      promptInactive: 'Me dê a lista de contas pagas inativas há mais de 10 dias.',
      promptUsageDrop: 'Me dê a lista de contas com queda de consumo nos últimos 30 dias.',
      promptLowConsumption: 'Me dê a lista de contas pagas com baixo consumo desde a última concessão do plano.',
      promptUncharged: 'Me dê a lista de pedidos concluídos sem cobrança de créditos.',
      promptDuplicates: 'Me dê a lista de possíveis cadastros duplicados por nome.',
    },
    translationEngines: {
      header: 'Motores de tradução',
      subtitle: 'Controle quais motores traduzem os documentos. Aplicado no servidor — o motor é realmente trocado/bloqueado, não apenas ocultado na interface.',
      tab: 'Tradução',
      deeplLabel: 'DeepL',
      deeplDesc: 'Permitir tradução com DeepL (tradução automática rápida, sem glossários de corpus). Aplica-se apenas quando o pedido NÃO tem corpus.',
      claudeLabel: 'Claude',
      claudeDesc: 'Permitir tradução com Claude para pedidos SEM corpus (tradução com reconhecimento de contexto).',
      corpusLabel: 'Corpus → sempre Claude',
      corpusDesc: 'Fixo (não configurável): um pedido com corpus é sempre traduzido pelo Claude — glossários de corpus só funcionam com Claude.',
      alwaysOn: 'Sempre ativo',
      bothDisabled: 'Ambos os motores estão desativados — pedidos SEM corpus ficarão sem motor. (Pedidos com corpus ainda são traduzidos pelo Claude.)',
      effectiveTitle: 'Comportamento efetivo',
      effectiveWithCorpus: 'Com corpus: apenas Claude (corpus) — sempre, mesmo se a opção Claude estiver desligada.',
      effectiveWithoutCorpusPrefix: 'Sem corpus:',
      noneEnabled: 'nenhum ativo',
    },
    orderDetail: {
      back: 'Voltar',
      documentInfo: 'Informações do documento',
      category: 'Categoria',
      type: 'Tipo',
      pages: 'Páginas',
      step: 'Etapa',
      exportFormat: 'Formato de exportação',
      certificate: 'Certificado',
      digitalSignature: 'Assinatura digital',
      humanVerified: 'Verificado por humano',
      attachOriginal: 'Anexar original',
      originalFile: 'Arquivo original',
      translation: 'Tradução',
      sourceLanguage: 'Idioma de origem',
      targetLanguage: 'Idioma de destino',
      sourceCountry: 'País de origem',
      targetCountry: 'País de destino',
      translationMethod: 'Método de tradução',
      people: 'Pessoas',
      account: 'Conta',
      createdBy: 'Criado por',
      creditsAndDates: 'Créditos e datas',
      creditsEstimated: 'Créditos estimados',
      creditsConsumed: 'Créditos consumidos',
      created: 'Criado',
      updated: 'Atualizado',
      completed: 'Concluído',
      processingTime: 'Tempo de processamento',
      platformCostBreakdown: 'Detalhamento de custos da plataforma',
      service: 'Serviço',
      usage: 'Uso',
      costUsd: 'Custo (USD)',
      total: 'Total',
      yes: 'Sim',
      no: 'Não',
      mode: 'Modo',
      referenceNumber: 'Referência',
      clientName: 'Cliente',
      dueDate: 'Data de entrega',
      verificationId: 'ID de verificação',
      viewVerification: 'Ver verificação pública',
      humanVerifiedBy: 'Verificado por',
      translationApprovedBy: 'Tradução aprovada por',
      filesPurgedTpl: 'Arquivos purgados em {date}',
      deletionCertificateLink: 'Ver certificado de exclusão',
      notFound: 'Pedido não encontrado',
      fetchFailed: 'Não foi possível carregar o pedido',
      formatTemplate: 'Modelo de formato',
      assignedTo: 'Atribuído a',
      notes: 'Notas',
      usagePagesTpl: '{n} páginas',
      usageTokensTpl: '{n} tokens',
      usageCharsTpl: '{n} caracteres',
      claudeOcr: 'Claude AI (OCR)',
      claudeTranslation: 'Claude AI (tradução)',
      claudeVision: 'Claude AI (visão)',
      modeDeeplClaude: 'Opção 1 (DeepL + Claude AI)',
      modeGoogle: 'Opção 1 (Google)',
      modeCorpus: 'Corpus',
    },
    common: {
      systemOnline: 'Sistema online',
      allTime: 'Desde sempre',
      realTime: 'Em tempo real',
      search: 'Pesquisar',
      save: 'Salvar',
      cancel: 'Cancelar',
      create: 'Criar',
      edit: 'Editar',
      delete: 'Excluir',
      close: 'Fechar',
      done: 'Concluído',
      loading: 'Carregando...',
      saving: 'Salvando...',
      success: 'Sucesso',
      error: 'Erro',
      confirmDelete: 'Excluir este item? Esta ação não pode ser desfeita.',
      cannotBeUndone: 'Esta ação não pode ser desfeita.',
      actions: 'Ações',
      status: 'Status',
      name: 'Nome',
      description: 'Descrição',
      title: 'Título',
      category: 'Categoria',
      type: 'Tipo',
      date: 'Data',
      language: 'Idioma',
      active: 'Ativo',
      inactive: 'Inativo',
      draft: 'Rascunho',
      total: 'Total',
      page: 'Página',
      of: 'de',
      previous: 'Anterior',
      next: 'Próximo',
      showing: 'Mostrando',
      noResults: 'Sem resultados',
      allStatus: 'Todos os status',
      exportCSV: 'Exportar CSV',
      view: 'Visualizar',
      add: 'Adicionar',
      remove: 'Remover',
      refresh: 'Atualizar',
      copy: 'Copiar',
      copied: 'Copiado',
      select: 'Selecionar',
      applying: 'Aplicando...',
    },
    overview: {
      title: 'Painel do administrador',
      subtitle: 'Visão geral e gerenciamento do sistema',
      totalOrders: 'Pedidos totais',
      activeAccounts: 'Contas ativas',
      totalUsers: 'Usuários totais',
      creditsBalance: 'Saldo de créditos',
      humanVerified: 'Verificado por humanos',
      totalRevenue: 'Receita total',
      today: 'Hoje',
      thisWeek: 'Esta semana',
      thisMonth: 'Este mês',
      platformCostsAllTime: 'Custos da plataforma (histórico)',
      totalCost: 'Custo total',
      avgPerOrder: 'Méd. / pedido',
      avgPerPage: 'Méd. / página',
      ordersProcessed: 'Pedidos processados',
      totalPages: 'Páginas totais',
      costByService: 'Custo por serviço',
      awsTextract: 'AWS Textract',
      googleDocAI: 'Google Document AI',
      claudeAI: 'Claude AI',
      deepl: 'DeepL',
      ocrExtraction: 'Extração OCR',
      ocrComplementary: 'OCR complementar',
      visionPostEdit: 'Visão + Pós-edição',
      translation: 'Tradução',
      pages: 'Páginas',
      costPerPage: 'Custo/página',
      ocrColor: 'OCR (cor)',
      visionClass: 'Visão (class.)',
      postEdit: 'Pós-edição',
      characters: 'Caracteres',
      words: 'Palavras',
      costPerMillion: 'Custo/1M caracteres',
      detailedUsage: 'Detalhamento de uso',
      service: 'Serviço',
      purpose: 'Propósito',
      usage: 'Uso',
      cost: 'Custo (USD)',
      ocrTextExtraction: 'OCR extração de texto',
      ocrColorDetection: 'OCR detecção de cor',
      visionClassification: 'Classificação por visão',
      translationPostEdit: 'Pós-edição de tradução',
      totalPlatformCost: 'Custo total da plataforma',
      tokens: 'tokens',
      chars: 'caracteres',
      topLanguagePairs: 'Principais pares de idiomas',
      ordersByStatus: 'Pedidos por status',
      noLanguagePairData: 'Ainda sem dados de pares de idiomas',
      percentOfOrders: '% do total de pedidos',
      orders: 'pedidos',
      noOrderData: 'Nenhum dado de pedido disponível',
      totalOrdersLabel: 'Pedidos totais',
      activitySummary: 'Resumo de atividade',
      ordersToday: 'Pedidos hoje',
      creditsConsumed: 'Créditos consumidos',
      completed: 'concluídos',
      inProgress: 'em andamento',
      totalAccounts: 'total',
      newThisWeek: 'esta semana',
      newThisMonth: 'novas este mês',
      verified: 'verificados',
      ofCompleted: 'de',
      sold: 'vendidos',
      consumed: 'consumidos',
      creditsSold: 'Créditos vendidos',
      totalPurchased: 'Total comprado por clientes',
      unusedAcrossAccounts: 'Créditos não usados em todas as contas',
      used: 'Usados',
      remaining: 'Restantes',
      available: 'Disponíveis',
      balance: 'Saldo',
      imageBased: 'Baseado em imagem',
      textBased: 'Baseado em texto',
      documents: 'documentos',
      documentsByType: 'Documentos por tipo',
      pagesByType: 'Páginas por tipo de documento',
      imagePages: 'Páginas de imagem',
      textPages: 'Páginas de texto',
      noDocData: 'Ainda sem dados de documentos',
      noPageData: 'Ainda sem dados de páginas',
      activeUsers: 'ativos',
      teamUsers: 'de equipe',
      memberUsers: 'membros',
      statusUploaded: 'Enviado',
      statusProcessing: 'Processando',
      statusOcrReview: 'Revisão OCR',
      statusTranslationReview: 'Revisão de tradução',
      statusCompleted: 'Concluído',
      plusTodayTpl: '+{n} hoje',
      plusThisWeekTpl: '+{n} esta semana',
      costEnvTitle: 'Ambiente do gasto do Claude',
      apply: 'Aplicar',
      salesHint: 'Clique para ver cada venda: quem, quando, o quê e quanto',
      salesTitle: 'Detalhe de vendas',
      salesModeAll: 'Todas',
      salesModeLive: 'Reais',
      salesModeTest: 'Teste',
      opsOption1: 'Opção 1 (DeepL)',
      opsOption2: 'Opção 2 (Claude AI)',
      opsCorpus: 'Corpus (Claude AI + corpus)',
      envProduction: 'Produção',
      claudeEnvErrorTpl: 'Não foi possível ler o gasto de {env} ({error}). Verifique se o ambiente tem a chave e o segredo de serviço configurados.',
      totalTokens: 'Tokens totais',
      vision: 'Visão',
      docClassification: 'Classificação de documentos',
      classifications: 'Classificações',
      tokensLabel: 'Tokens',
      costLabel: 'Custo',
      infraTitle: 'Infraestrutura (Railway) — mês atual',
      infraNote: 'Uso estimado do mês até hoje segundo a API do Railway (CPU, memória, rede, volumes).',
      infraNotConnectedTpl: 'Sem conexão. Configure {token} no serviço api-gateway para ver os custos de infraestrutura por ambiente.',
      usersOverview: 'Visão geral de usuários',
      activeCountTpl: '{n} ativos',
      usersUnit: 'usuários',
      userTypeTeam: 'Equipe',
      userTypeMember: 'Membro',
      userTypeFreelance: 'Freelancer',
      userTypeAdmin: 'Admin',
      docTypeTitle: 'Distribuição por tipo de documento',
      docTypeNote: 'Todos os tipos de documento: 1 crédito/página',
      docsUnit: 'docs',
      pagesUnit: 'páginas',
      documentsLabel: 'Documentos',
      pagesProcessed: 'Páginas processadas',
      docTypeCountsTpl: '({docs} docs, {pages} páginas)',
    },
    accounts: {
      title: 'Contas',
      subtitle: 'Gerenciar todas as contas registradas',
      searchPlaceholder: 'Pesquisar contas...',
      noAccountsFound: 'Nenhuma conta encontrada',
      account: 'Conta',
      owner: 'Proprietário',
      members: 'Membros',
      plan: 'Plano',
      credits: 'Créditos',
      created: 'Criada',
      payAsYouGo: 'Pague pelo uso',
      activate: 'Ativar',
      suspend: 'Suspender',
      viewDetails: 'Ver detalhes',
      addCredits: 'Adicionar créditos',
      statusActive: 'Ativa',
      statusTrial: 'Testando',
      statusSuspended: 'Suspensa',
      adjustCredits: 'Ajustar créditos',
      currentBalance: 'Saldo atual',
      creditsAmount: 'Quantidade de créditos',
      amountPlaceholder: 'Ex. 100 (use negativo para deduzir)',
      amountHint: 'Positivo para adicionar, negativo para deduzir',
      reason: 'Motivo',
      reasonPlaceholder: 'Ex. Créditos de cortesia, correção de cobrança...',
      newBalance: 'Novo saldo',
      creditsAppliedSuccess: 'créditos aplicados com sucesso',
      failedToAdjust: 'Falha ao ajustar créditos',
      networkError: 'Erro de rede. Tente novamente.',
      applyCredits: 'Aplicar créditos',
      applying: 'Aplicando...',
      showing: 'Mostrando',
      accountsLabel: 'contas',
      changePlan: 'Mudar plano',
      noPlan: 'Sem plano',
      assignPlan: 'Atribuir plano',
      selectPlan: 'Selecionar um plano',
      billingCycle: 'Ciclo de cobrança',
      monthly: 'Mensal',
      yearly: 'Anual',
      applyCreditsLabel: 'Adicionar créditos do plano ao saldo atual',
      currentPlan: 'Plano atual',
      newPlan: 'Novo plano',
      planChangedSuccess: 'Plano atualizado com sucesso',
      failedToChangePlan: 'Não foi possível mudar o plano',
      freelanceOnly: 'Apenas freelancer (1 membro)',
      companyPlan: 'Plano empresa',
      removePlan: 'Remover plano',
      memberLimitExceeded: 'A conta tem mais membros do que este plano permite',
      freeMembersKeepHint: 'Os membros permanecem na conta. Equipe fica bloqueada até comprarem um plano pago.',
      freeCreditModeLabel: 'Créditos ao passar para Free',
      freeCreditKeepPlus5: 'Saldo atual + 5',
      freeCreditOnly5: 'Apenas 5 (remover o resto)',
      removePlanWarning: 'Cancela a assinatura no Stripe imediatamente e zera o saldo.',
      ownerViewHint: 'O plano também ajusta o que o dono vê: com plano de equipe passa à vista de equipe. Aplica-se no próximo login.',
      lastActive: 'Última atividade',
      never: 'Nunca',
      trialColumn: 'Teste',
      trialExpired: 'Expirado',
      trialOneDay: '1 dia',
      trialDays: n => `${n} dias`,
      planPriceLineTpl: '{monthly}/mês · {yearly}/ano · {credits} créditos/mês',
    },
    users: {
      title: 'Usuários',
      subtitle: 'Gerenciar todos os usuários da plataforma',
      searchPlaceholder: 'Pesquisar usuários por nome ou email...',
      user: 'Usuário',
      email: 'Email',
      accountLabel: 'Conta',
      userType: 'Tipo',
      role: 'Função',
      lastLogin: 'Último acesso',
      status: 'Status',
      noUsersFound: 'Nenhum usuário encontrado',
      allTypes: 'Todos os tipos',
      allRoles: 'Todas as funções',
      typeAdmin: 'Admin',
      typeTeam: 'Equipe',
      typeMember: 'Membro',
      typeUser: 'Usuário',
      roleOwner: 'Proprietário',
      roleAdmin: 'Admin',
      roleManager: 'Gerente',
      roleMember: 'Membro',
      roleFreelancer: 'Freelancer',
      activate: 'Ativar',
      deactivate: 'Desativar',
      impersonate: 'Personificar',
      viewActivity: 'Ver atividade',
      never: 'Nunca',
      showing: 'Mostrando',
      usersLabel: 'usuários',
      subtitleActivity: 'Monitore a atividade e o engajamento dos usuários',
      exportExcel: 'Exportar para Excel',
      exportEmail: 'E-mail',
      exportPlan: 'Plano',
      exportCreditsAvailable: 'Créditos disponíveis',
      exportConsumedAccount: 'Consumidos (conta)',
      exportConsumedUser: 'Consumidos (usuário)',
      onlineNow: 'Online agora',
      activeToday: 'Ativos hoje',
      byRole: 'Por função',
      teamShort: 'equipe',
      memberShort: 'membro',
      userShort: 'usuário',
      allActivity: 'Toda a atividade',
      filterOnline: 'Online agora',
      filterRecent: 'Ativo recentemente',
      filterActiveStatus: 'Status: ativo',
      filterSuspendedStatus: 'Status: suspenso',
      statusOnline: 'Online',
      statusRecently: 'Recentemente',
      statusOffline: 'Offline',
      statusSuspendedBadge: 'Suspenso',
      lastActive: 'Última atividade',
      lastPage: 'Última página',
      joined: 'Entrou em',
      noAccount: 'Sem conta',
      moreAccountsTpl: '+{n} mais',
      showingRangeTpl: 'Mostrando {from}-{to} de {total} usuários',
      timeJustNow: 'agora mesmo',
      timeMinAgoTpl: 'há {n}m',
      timeHourAgoTpl: 'há {n}h',
      timeDayAgoTpl: 'há {n}d',
      timeWeekAgoTpl: 'há {n}sem',
      platformAdminLabel: 'Admin da plataforma',
      platformAdminBadge: 'Admin da plataforma',
      platformAdminDescription: 'Concede acesso a /admin sem alterar o papel de equipe ou plano. Podem alternar a vista como os embaixadores.',
      platformAdminReloginHint: 'Devem sair e entrar novamente para a alteração ter efeito.',
      platformAdminGrant: 'Tornar admin da plataforma',
      platformAdminRevoke: 'Remover admin da plataforma',
      platformAdminGranted: 'Admin da plataforma concedido',
      platformAdminRevoked: 'Admin da plataforma removido',
      platformAdminFailed: 'Não foi possível atualizar o admin da plataforma',
      platformAdminConfirmGrant: 'Conceder admin da plataforma a este usuário? Ele mantém a vista de equipe/plano e precisa entrar de novo.',
      platformAdminConfirmRevoke: 'Remover o admin da plataforma deste usuário? Ele precisa entrar de novo.',
      deleteUser: 'Excluir usuário…',
      deleteTitle: 'Excluir usuário permanentemente',
      deleteWarningTpl: 'Esta ação {strong}. Para continuar, um código de confirmação de 6 caracteres será enviado ao e-mail de administração configurado em Configurações.',
      deleteWarningStrong: 'não pode ser desfeita',
      sendCode: 'Enviar código',
      enterCodeTpl: 'Digite o código enviado para {email} (expira em 10 minutos).',
      adminEmailFallback: 'o e-mail de administração',
      deletePermanently: 'Excluir permanentemente',
      codeSendFailed: 'Não foi possível enviar o código',
      invalidCode: 'Código inválido',
      somethingWrong: 'Algo deu errado. Tente novamente.',
      userDeleted: 'Usuário excluído',
      userDeletedTpl: '{name} foi excluído permanentemente.',
      exportSheet: 'Usuários e créditos',
    },
    orders: {
      title: 'Todos os pedidos',
      subtitle: 'Ver e gerenciar todos os pedidos de todas as contas',
      searchPlaceholder: 'Pesquisar pedidos por número ou nome do documento...',
      totalOrders: 'Pedidos totais',
      completed: 'Concluídos',
      inProgress: 'Em andamento',
      totalPlatformCost: 'Custo total da plataforma',
      orderNum: 'Pedido N°',
      document: 'Documento',
      account: 'Conta',
      pages: 'Páginas',
      credits: 'Créditos',
      quality: 'Qualidade',
      cost: 'Custo (USD)',
      status: 'Status',
      date: 'Data',
      actions: 'Ações',
      viewBtn: 'Ver',
      logsBtn: 'Logs',
      noOrdersFound: 'Nenhum pedido encontrado.',
      platformCostBreakdown: 'Detalhamento do custo da plataforma',
      awsTextract: 'AWS Textract',
      googleDocAI: 'Google Doc AI',
      claudeAI: 'Claude AI',
      deepl: 'DeepL',
      grandTotal: 'Total geral',
      allServicesCombined: 'todos os serviços combinados',
      detailedUsageBreakdown: 'Detalhamento de uso',
      allTimeAggregated: 'Uso agregado histórico de todos os pedidos',
      service: 'Serviço',
      purpose: 'Propósito',
      usage: 'Uso',
      costUsd: 'Custo (USD)',
      ocrTextExtraction: 'OCR (extração de texto)',
      ocrComplementary: 'OCR (complementar)',
      visionClassification: 'Visão (classificação)',
      translationClaude: 'Tradução (Claude)',
      translation: 'Tradução',
      totalLbl: 'Total',
      orderLogsTitle: 'Logs do pedido',
      loadingLogs: 'Carregando logs...',
      noLogsFound: 'Nenhum log encontrado para este pedido.',
      timestamp: 'Carimbo de data',
      action: 'Ação',
      creditsCol: 'Créditos',
      pagesLower: 'páginas',
      charsLower: 'caracteres',
      tokensLower: 'tokens',
      statusUploaded: 'Enviado',
      statusProcessing: 'Processando',
      statusOcrReview: 'Revisão OCR',
      statusTranslationReview: 'Revisão de tradução',
      statusCompleted: 'Concluído',
      allStatus: 'Todos os status',
      actionOrderCreated: 'Pedido criado',
      actionOcrCompleted: 'OCR concluído',
      actionOcrGenerated: 'OCR gerado',
      actionOcrEdited: 'OCR editado',
      actionTranslationGen: 'Trad. gerada',
      actionTranslationEdit: 'Trad. editada',
      actionDownload: 'Download',
      actionProcessing: 'Processando',
      actionCompleted: 'Concluído',
      actionTranslationReview: 'Revisão de tradução',
      actionOcrReview: 'Revisão OCR',
      exportCSV: 'Exportar CSV',
      wordsLower: 'palavras',
      ordersLower: 'pedidos',
      showingRangeTpl: 'Mostrando {from}-{to} de {total} pedidos',
      orderLogsForTpl: 'Logs do pedido — {orderNumber}',
      visibilityAll: 'Visibilidade: todos',
      visibilityActive: 'Ativos',
      visibilityTrash: 'Na lixeira',
      visibilityDeleted: 'Excluídos permanentemente',
      visibilityArchived: 'Arquivados',
      badgeInTrash: 'Na lixeira',
      badgeDeleted: 'Excluído permanentemente',
      deletedAuto: 'Automática (7 dias na lixeira)',
      byTpl: '{date} · por {name}',
      inTrashSince: 'Na lixeira desde',
      statusCancelled: 'Cancelado',
      actorAuto: 'Automático',
      userCol: 'Usuário',
      csvOrderNumber: 'Número do pedido',
      csvDocumentName: 'Nome do documento',
      csvAccount: 'Conta',
      csvStatus: 'Status',
      csvPages: 'Páginas',
      csvCreditsEstimated: 'Créditos estimados',
      csvCreditsConsumed: 'Créditos consumidos',
      csvSourceLanguage: 'Idioma de origem',
      csvTargetLanguage: 'Idioma de destino',
      csvOrderDate: 'Data do pedido',
      csvLogTimestamp: 'Data do registro',
      csvLogAction: 'Ação',
      csvLogCredits: 'Créditos do registro',
      csvLogUser: 'Usuário do registro',
      csvTrashedAt: 'Na lixeira desde',
      csvDeletedAt: 'Excluído em',
      csvDeletedReason: 'Motivo da exclusão',
    },
    waitlist: {
      title: 'Lista de espera',
      subtitle: 'Inscrições de Founding User da landing page',
      totalSignups: 'Inscrições totais',
      companies: 'Empresas',
      wantBetaAccess: 'Querem acesso beta',
      latestSignup: 'Última inscrição',
      searchPlaceholder: 'Pesquisar por nome, email, empresa ou função...',
      noEntriesFound: 'Nenhuma inscrição encontrada na lista',
      name: 'Nome',
      email: 'Email',
      phone: 'Telefone',
      company: 'Empresa',
      role: 'Função',
      pagesPerWeek: 'Pág./sem.',
      biggestPain: 'Maior problema',
      priceWillingness: 'Disposição de pagar',
      betaInterest: 'Interesse beta',
      language: 'Idioma',
      signedUp: 'Inscrito',
      signedUpAt: 'Inscrito em',
      deleteEntry: 'Excluir inscrição',
      viewDetails: 'Ver detalhes',
      deleteConfirm: 'Excluir esta inscrição?',
      csvName: 'Nome',
      csvEmail: 'E-mail',
      csvPhone: 'Telefone',
      csvCompany: 'Empresa',
      csvRole: 'Função',
      csvPagesWeek: 'Páginas/semana',
      csvBiggestPain: 'Maior dificuldade',
      csvPriceWillingness: 'Disposição de pagamento',
      csvBetaInterest: 'Interesse no beta',
      csvLanguage: 'Idioma',
      csvDate: 'Data',
    },
    analytics: {
      title: 'Análises',
      subtitle: 'Desempenho e insights da plataforma',
      totalOrders: 'Pedidos totais',
      activeAccounts: 'Contas ativas',
      ordersProcessed: 'Pedidos processados',
      creditsConsumed: 'Créditos consumidos',
      ordersByStatus: 'Pedidos por status',
      topLanguagePairs: 'Principais pares de idiomas',
      documentsByType: 'Documentos por tipo',
      pagesByDocType: 'Páginas por tipo de documento',
      imageBased: 'Baseado em imagem',
      textBased: 'Baseado em texto',
      imagePages: 'Páginas de imagem',
      textPages: 'Páginas de texto',
      documents: 'documentos',
      pages: 'páginas',
      noOrderData: 'Ainda sem dados de pedidos',
      noLanguagePairData: 'Ainda sem dados de pares de idiomas',
      noDocData: 'Ainda sem dados de documentos',
      noPageData: 'Ainda sem dados de páginas',
      statusUploaded: 'Enviado',
      statusProcessing: 'Processando',
      statusOcrReview: 'Revisão OCR',
      statusTranslationReview: 'Revisão de tradução',
      statusCompleted: 'Concluído',
      manuscript: 'Manuscrito',
    },
    blog: {
      title: 'Blog · Artigos Ranqio',
      subtitle: 'Conteúdo ingerido via API + edição de SEO, OG, JSON-LD e status.',
      searchPlaceholder: 'Pesquisar por título...',
      allStatuses: 'Todos os status',
      statusDraft: 'Rascunho',
      statusScheduled: 'Agendado',
      statusPublished: 'Publicado',
      statusArchived: 'Arquivado',
      noArticles: 'Nenhum artigo.',
      titleCol: 'Título',
      status: 'Status',
      locale: 'Locale',
      author: 'Autor',
      publishedAt: 'Publicado',
      actions: 'Ações',
      viewOnSite: 'Ver no site',
      editSeo: 'Editar SEO',
      deleteArticle: 'Excluir',
      deleteConfirm: 'Excluir este artigo? Esta ação não pode ser desfeita.',
      articles: 'artigos',
      pageOf: 'Página {p} de {t}',
      errorSave: 'Erro ao salvar.',
      loadFailed: 'Não foi possível carregar o artigo.',
      savedOk: 'Alterações salvas.',
      notFound: 'Artigo não encontrado.',
      back: 'Voltar',
      backToArticles: 'Voltar para artigos',
      sectionBasic: 'Informações básicas',
      slugHint: 'Define a URL final /blog/[slug].',
      fieldExcerpt: 'Resumo',
      excerptHint: 'Texto curto para listagens e meta description padrão.',
      sectionSeo: 'SEO · Busca',
      schemasHint: 'Array de objetos { type, jsonLd }. É inserido no <head>.',
      sectionFeaturedImage: 'Imagem em destaque',
      altText: 'Texto alternativo',
      sectionPublication: 'Publicação',
      fieldPublishDate: 'Data de publicação',
      sectionInfo: 'Informações',
      viewPublished: 'Ver artigo publicado →',
    },
    copy: {
      title: 'Textos do site',
      subtitle: 'Edite os textos da landing principal em todos os idiomas. Alterações vivem em rascunho até você clicar em Publicar.',
      discardDraft: 'Descartar rascunho',
      saveDraft: 'Salvar rascunho',
      publish: 'Publicar',
      publishing: 'Publicando',
      draftSaved: '✓ Rascunho salvo. Ainda não visível ao público.',
      publishedMsg: '🚀 Publicado. Visitantes já veem as alterações.',
      errorSaveDraft: 'Erro ao salvar rascunho',
      errorPublish: 'Erro ao publicar',
      discardConfirm: 'Descartar rascunho e voltar para a versão publicada?',
      draftDiscarded: 'Rascunho descartado',
      loadingError: 'Erro carregando copy',
      unpublishedChanges: 'Há alterações não publicadas em',
      pressPublish: 'Clique em Publicar para que os visitantes as vejam.',
      unsaved: 'não salvo',
      draftBadge: 'rascunho',
      pendingChanges: 'Alterações não publicadas',
    },
    nav: {
      title: 'Menu de navegação',
      subtitle: 'Configure os itens do cabeçalho. Crie links para páginas, dropdowns com sub-itens ou links externos.',
      newItem: 'Novo item',
      noItems: 'Ainda não há itens. Crie o primeiro para aparecer no cabeçalho do site.',
      dragHint: '💡 Arraste os itens pela alça da esquerda para reordená-los.',
      itemCreated: 'Item criado',
      itemUpdated: 'Item atualizado',
      saveError: 'Erro ao salvar',
      deleteConfirm: 'Excluir este item? Seus filhos também serão excluídos.',
      newItemTitle: 'Novo item',
      editItemTitle: 'Editar item',
      kind: 'Tipo',
      kindLink: 'Link externo (URL)',
      kindLanding: 'Landing page (criada no EZDocuAI)',
      kindDropdown: 'Dropdown (com sub-itens)',
      url: 'URL',
      urlHint: 'Ex: https://docs.exemplo.com ou /pricing',
      landingPage: 'Landing page',
      landingHint: 'Se a landing for renomeada ou excluída, o link é atualizado/desativado automaticamente.',
      selectPlaceholder: '— Selecionar —',
      parentItem: 'Item pai (opcional)',
      parentHint: 'Para aninhar dentro de um dropdown',
      noParent: '— Sem pai (top-level) —',
      activeLabel: 'Ativo (visível no cabeçalho)',
      addSubItem: 'Adicionar sub-item',
      dragReorder: 'Arrastar para reordenar',
      deleteItem: 'Excluir',
      inactive: 'inativo',
      items: 'itens',
      kindLinkShort: 'Link',
      kindLandingShort: 'Landing',
      kindDropdownShort: 'Suspenso',
      itemsOne: '{n} item',
      itemsOther: '{n} itens',
    },
    seo: {
      title: 'SEO e Metadados',
      subtitle: 'Otimize seu site para mecanismos de busca e redes sociais.',
      tabGeneral: 'Geral',
      tabRobots: 'Robots',
      tabSitemap: 'Sitemap',
      tabPages: 'Páginas',
      errorLoading: 'Erro carregando configuração',
      settingsSaved: 'Configuração salva',
      errorSaving: 'Erro ao salvar',
      saveChanges: 'Salvar alterações',
      addSocialProfile: 'Adicionar perfil social',
      generalSection: 'Configuração geral',
      siteName: 'Nome do site',
      siteNamePlaceholder: 'EZDocuAI',
      siteUrl: 'URL do site',
      siteUrlPlaceholder: 'https://www.ezdocu.ai',
      titleTemplate: 'Template do título',
      titleTemplateHint: 'Use %s onde irá o título de cada página',
      titleTemplatePlaceholder: '%s | EZDocuAI',
      defaultTitle: 'Título padrão',
      titleCounterLabel: 'Título',
      defaultDescription: 'Descrição padrão',
      descriptionCounterLabel: 'Descrição',
      ogImage: 'Imagem para redes sociais (OG)',
      ogImageHint: 'Tamanho recomendado: 1200×630px. Envie do seu computador ou cole uma URL.',
      ogImagePlaceholder: 'https://… ou envie uma imagem',
      googleVerification: 'Código de verificação do Google',
      googleVerificationPlaceholder: 'google-site-verification=...',
      socialProfiles: 'Perfis sociais',
      socialProfilePlaceholder: 'https://www.instagram.com/ezdocu',
      googlePreview: 'Visualização no Google',
      socialPreview: 'Visualização em redes sociais',
      indexingSection: 'Indexação do site',
      allowGoogleIndex: 'Permitir que o Google indexe o site',
      allowGoogleIndexHint: 'Se desativado, o site não aparecerá nos buscadores.',
      blockedPathsSection: 'Caminhos bloqueados para crawlers',
      blockedPathsHint: 'Esses caminhos não serão rastreados pelo Google nem por outros buscadores.',
      blockedPathPlaceholder: '/caminho-a-bloquear/',
      aiPolicySection: 'Política de crawlers de IA',
      aiPolicyAllowAll: 'Permitir todos',
      aiPolicyAllowAllDesc: 'Google, Bing, ChatGPT, Claude podem acessar',
      aiPolicyBlockTraining: 'Bloquear treinamento',
      aiPolicyBlockTrainingDesc: 'Permite busca IA, bloqueia treinamento (GPTBot, CCBot)',
      aiPolicyBlockAll: 'Bloquear todos os bots IA',
      aiPolicyBlockAllDesc: 'Só permite buscadores tradicionais',
      robotsPreviewSection: 'Visualização do robots.txt',
      sitemapSection: 'Configuração do sitemap',
      autoGenerateSitemap: 'Gerar sitemap automaticamente',
      autoGenerateSitemapHint: 'Inclui páginas estáticas, landing pages ativas e conteúdo do CMS.',
      sitemapUpdated: 'Sitemap atualizado',
      sitemapUrlCopied: 'URL copiada',
      includedContentSection: 'Conteúdo incluído',
      includedStaticPages: 'Páginas estáticas (início, pricing, blog)',
      includedLandingPages: 'Landing pages dinâmicas ativas',
      includedBlogArticles: 'Artigos de blog publicados',
      excludedHint: 'Páginas privadas (dashboard, workspace) são excluídas automaticamente.',
      metaBasicSection: 'Meta básica',
      metaTitleLabelTpl: 'Meta title ({n}/60 recomendado)',
      metaDescriptionLabelTpl: 'Meta description ({n}/155 recomendado)',
      focusKeyword: 'Focus keyword',
      canonicalUrl: 'URL canônica',
      canonicalPlaceholder: 'https://www.ezdocu.ai/...',
      noindexLabel: 'noindex',
      nofollowLabel: 'nofollow',
      openGraphSection: 'Open Graph',
      ogTitle: 'OG title',
      ogDescription: 'OG description',
      ogImageUrl: 'OG image URL',
      ogImageUrlPlaceholder: 'https://...',
      twitterSection: 'Twitter Cards',
      twitterCard: 'Twitter card',
      twitterSite: 'Twitter @site',
      twitterSitePlaceholder: '@ezdocuai',
      twitterTitle: 'Twitter title',
      twitterDescription: 'Twitter description',
      twitterImage: 'Twitter image URL',
      jsonLdSection: 'JSON-LD',
      jsonLdLabel: 'Schemas (array de { type, jsonLd })',
      jsonLdHint: 'É injetado dentro de <head> ao renderizar a página.',
      jsonLdInvalid: 'JSON-LD inválido',
      changesPublished: 'Mudanças publicadas',
      previewGoogle: 'Preview Google',
      previewOg: 'Preview OG',
      infoSection: 'Info',
      pageKeyLabel: 'Chave da página',
      lastEdited: 'Última edição',
    },
    apiKeys: {
      title: 'API Keys',
      subtitle: 'Gerencie as chaves de acesso de integrações externas (Ranqio, etc.). Configure um webhook para receber confirmação quando o EZDocuAI processar um artigo.',
      noKeys: 'Nenhuma API key criada ainda.',
      webhookDeleted: 'Webhook excluído',
      webhookSaved: 'Webhook salvo',
      saveError: 'Erro ao salvar',
      copiedToClipboard: '✓ Copiado para a área de transferência',
      statusActive: 'ativa',
      statusRevoked: 'revogada',
      webhookBadge: 'webhook',
      rateLimitTpl: '{n}/min',
      lastUsedTpl: 'última vez: {when}',
      lastUsedNever: 'nunca',
      lastDeliveryTpl: 'última entrega: HTTP {status}',
      noDeliveriesYet: 'sem entregas ainda',
      editWebhook: 'Editar webhook',
      configureWebhook: 'Configurar webhook',
      webhookUrlLabel: 'URL do webhook',
      webhookUrlPlaceholder: 'https://seu-dominio.com/webhooks/ezdocu',
      webhookUrlHint: 'O EZDocuAI enviará um POST assinado aqui quando um artigo for criado, atualizado ou excluído a partir desta API key.',
      secretLabel: 'Secret (opcional)',
      secretPlaceholder: 'É gerado automaticamente se deixar vazio',
      secretHint: 'Usado para assinar cada request (HMAC-SHA256) no header X-EZDocu-Signature.',
      showSecret: 'Mostrar',
      hideSecret: 'Ocultar',
      saveSecretWarning: '⚠ Salve este secret — não será mostrado novamente',
      deleteWebhook: 'Excluir webhook',
      cancel: 'Cancelar',
      save: 'Salvar',
      payloadExample: 'Payload do webhook (exemplo)',
    },
    landingPages: {
      title: 'Landing Pages',
      subtitle: 'Gerencie as landing pages dinâmicas: ofertas, promoções, eventos.',
      newPage: 'Nova página',
      noPages: 'Ainda não há landing pages',
      createFirst: 'Criar a primeira',
      deleteConfirm: 'Excluir esta landing page? Esta ação não pode ser desfeita.',
      totalLbl: 'Total',
      activeLbl: 'Ativas',
      draftsLbl: 'Rascunhos',
      titleCol: 'Título',
      slug: 'Slug',
      status: 'Status',
      updated: 'Atualizada',
      actions: 'Ações',
      activeBadge: 'Ativa',
      draftBadge: 'Rascunho',
      viewSite: 'Ver',
      editPage: 'Editar',
      deletePage: 'Excluir',
      slugTitleRequired: 'Slug e título são obrigatórios',
      errorCreate: 'Erro ao criar',
      errorSave: 'Erro ao salvar',
      errorPublish: 'Erro ao publicar',
      draftSavedMsg: '✓ Rascunho salvo. Ainda não visível ao público.',
      publishedMsg: '🚀 Publicado. Os visitantes já veem as mudanças.',
      draftDiscarded: 'Rascunho descartado',
      draftUnpublished: 'Rascunho não publicado',
      errorCreatePage: 'Erro ao criar a página',
      errorSaveDraft: 'Erro ao salvar o rascunho',
      notFound: 'Página não encontrada',
      discardConfirm: 'Descartar todas as alterações do rascunho? Você voltará à versão publicada.',
      confirmUnpublish: 'Despublicar esta página?\n\nOs visitantes não a verão mais e ela retornará 404.',
      confirmPublishTpl: 'Publicar esta página?\n\nEla ficará visível publicamente em /{slug}.',
      unpublishedMsg: 'Página despublicada (404 para o público)',
      visibleMsg: 'Página visível para o público',
      newTitle: 'Nova landing page',
      editTitle: 'Editar landing page',
      badgePublished: 'Publicada',
      badgeUnpublished: 'Despublicada (404 para o público)',
      publicUrl: 'URL pública:',
      toggleTitleUnpublish: 'Faz a página deixar de ser visível para o público',
      toggleTitlePublish: 'Torna-a visível para o público novamente',
      unpublish: 'Despublicar',
      publishPage: 'Publicar página',
      discardDraft: 'Descartar rascunho',
      preview: 'Pré-visualização',
      createPage: 'Criar página',
      saveDraft: 'Salvar rascunho',
      publish: 'Publicar',
      editingDraftTpl: 'Você está editando um rascunho. Clique em {publish} para que os visitantes vejam as alterações ou em {preview} para revisá-las antes.',
      sectionBasic: 'Informações básicas',
      slugLockedHint: '🔒 Não editável. A URL não pode mudar depois de criar a página (quebraria links externos).',
      slugUrlHintTpl: 'URL: /{slug}',
      fieldTitle: 'Título *',
      fieldPublishedFrom: 'Publicada desde',
      publishedFromHint: 'Informativo. A visibilidade real depende do botão Publicar/Despublicar.',
      fieldExpires: 'Expira em',
      expiresHint: 'Informativo.',
      sectionContent: 'Conteúdo',
      sectionSeo: 'SEO',
      fieldOgImage: 'Imagem OG (redes sociais)',
      ogImageHint: '1200×630 px recomendado. Envie do seu computador ou cole uma URL.',
      ogImagePlaceholder: 'https://… ou envie uma imagem',
      previewGoogle: 'Pré-visualização no Google',
      previewOg: 'Pré-visualização OG',
    },
    templates: {
      title: 'Modelos de certificado',
      subtitle: 'Gerencie os modelos de certificado globais disponíveis para todas as contas.',
      noTemplates: 'Nenhum modelo ainda',
      uploadTemplate: 'Enviar modelo',
      newTemplate: 'Novo modelo',
      editTemplate: 'Editar modelo',
      activateTemplate: 'Ativar',
      deactivateTemplate: 'Desativar',
      default: 'Padrão',
      global: 'Global',
      custom: 'Personalizado',
      uploadDocx: 'Enviar DOCX',
      globalTemplatesStat: 'Modelos globais',
      activeStat: 'Ativos',
      defaultStat: 'Padrão',
      inactiveStat: 'Inativos',
      categoryGeneral: 'Geral',
      categoryLegal: 'Jurídico',
      categoryImmigration: 'Imigração',
      categoryAcademic: 'Acadêmico',
      allTemplatesFilter: 'Todos os modelos',
      colTemplate: 'Modelo',
      colCategory: 'Categoria',
      colAccount: 'Conta',
      colFlags: 'Flags',
      colCreated: 'Criado',
      colActions: 'Ações',
      colActive: 'Ativo',
      loadingTemplates: 'Carregando modelos...',
      noTemplatesFound: 'Nenhum modelo encontrado.',
      flagDefault: 'Padrão',
      flagGlobal: 'Global',
      editBtn: 'Editar',
      newGlobalTemplate: 'Novo modelo global',
      uploadTemplateDialog: 'Enviar modelo',
      nameLabel: 'Nome',
      namePlaceholder: 'Ex.: Certificado de tradução',
      descriptionLabel: 'Descrição (opcional)',
      descriptionPlaceholder: 'Breve descrição deste modelo',
      categoryLabel: 'Categoria',
      languageLabel: 'Idioma',
      anyLanguage: 'Qualquer idioma',
      languageEnglish: 'Inglês',
      languageSpanish: 'Espanhol',
      languagePortuguese: 'Português',
      cancelBtn: 'Cancelar',
      createAndEdit: 'Criar e editar',
      creatingBtn: 'Criando...',
      editingGlobalTemplate: 'Editando modelo global',
      variablesBtn: 'Variáveis',
      clickToCopyHint: 'Clique para copiar → Ctrl+V',
      copiedTooltip: '✓ Copiado!',
      clickToCopyTooltip: 'Clique para copiar → {description}',
      saveAndClose: 'Salvar e fechar',
      savingBtn: 'Salvando...',
      variableTranslatorName: 'Nome completo do tradutor',
      variableTranslatorEmail: 'E-mail do tradutor',
      variableCertificationDate: 'Data da certificação',
      variableOrderDate: 'Data em que o pedido foi criado',
      variableCompletionDate: 'Data em que o pedido foi concluído',
      variableSourceLanguage: 'Idioma original do documento',
      variableTargetLanguage: 'Idioma da tradução',
      variableSourceCountry: 'País de origem',
      variableTargetCountry: 'País de destino',
      variableDocumentTitle: 'Título do documento',
      variableDocumentType: 'Categoria/tipo do documento',
      variablePageCount: 'Número de páginas',
      variableOrderNumber: 'Número de referência do pedido',
      variableProjectNumber: 'Número de referência do projeto',
      failedToPrepareTpl: 'Falha ao preparar o modelo: {message}',
      failedToSaveTpl: 'Falha ao salvar o modelo: {message}',
      failedToSaveGeneric: 'Falha ao salvar o modelo. Confira o console para mais detalhes.',
      failedToCreate: 'Falha ao criar o modelo',
    },
    accountDetail: {
      loadFailed: 'Não foi possível carregar a conta',
      loadDetailsFailed: 'Não foi possível carregar os detalhes da conta',
      notFound: 'Conta não encontrada',
      backToAccounts: 'Voltar para contas',
      subtitle: 'Detalhes da conta',
      typeFreelance: 'Freelancer',
      typeCompany: 'Empresa',
      trialEndsTpl: 'O teste termina em {date}',
      legalName: 'Razão social',
      taxId: 'ID fiscal',
      website: 'Site',
      yes: 'Sim',
      no: 'Não',
      dateFormat: 'Formato de data',
      retention: 'Retenção',
      noAutoPurge: 'Sem limpeza automática',
      retentionDaysTpl: '{n} dias',
      orders: 'Pedidos',
      completed: 'Concluídos',
      inProgress: 'Em andamento',
      withFormat: 'Com formato',
      recentOrders: 'Pedidos recentes',
      colOrder: 'Pedido',
      colDocument: 'Documento',
      colLanguages: 'Idiomas',
      colFormat: 'Formato',
      colPages: 'Páginas',
      colCredits: 'Créditos',
      colStatus: 'Status',
      colCreated: 'Criado',
      noOrders: 'Esta conta ainda não tem pedidos.',
      ordersUnavailable: 'A atividade de pedidos não está disponível no momento.',
      spentToday: 'Gasto hoje',
      spentThisMonth: 'Gasto este mês',
      recentTransactions: 'Movimentações recentes',
      balanceAfterTpl: 'Saldo {n}',
      noTransactions: 'Ainda não há movimentações de créditos.',
      txPurchase: 'Compra',
      txConsumption: 'Consumo',
      txRefund: 'Reembolso',
      txAdjustment: 'Ajuste',
      txAutoRecharge: 'Recarga automática',
      txSubscription: 'Assinatura',
      txCampaignBonus: 'Bônus de campanha',
      txReferral: 'Indicação',
      txClawback: 'Estorno',
      teamMembers: 'Membros da equipe',
      firstName: 'Nome',
      lastName: 'Sobrenome',
      activeRelTpl: 'Ativo {time}',
      lastLoginRelTpl: 'Último acesso {time}',
      neverLoggedIn: 'Nunca entrou',
      pendingInvitations: 'Convites pendentes',
      pending: 'Pendente',
      expiresTpl: 'Expira em {date}',
    },
    userDetail: {
      loadFailed: 'Não foi possível carregar o usuário',
      loadDetailsFailed: 'Não foi possível carregar os detalhes do usuário',
      notFound: 'Usuário não encontrado',
      backToUsers: 'Voltar para usuários',
      noAccounts: 'Este usuário não pertence a nenhuma conta.',
      ordersOne: '{n} pedido',
      ordersOther: '{n} pedidos',
      noOrders: 'Este usuário ainda não tem pedidos.',
    },
    plans: {
      title: 'Gestão de planos',
      popular: 'Popular',
      saved: 'Salvo',
      monthlyPrice: 'Preço mensal',
      yearlyPrice: 'Preço anual',
      creditsMonth: 'Créditos/mês',
      creditsYear: 'Créditos/ano',
      yearlyDiscount: 'Desconto anual %',
      buttonText: 'Texto do botão',
      yes: 'Sim',
      no: 'Não',
      active: 'Ativo',
      inactive: 'Inativo',
      description: 'Descrição',
      descriptionPlaceholder: 'Descrição do plano...',
      limitsTitle: 'Limites (vazio = ilimitado)',
      limitMaxCorpora: 'Máx. corpus',
      limitMaxMembers: 'Máx. membros',
      limitHistoryDays: 'Histórico (dias)',
      limitRetentionDays: 'Retenção máx. (dias)',
      featuresTitle: 'Recursos',
      featureHumanVerifiedSeal: 'Selo Human Verified',
      featureManuscripts: 'Manuscritos',
      featureConfidential: 'Modo confidencial',
      featurePostEdit: 'Assistente de pós-edição',
      featureOtp: 'Verificação OTP',
      featureApi: 'Acesso à API',
      featureSso: 'SSO / SAML',
      featureWhiteLabel: 'Marca branca',
      benefits: 'Benefícios',
      moreTpl: '+{n} mais',
    },
    settingsBcc: {
      supportPlaceholder: 'ops@empresa.com, suporte@empresa.com',
      eventPlaceholder: 'vendas@empresa.com, financeiro@empresa.com',
      salesPlaceholder: 'vendas@empresa.com, diretoria@empresa.com',
    },
    features: {
      title: 'Ativação de recursos',
      subtitle: 'Ative ou desative recursos da plataforma',
      loadFailed: 'Não foi possível carregar os recursos',
      retry: 'Tentar novamente',
      totalFeatures: 'Recursos no total',
      enabled: 'Ativados',
      disabled: 'Desativados',
      categories: 'Categorias',
      searchPlaceholder: 'Buscar recursos...',
      all: 'Todos',
      catCore: 'Núcleo',
      catTranslation: 'Tradução',
      catBilling: 'Faturamento',
      catNotifications: 'Notificações',
      catIntegrations: 'Integrações',
      warning: 'Desativar recursos do núcleo pode afetar o sistema. As alterações entram em vigor imediatamente.',
      empty: 'Nenhum recurso configurado. Carregue os padrões para começar.',
      seed: 'Carregar recursos padrão',
      noMatch: 'Nenhum recurso corresponde à sua busca.',
    },
    hubspot: {
      subtitle: 'Sincronização EZDocu → HubSpot (contatos, empresas e associações)',
      loadFailed: 'Não foi possível carregar o status da sincronização.',
      actionFailed: 'A ação falhou. Verifique os logs do auth-ms.',
      retryFailed: 'Reprocessar falhas',
      syncAll: 'Sincronizar tudo',
      confirmSyncAll: 'Reenfileirar TODOS os usuários e contas para o HubSpot?',
      notConfiguredTpl: 'A sincronização está inativa: falta configurar {token} no auth-ms.',
      pending: 'Pendentes',
      processing: 'Processando',
      done: 'Concluídos',
      failed: 'Com falha',
      contactsSynced: 'Contatos sincronizados',
      companiesSynced: 'Empresas sincronizadas',
      recentFailures: 'Falhas recentes',
      colObject: 'Objeto',
      colId: 'ID',
      colAttempts: 'Tentativas',
      colLastError: 'Último erro',
      colDate: 'Data',
      noFailures: 'Sem falhas: tudo sincronizando normalmente.',
    },
    knowledge: {
      title: 'Central de ajuda',
      subtitleTpl: 'Os artigos publicados aparecem em {path} e alimentam o assistente de IA do widget de suporte.',
      newArticle: '+ Novo artigo',
      loadFailed: 'Não foi possível carregar os artigos.',
      searchPlaceholder: 'Buscar por título, identificador ou seção…',
      emptyNone: 'Ainda não há artigos.',
      emptyNoMatch: 'Nenhum artigo corresponde.',
      createFirst: 'Criar o primeiro →',
      colArticle: 'Artigo',
      colKey: 'Identificador',
      colSection: 'Seção',
      colLanguages: 'Idiomas',
      colStatus: 'Status',
      colUpdated: 'Atualizado',
      colActions: 'Ações',
      edit: 'Editar',
      deleteAll: 'Excluir todos os idiomas',
      confirmDeleteTpl: 'Excluir "{title}" em TODOS os idiomas ({n})? Esta ação é permanente e também o remove da base de conhecimento do assistente.',
      published: 'Publicado',
      draft: 'Rascunho',
      missingTranslation: 'Falta traduzir',
      allPublished: 'Todos publicados',
      publishedCountTpl: '{pub}/{total} publicados',
      titleRequired: 'O título e o slug são obrigatórios.',
      saveFailed: 'Não foi possível salvar o artigo.',
      publishFailed: 'Não foi possível alterar a publicação do artigo.',
      confirmUnpublish: 'Despublicar o artigo? Ele é removido do assistente e de /help/.',
      back: 'Voltar para a central de ajuda',
      titlePlaceholder: 'Título do artigo…',
      titleShortPlaceholder: 'Título…',
      savedTpl: 'Salvo {time}',
      view: 'Ver',
      saveDraft: 'Salvar rascunho',
      unpublish: 'Despublicar',
      republish: 'Republicar',
      publish: 'Publicar',
      fieldSection: 'Seção',
      noSection: '— Sem seção —',
      fieldCategory: 'Categoria',
      categoryPlaceholder: 'Ex.: Faturamento, Primeiros passos…',
      fieldLanguage: 'Idioma',
      editorPlaceholder: 'Comece a escrever…',
      editorTipTpl: 'Dica: digite {key} para ver os blocos disponíveis (títulos, listas, imagens, tabelas, código…).',
      featureOrderCreate: 'Criar pedido',
      featureOrderDetail: 'Detalhe do pedido',
      featureOrderList: 'Lista de pedidos',
      featureCreditsBilling: 'Créditos e faturamento',
      featureTeamManagement: 'Gestão da equipe',
      featureCertificate: 'Certificado',
      featureGlossary: 'Glossário',
      featureAccountSettings: 'Configurações da conta',
      featureFaq: 'Perguntas frequentes',
      groupLabel: 'Grupo de traduções',
      keyLabel: 'Identificador:',
      publishedWithDraft: 'Publicado com rascunho pendente',
      missingShort: 'Falta',
      missingVersionTpl: 'Este artigo ainda não tem versão em {lang}.',
      creating: 'Criando…',
      createTranslationTpl: 'Criar tradução em {lang}',
      createFailed: 'Não foi possível criar a tradução.',
      featureReleaseNotes: 'Novidades',
      articleLoadFailed: 'Não foi possível carregar o artigo.',
    },
    marketingUi: {
      charsTpl: '{n} caracteres',
      idealTpl: '(ideal {min}-{max})',
      noOgImage: 'Sem imagem OG',
      noTitle: 'Sem título',
      noDescription: 'Sem descrição',
      previewTitle: 'Pré-visualização: assim ficará a página publicada',
      noContentYet: 'Sem conteúdo ainda.',
      previewFooter: 'Isto é exatamente o que os visitantes verão quando você publicar.',
      close: 'Fechar',
      imageTooLargeTpl: 'A imagem não pode passar de {n} MB.',
      uploadFailedTpl: 'Erro {status} ao enviar a imagem.',
      uploadTimeout: 'O envio levou mais de 30 s. Verifique sua conexão.',
      uploadError: 'Erro ao enviar a imagem. Tente novamente.',
      uploadImageTpl: 'Enviar imagem (máx. {n} MB)',
      upload: 'Enviar',
      uploading: 'Enviando…',
      clear: 'Limpar',
      imageLoaded: 'Imagem carregada',
      previewAlt: 'Pré-visualização',
      editorPlaceholder: 'Comece a escrever o conteúdo da landing page…',
      loadingEditor: 'Carregando editor…',
      linkPrompt: 'URL do link',
      youtubePrompt: 'URL do vídeo do YouTube (https://youtube.com/watch?v=...)',
      editorUploadFailedTpl: 'Erro {status}: o servidor de imagens não respondeu corretamente.',
      editorUploadTimeout: 'O envio levou mais de 30 segundos. Verifique sua conexão ou se o serviço de imagens está funcionando.',
      bold: 'Negrito',
      italic: 'Itálico',
      strike: 'Tachado',
      inlineCode: 'Código em linha',
      heading1: 'Título 1',
      heading2: 'Título 2',
      heading3: 'Título 3',
      bulletList: 'Lista',
      orderedList: 'Lista numerada',
      quote: 'Citação',
      divider: 'Separador',
      link: 'Link',
      uploadImageCloud: 'Enviar imagem (Cloudinary, máx. 5 MB)',
      insertYoutube: 'Inserir vídeo do YouTube',
      imageLabel: 'Imagem:',
      alignLeft: 'Alinhar à esquerda',
      alignCenter: 'Centralizar',
      alignRight: 'Alinhar à direita',
      uploadingImage: 'Enviando imagem…',
      undo: 'Desfazer',
      redo: 'Refazer',
    },
    apiErrors: {
      fieldNotAllowedTpl: 'O campo "{field}" não pode ser enviado nesta operação.',
      mustBeTextTpl: '{field} deve ser texto.',
      mustBeBooleanTpl: '{field} deve ser verdadeiro ou falso.',
      mustBeTypeTpl: '{field} tem um formato inválido.',
      requiredTpl: '{field} é obrigatório.',
      minLengthTpl: '{field} deve ter pelo menos {n} caracteres.',
      maxLengthTpl: '{field} deve ter no máximo {n} caracteres.',
      upstream: 'O serviço de marketing não está respondendo. Tente novamente em alguns segundos.',
      notFound: 'Não encontrado.',
      tooLarge: 'A imagem ou o conteúdo é grande demais.',
      unauthorized: 'Sua sessão expirou. Entre novamente.',
      forbidden: 'Você não tem permissão para esta ação.',
      invalidLocale: 'Idioma inválido.',
      fieldSlug: 'Slug',
      fieldTitle: 'Título',
      fieldContent: 'Conteúdo',
      fieldOgImage: 'Imagem OG',
      fieldPublishedAt: 'Data de publicação',
      fieldExpiresAt: 'Data de expiração',
      fieldIsActive: 'Status',
      fieldKind: 'Tipo',
      fieldLabelTpl: 'Rótulo ({lang})',
      slugTaken: 'Já existe uma landing page com esse slug. Escolha outro.',
      slugReserved: 'Esse slug está reservado: já existe uma página do app nesse URL. Escolha outro.',
    },
    copyFields: {
      secHero: 'Hero (destaque)',
      secFeatures: 'Recursos — seção',
      secFeatureCardTpl: 'Recursos — cartão {n}',
      secFaq: 'Perguntas frequentes — seção',
      secFaqItemTpl: 'Perguntas frequentes — pergunta {n}',
      secPricing: 'Preços',
      secCtaFinal: 'CTA final',
      secFooter: 'Rodapé',
      titleLine1: 'Título — linha 1 (preto)',
      titleLine2: 'Título — linha 2 (roxo)',
      titleSizeDesktop: 'Tamanho do título — desktop (px)',
      titleSizeMobile: 'Tamanho do título — celular (px)',
      titleSizeDesktopHint: 'Limite para telas grandes. Vazio = tamanho responsivo padrão. Recomendado 48–80.',
      titleSizeMobileHint: 'Mínimo em celulares. Vazio = 55% do valor de desktop. Recomendado 28–44.',
      subtitleSentence1: 'Subtítulo — frase 1',
      subtitleSentence2: 'Subtítulo — frase 2',
      ctaPrimary: 'Botão principal',
      ctaSecondary: 'Botão secundário',
      ctaDemo: 'Botão agendar demo',
      ctaDemoUrl: 'URL para agendar demo',
      title: 'Título',
      subtitle: 'Subtítulo',
      name: 'Nome',
      description: 'Descrição',
      descriptionHover: 'Descrição estendida (ao passar o cursor)',
      question: 'Pergunta',
      answer: 'Resposta',
      titlePart1: 'Título — parte 1 (branco)',
      titlePart2: 'Título — parte 2 (roxo claro)',
      button: 'Botão',
      tagline: 'Slogan',
      auto: 'Auto',
    },
    logs: {
      title: 'Registro de atividades',
      subtitle: 'Registro detalhado de todas as atividades que consomem créditos',
      totalLogs: 'Registros totais',
      documents: 'Documentos',
      translations: 'Traduções',
      searchPlaceholder: 'Buscar por pedido, conta ou usuário...',
      allActions: 'Todas as ações',
      filterStatusCompleted: 'Status: concluído',
      actionAccountStatus: 'Status da conta',
      actionAccountStatusChange: 'Mudança de status da conta',
      actionMemberUpdate: 'Membro atualizado',
      actionFeatureToggle: 'Recurso ativado/desativado',
      actionSettingsUpdate: 'Configurações atualizadas',
      colOrder: 'Pedido',
      colDetails: 'Detalhes',
      noLogs: 'Nenhum registro encontrado',
      loadFailed: 'Não foi possível carregar os registros.',
      pageOfTpl: 'Página {page} de {pages}',
      totalTpl: '({n} no total)',
      csvDate: 'Data',
    },
    webinar: {
      titleTpl: 'Inscrições · {slug}',
      subtitleTpl: 'Inscrições capturadas por {endpoint} com {field}.',
      reload: 'Recarregar',
      totalParticipants: 'Participantes no total',
      language: 'Idioma',
      latestSignup: 'Último registro',
      searchPlaceholder: 'Buscar por e-mail ou usuário…',
      empty: 'Ainda não há participantes.',
      loadFailed: 'Não foi possível carregar as inscrições.',
      colEmail: 'E-mail',
      colSource: 'Origem',
      colDate: 'Data',
      csvCreatedAt: 'Data de registro',
    },
    support: {
      title: 'Suporte',
      subtitle: 'Caixa de entrada de toda a plataforma EZDocuAI',
      searchPlaceholder: 'Buscar por assunto ou resumo…',
      anyPriority: 'Qualquer prioridade',
      statusOpen: 'Aberto',
      statusPending: 'Pendente',
      statusSolved: 'Resolvido',
      statusSnoozed: 'Adiado',
      statusSpam: 'Spam',
      priorityLow: 'Baixa',
      priorityNormal: 'Normal',
      priorityHigh: 'Alta',
      priorityUrgent: 'Urgente',
      channelEmail: 'E-mail',
      channelChat: 'Chat',
      channelApi: 'API',
      channelForm: 'Formulário',
      channelSlack: 'Slack',
      sentimentPositive: 'Positivo',
      sentimentNegative: 'Negativo',
      sentimentNeutral: 'Neutro',
      sentimentAngry: 'Irritado',
      noTickets: 'Nenhum ticket corresponde aos filtros.',
      colSubject: 'Assunto',
      colChannel: 'Canal',
      colPriority: 'Prioridade',
      colStatus: 'Status',
      colSentiment: 'Sentimento',
      colCreated: 'Criado',
      noSubject: '(sem assunto)',
      pageTpl: 'Página {n}',
      connectError: 'Não foi possível conectar à caixa de suporte.',
      backToInbox: 'Voltar para a caixa de entrada',
      ticketNotFound: 'Ticket não encontrado',
      ticketLoadError: 'Não foi possível carregar o ticket.',
      timeNow: 'agora',
      timeMinTpl: 'há {n} min',
      timeHourTpl: 'há {n} h',
      timeDayTpl: 'há {n} d',
      createdTpl: 'Criado {time}',
      hideContext: 'Ocultar painel de contexto',
      showContext: 'Mostrar painel de contexto',
      aiSummary: 'Resumo da IA',
      internalNotePlaceholder: 'Nota interna (visível só para agentes)…',
      replyPlaceholder: 'Escreva uma resposta ao cliente…',
      send: 'Enviar',
      internalNote: 'Nota interna',
      internalNoteNoEmail: 'Notas internas nunca são enviadas por e-mail',
      uncheckNoEmail: 'Desmarque para não enviar e-mail ao cliente (ele continuará vendo a resposta no painel)',
      notifyByEmail: 'Notificar por e-mail',
      enterSendsTpl: '{enter} envia · {shift} nova linha',
      ticketContext: 'Contexto do ticket',
      closePanel: 'Fechar painel',
      suggestedDraft: 'Rascunho sugerido',
      generatedByAi: 'Gerado por IA',
      aiBadge: 'IA',
      useReply: 'Usar resposta',
      copy: 'Copiar',
      discard: 'Descartar',
      customer: 'Cliente',
      agent: 'Agente',
      aiAssistant: 'Assistente de IA',
      internalBadge: 'interna',
      ezdocuCustomer: 'Cliente EZDocuAI',
      anonymousSender: 'Remetente anônimo',
      copyUserId: 'Copiar ID do usuário',
      visitorBadge: 'Visitante (sem conta no EZDocuAI)',
      lastActivity: 'Última atividade:',
      lastLogin: 'Último acesso:',
      lastPage: 'Última página:',
      timezone: 'Fuso horário:',
      signupDate: 'Cadastro:',
      purchasesTitle: 'Compras e pedidos',
      statTotal: 'Total',
      statCompleted: 'Concluídos',
      statInProgress: 'Em andamento',
      statCredits: 'Créditos',
      accountName: 'Nome',
      legalName: 'Razão social',
      taxId: 'ID fiscal',
      website: 'Site',
      accountStatus: 'Status da conta',
      yes: 'Sim',
      no: 'Não',
      dateFormat: 'Formato de data',
      accountCreated: 'Conta criada',
      owner: 'Proprietário',
      accountDetails: 'Detalhes da conta',
      membersTitle: 'Membros da conta',
      noMembers: 'Sem membros.',
      inactive: 'Inativo',
      pending: 'Pendente',
      aiAssist: 'Assistência de IA',
      intentTpl: 'intenção · {intent}',
      suggestedTags: 'Etiquetas sugeridas',
      sessionReplay: 'Gravação da sessão',
      sessionReplayDesc: 'Veja o que o usuário fez antes de abrir o ticket (cliques, navegação, requisições de rede).',
      openPosthog: 'Abrir no PostHog →',
      relatedOrder: 'Pedido relacionado',
      goToOrder: 'Ir para o detalhe do pedido →',
      relatedDocument: 'Documento em questão',
      openDocument: 'Abrir documento →',
      unassigned: 'Não atribuído',
      detailTags: 'Etiquetas',
      noTags: 'Sem etiquetas',
      detailLanguage: 'Idioma',
      detailFirstResponse: '1ª resposta',
      detailResolved: 'Resolvido',
      detailSlaBreached: 'SLA excedido',
      pastConversations: 'Conversas anteriores',
      firstTime: 'É a primeira vez que este cliente escreve.',
      activityLog: 'Registro de atividade',
      noEvents: 'Sem eventos.',
      relToday: 'hoje',
      relDaysTpl: '{n} d',
      relWeeksTpl: '{n} sem',
      relMonthsTpl: '{n} m',
      actorSystem: 'Sistema',
      actorSomeone: 'Alguém',
      actCreated: 'criou o ticket',
      actAssigned: 'atribuiu o ticket',
      actUnassigned: 'removeu a atribuição do ticket',
      actStatusChanged: 'mudou o status',
      actPriorityChanged: 'mudou a prioridade',
      actTagAdded: 'adicionou uma etiqueta',
      actTagRemoved: 'removeu uma etiqueta',
      actReplySent: 'enviou uma resposta',
      actNoteAdded: 'adicionou uma nota interna',
      actResolved: 'resolveu o ticket',
      actReopened: 'reabriu o ticket',
      actSnoozed: 'adiou o ticket',
      actMerged: 'mesclou o ticket',
      viewWidgetConversation: 'Ver conversa do widget',
      widgetConversation: 'Conversa do widget',
      messagesOne: '{n} mensagem',
      messagesOther: '{n} mensagens',
      attachedImage: 'Imagem anexada',
      attachment: 'Anexo',
      attachedFile: 'Arquivo anexado',
      fileFallback: 'arquivo',
      loading: 'Carregando…',
    },
  },
  adminPayments: {
    title: 'Pagamentos',
    transactionsOne: '{n} transação',
    transactionsOther: '{n} transações',
    subtitle: 'compras de plano, pacotes de créditos, renovações e recargas automáticas',
    refresh: 'Atualizar',
    exportExcel: 'Exportar Excel',
    exporting: 'Exportando…',
    exportError: 'Não foi possível exportar. Tente novamente.',
    searchPlaceholder: 'Buscar por cliente, e-mail, conta, plano ou ID do Stripe…',
    countOf: '{n} de {total}',
    loading: 'Carregando…',
    empty: 'Ainda não há pagamentos registrados.',
    emptyFiltered: 'Nenhum pagamento corresponde a estes filtros.',
    viewAccount: 'Ver conta',
    staleBackend: 'O servidor ainda não aplica estes filtros: a tabela só filtra os 200 pagamentos mais recentes e os totais são de todos os pagamentos. O Excel sai completo e filtrado.',
    filters: {
      period: 'Período',
      type: 'Tipo',
      status: 'Status',
      from: 'De',
      to: 'Até',
      clear: 'Limpar filtros',
      sinceDate: 'A partir de {date}',
      untilDate: 'Até {date}',
    },
    periods: {
      all: 'Tudo',
      thisMonth: 'Este mês',
      lastMonth: 'Mês anterior',
      last30Days: 'Últimos 30 dias',
      thisYear: 'Este ano',
      custom: 'Personalizado',
    },
    categories: {
      all: 'Todos',
      plan: 'Planos',
      credits: 'Pacotes de créditos',
      autoRecharge: 'Recargas automáticas',
      refund: 'Reembolsos',
    },
    statusAll: 'Todos',
    statuses: {
      active: 'Ativa',
      trial: 'Em teste',
      cancelsAtEnd: 'Será cancelada',
      canceled: 'Cancelada',
      unpaid: 'Inadimplente',
      incomplete: 'Incompleta',
      unknown: 'Sem dados',
      paid: 'Pago',
      refund: 'Reembolso',
    },
    statusHelp: {
      active: 'Assinatura ativa: será renovada automaticamente.',
      cancelsAtEnd: 'Cancelada pelo cliente: não será renovada no fim do período.',
      unpaid: 'O Stripe não conseguiu cobrar a renovação.',
      unknown: 'Não foi possível consultar o Stripe; a próxima cobrança é uma estimativa.',
    },
    cycles: {
      yearly: 'Anual',
      monthly: 'Mensal',
    },
    items: {
      plan: 'Plano',
      creditPack: 'Pacote de créditos',
      autoRecharge: 'Recarga automática',
      refund: 'Reembolso',
    },
    cards: {
      revenue: 'Receita',
      total: 'Total',
      netAndRefunds: 'Líquido {net} · reembolsos {refunds}',
      customersOne: '{n} cliente',
      customersOther: '{n} clientes',
      thisMonth: 'Este mês',
      plans: 'Planos',
      paymentsOne: '{n} pagamento',
      paymentsOther: '{n} pagamentos',
      creditPacks: 'Pacotes de créditos',
      purchasesOne: '{n} compra',
      purchasesOther: '{n} compras',
      activeSubscriptions: 'Assinaturas ativas',
      today: 'Hoje',
      mrr: 'MRR {usd}',
      cancelling: '{n} a cancelar',
      unpaid: '{n} em atraso',
      unknown: '{n} sem dados',
      creditsSold: 'Créditos vendidos',
    },
    columns: {
      date: 'Data',
      customer: 'Cliente',
      account: 'Conta',
      item: 'Item',
      cycle: 'Ciclo',
      status: 'Status',
      nextCharge: 'Próx. cobrança',
      description: 'Descrição',
      credits: 'Créditos',
      amount: 'Valor',
      stripeId: 'ID do Stripe',
      mode: 'Modo',
    },
    excel: {
      sheet: 'Pagamentos',
      date: 'Data',
      customer: 'Cliente',
      email: 'E-mail',
      account: 'Conta',
      type: 'Tipo',
      cycle: 'Ciclo',
      status: 'Status',
      nextCharge: 'Próxima cobrança',
      description: 'Descrição',
      credits: 'Créditos',
      amountUsd: 'Valor USD',
      stripeId: 'ID do Stripe',
      mode: 'Modo',
    },
  },
  adminAiCosts: {
    title: 'Custos de IA',
    subtitle: 'O que a EZDocu gasta com IA, com Claude (Anthropic) e Gemini (Google), por processo, modelo, dia e conta.',
    refresh: 'Atualizar',
    exportExcel: 'Excel',
    exporting: 'Exportando…',
    exportError: 'Não foi possível gerar o Excel. Tente novamente.',
    exportTruncated: 'O Excel traz só as primeiras {n} linhas. Reduza o período para ver o restante.',
    exportEmpty: 'Não há linhas para exportar neste período.',
    updatedAt: 'Atualizado às {time}',
    envSwitchLabel: 'Ambiente',
    envBadge: { production: 'Produção', staging: 'Staging', qa: 'QA', local: 'Local' },
    filters: {
      period: 'Período',
      provider: 'Provedor',
      allProviders: 'Todos',
      from: 'De',
      to: 'Até',
      apply: 'Aplicar',
      rangeTooLong: 'O intervalo não pode passar de {n} dias.',
      rangeIncomplete: 'Escolha as duas datas.',
    },
    periods: {
      today: 'Hoje',
      last7: 'Últimos 7 dias',
      thisMonth: 'Este mês',
      lastMonth: 'Mês anterior',
      last30: 'Últimos 30 dias',
      last90: 'Últimos 90 dias',
      custom: 'Personalizado',
    },
    kpis: {
      totalAi: 'Gasto total com IA',
      platform: 'Plataforma',
      callcenter: 'Central de atendimento',
      claude: 'Claude',
      gemini: 'Gemini',
      perPage: 'Custo por página',
      perOrder: 'Por pedido {usd}',
      ofTotal: '{pct} do total',
      callsOne: '{n} chamada',
      callsOther: '{n} chamadas',
      pagesOne: '{n} página',
      pagesOther: '{n} páginas',
      ordersOne: '{n} pedido',
      ordersOther: '{n} pedidos',
      vsPrevious: 'Em relação a {range}',
      noPrevious: 'Sem período anterior comparável',
      platformDeltaNote: 'A variação compara só a plataforma: a central de atendimento não informa o período anterior.',
      savingsShort: 'Economia est. {usd}',
      more: 'Gasta mais',
      less: 'Gasta menos',
    },
    charts: {
      byDay: 'Gasto por dia',
      byDayHint: 'US$ por dia, empilhado por provedor',
      byProcess: 'Por processo',
      byProcessHint: 'Os 7 processos que mais gastam',
      others: 'Outros',
      usd: 'US$',
      calls: 'Chamadas',
      total: 'Total',
    },
    savings: {
      title: 'Economia estimada com Gemini',
      note: 'Quanto as chamadas respondidas pelo Gemini teriam custado no Claude, menos o que custaram. Os testes em sombra aparecem à parte.',
      geminiCost: 'Custo no Gemini',
      claudeEstimate: 'Teria custado no Claude',
      savings: 'Economia',
      shadow: 'Testes em sombra',
      none: 'Nenhum processo usou o Gemini neste período.',
      process: 'Processo',
    },
    tables: {
      byModel: 'Por modelo',
      byProcess: 'Por processo',
      model: 'Modelo',
      process: 'Processo',
      provider: 'Provedor',
      calls: 'Chamadas',
      tokensIn: 'Entrada',
      cacheRead: 'Cache de leitura',
      cacheWrite: 'Cache de escrita',
      cacheSplit: 'L {read} · E {write}',
      tokensOut: 'Saída',
      reasoning: 'Raciocínio',
      avgSeconds: 'Tempo médio',
      usd: 'US$',
      share: '% do gasto',
      failed: 'Falhas',
      fallbacks: 'Reservas',
      stages: 'Etapas',
      models: 'Modelos',
      providers: 'Provedores',
      unknownPriceOne: '{n} chamada usou um modelo sem tarifa: foi cobrada pela tarifa mais alta.',
      unknownPriceOther: '{n} chamadas usaram um modelo sem tarifa: foram cobradas pela tarifa mais alta.',
    },
    top: {
      accounts: 'Contas que mais gastam',
      orders: 'Pedidos que mais gastam',
      account: 'Conta',
      order: 'Pedido',
      ordersCount: 'Pedidos',
      pages: 'Páginas',
      usdPerPage: 'US$/página',
      noAccount: 'Conta de outro ambiente',
      processes: 'Processos',
      empty: 'Sem gasto ligado a contas neste período.',
    },
    environments: {
      title: 'Por ambiente',
      hint: 'Cada ambiente tem a sua própria chave e o seu próprio saldo.',
      unavailable: 'Sem dados',
      notConfigured: 'Não configurado',
      noRecord: 'Registro ainda não ativo',
      otherRows: 'Esta base também guarda {usd} de chamadas feitas a partir de “{env}”, que não são somadas aqui.',
      current: 'Exibindo',
    },
    callcenter: {
      title: 'Central de atendimento (suporte)',
      subtitle: 'Chat do widget e tickets de suporte da EZDocu, com o custo da sua IA.',
      cost: 'Custo de IA',
      conversations: 'Conversas',
      messages: 'Mensagens',
      tickets: 'Tickets',
      autoReplied: 'Respostas automáticas',
      escalated: 'Escalados',
      byDay: 'Gasto por dia',
      byProcessModel: 'Por processo e modelo',
      noCostBefore: 'Sem registro de custos antes de {date}. Conversas, mensagens e tickets continuam sendo contados.',
      onlyProd: 'A central de atendimento atende a produção: o seu custo só entra no total com Produção.',
      unavailable: 'O consumo da central de atendimento não está disponível: {reason}.',
      empty: 'A central de atendimento não usou IA neste período.',
      motivos: {
        'no-configurado': 'falta configurar a chave de consumo no gateway',
        timeout: 'a central de atendimento levou mais de 5 s para responder',
        'no-autorizado': 'a central de atendimento recusou a chave de consumo',
        'rango-invalido': 'a central de atendimento não aceita este intervalo de datas',
        http: 'a central de atendimento respondeu com o erro {code}',
        red: 'não foi possível conectar com a central de atendimento',
        'respuesta-invalida': 'a central de atendimento respondeu num formato inesperado',
      },
    },
    states: {
      loading: 'Carregando…',
      empty: 'Sem chamadas de IA neste período',
      emptyHint: 'Experimente um intervalo maior.',
      noTable: 'O registro de custos ainda não está ativo neste ambiente: falta aplicar manualmente a migração 030 do processing-ms.',
      error: 'Não foi possível carregar os custos de IA ({reason}).',
      retry: 'Tentar novamente',
      noRecordBefore: 'Sem registro de custos antes de {date}.',
      backfillNote: 'Inclui {usd} de histórico estimado, de antes do registro ao vivo.',
      notConfigured: 'Este ambiente não está configurado no servidor.',
    },
    groups: {
      'crear-orden': 'Criar pedido',
      procesar: 'Processar',
      traducir: 'Traduzir',
      revisar: 'Revisar',
      glosario: 'Glossário',
      formato: 'Formato',
      admin: 'Admin',
      latente: 'Em desuso',
    },
    processes: {
      clasificacion: 'Classificação do documento',
      'clasificacion-sombra': 'Classificação (teste em sombra)',
      'giro-texto': 'Rotação da página',
      'esquinas-foto': 'Recorte de foto',
      transcripcion: 'Transcrição de páginas',
      'marcas-bbox': 'Localização de carimbos e assinaturas',
      'tablas-validador': 'Detecção de tabelas',
      'traduccion-html': 'Tradução por páginas',
      'traduccion-terminos': 'Lista de termos',
      'traduccion-textos': 'Tradução por textos (Word/ODT/blocos)',
      'post-edicion': 'Pós-edição',
      'corpus-correcciones': 'Termos a partir de correções',
      'corpus-extractor': 'Glossário a partir de pares',
      'glosario-validador': 'Validação de termos',
      'glosario-ingesta': 'Importação de dicionários',
      'glosario-metadatos': 'Idiomas do dicionário',
      'cierre-formula': 'Fórmula de encerramento',
      'plantilla-nombre': 'Nome do modelo',
      'insights-chat': 'Assistente do admin',
      'mensaje-compartir': 'Melhoria da mensagem para compartilhar',
      'manuscrito-docx-legacy': 'Manuscrito para Word (antigo)',
      'escaneo-foto-legacy': 'Digitalização de foto (antiga)',
      'fusion-parrafos': 'Fusão de parágrafos',
      preanalisis: 'Pré-análise do documento',
      'preproceso-ocr': 'Pré-processamento do OCR',
      'legacy-colores': 'Cores (antigo)',
      'legacy-tablas-hoja': 'Tabelas por página (antigo)',
      'legacy-transcripcion-html': 'Transcrição HTML (antiga)',
      traduccion: 'Tradução (histórico)',
      'widget-chat': 'Chat do widget',
      autoresponder: 'Resposta automática de tickets',
      tagger: 'Etiquetagem de tickets',
      summary: 'Resumo de conversas',
      embeddings: 'Embeddings para busca',
    },
    stages: {
      principal: 'Principal',
      precalentado: 'Pré-aquecimento do cache',
      antibucle: 'Antilaço',
      'reintento-corte': 'Nova tentativa após corte',
      'sin-contexto': 'Sem contexto',
      backfill: 'Histórico estimado',
    },
    providers: { anthropic: 'Claude (Anthropic)', gemini: 'Gemini (Google)', voyage: 'Voyage AI', other: 'Outro' },
    sources: { vivo: 'Ao vivo', backfill: 'Histórico estimado' },
    summaryCard: {
      title: 'Custos de IA',
      seeDetail: 'Ver detalhes',
      platformOnly: 'Só a plataforma. A central de atendimento e o detalhamento por processo estão nos detalhes.',
      noData: 'Sem dados de custos de IA neste período.',
    },
    excel: {
      sheet: 'Custos de IA',
      date: 'Data',
      environment: 'Ambiente',
      provider: 'Provedor',
      model: 'Modelo',
      process: 'Processo',
      processId: 'ID do processo',
      stage: 'Etapa',
      calls: 'Chamadas',
      failed: 'Falhas',
      fallbacks: 'Reservas',
      shadow: 'Em sombra',
      tokensUncached: 'Tokens de entrada',
      cacheRead: 'Tokens de cache (leitura)',
      cacheWrite: 'Tokens de cache (escrita)',
      tokensOut: 'Tokens de saída',
      reasoning: 'Tokens de raciocínio',
      usd: 'US$',
      avgSeconds: 'Segundos médios',
      source: 'Origem',
      yes: 'Sim',
      no: 'Não',
    },
  },
  glossary: {
    title: 'Glossário global',
    subtitle: 'Terminologia compartilhada entre todas as contas. Usada em traduções automáticas.',
    categoriesBtn: 'Categorias',
    uploadFile: 'Enviar arquivo',
    newTerm: 'Novo termo',
    breadcrumbRoot: 'Glossário',
    categoriesWithDataTpl: 'Categorias com termos ({n})',
    emptyCategoriesTpl: 'Categorias vazias ({n})',
    termsCountOne: '{n} termo',
    termsCountOther: '{n} termos',
    pairsCountOne: '{n} par',
    pairsCountOther: '{n} pares',
    defsCountTpl: '{n} def.',
    backToCategories: 'Categorias',
    pairType: 'Par bilíngue',
    definitionType: 'Monolíngue (definição)',
    pairTypeDescTpl: 'Termo + tradução. {n} entradas.',
    definitionTypeDescTpl: 'Termo + definição. {n} entradas.',
    backToTypes: 'Tipos',
    langComboTermsTpl: '{n} termos · {combo}',
    emptyType: 'Nenhuma entrada neste tipo.',
    deleteLangTitle: 'Excluir termos',
    deleteLangBodyTpl: 'Você vai excluir {n} termos de {cat} · {combo}.',
    deleteCannotUndo: 'Esta ação não pode ser desfeita.',
    cancel: 'Cancelar',
    deleteCountTpl: 'Excluir {n}',
    backToLanguages: 'Idiomas',
    filterByLetter: 'Filtrar por letra',
    allLetters: 'Todas',
    search: 'Pesquisar',
    searchPlaceholder: 'Pesquisar termo ou tradução...',
    onlyVerified: 'Somente verificados',
    refresh: 'Atualizar',
    downloadPdf: 'Baixar PDF',
    generatingPdf: 'Gerando…',
    downloadPdfTipFiltered: 'O download respeita os filtros ativos',
    downloadPdfTipAll: 'Baixar TODO o glossário desta categoria/tipo',
    selectFilterCountTpl: 'Selecionar os {n} termos do filtro',
    selectedCountTpl: '{n} selecionados',
    allFilter: '(todo o filtro)',
    verify: 'Verificar',
    unverify: 'Desmarcar',
    clear: 'Limpar',
    pageXofYTpl: 'página {p} / {t}',
    letterLabelTpl: 'letra {l}',
    otherLetter: 'outros',
    noTerms: 'Não há termos com estes filtros.',
    previous: '← Anterior',
    next: 'Próximo →',
    term: 'Termo',
    translation: 'Tradução',
    definition: 'Definição',
    source: 'Fonte',
    actions: 'Ações',
    verifiedTitle: 'Verificado · clique para desmarcar',
    unverifiedTitle: 'Não verificado · clique para aprovar',
    selectPage: 'Selecionar esta página',
    entryNewTitle: 'Novo termo',
    entryEditTitle: 'Editar termo',
    fieldCategory: 'Categoria',
    fieldCategoryHelp: 'Agrupa termos por domínio (jurídico, médico, técnico...). Usado para sugerir o glossário certo ao traduzir.',
    fieldType: 'Tipo',
    fieldTypeHelp: 'Par de tradução = termo origem + termo destino em outro idioma. Definição (monolíngue) = termo + explicação no mesmo idioma.',
    fieldSourceTerm: 'Termo origem',
    fieldSourceTermHelp: 'A palavra ou frase exatamente como aparece no documento original. Armazenada em minúsculas para pesquisa insensível.',
    fieldLang: 'Idioma',
    fieldSourceLangHelp: 'Idioma do termo origem no código ISO-639-1 (es, en, pt, fr, it, de).',
    fieldTranslation: 'Tradução',
    fieldTranslationHelp: 'Como o termo origem deve ser traduzido no idioma destino. Usado como referência preferencial.',
    fieldTargetLangHelp: 'Idioma do termo traduzido (ISO-639-1).',
    fieldDefinition: 'Definição',
    fieldDefinitionHelp: 'Explicação do termo no mesmo idioma da origem. Útil para termos técnicos/jurídicos sem tradução direta.',
    fieldContext: 'Contexto (opcional)',
    fieldContextHelp: 'Notas sobre quando este termo se aplica (país, subdomínio, registro). Apenas guia para o revisor.',
    fieldPriority: 'Prioridade (0-100)',
    fieldPriorityHelp: 'Entre termos duplicados, o de maior prioridade vence. 0 = normal, 50+ = preferencial, 100 = sempre forçar.',
    fieldVerified: 'Verificado',
    fieldVerifiedHelp: 'Marca termos revisados por humano. Verificados têm prioridade sobre não verificados ao traduzir.',
    fieldSourceKind: 'Tipo de fonte',
    fieldSourceKindHelp: 'De onde vem o termo: Manual, PDF/CSV/TXT, IA (Claude), Web (página pública), Cliente (documento privado).',
    fieldSourceLabel: 'Nome / referência',
    fieldSourceLabelHelp: 'Nome legível da fonte para auditoria. Aparece na coluna Fonte da tabela.',
    fieldSourceUrl: 'URL (se vem da web)',
    fieldSourceUrlHelp: 'Link canônico para a página original. Se vazio, nenhum link aparece na tabela.',
    fieldSourceUrlHint: 'Ex: https://www.justicia.ar/herramientas/glosario',
    provenanceTitle: 'Fonte / Procedência',
    selectPlaceholder: '— Selecionar —',
    entryPairOption: 'Par de tradução',
    entryDefinitionOption: 'Definição (monolíngue)',
    save: 'Salvar',
    sourceTermPlaceholder: 'Ex: certidão de nascimento',
    translationPlaceholder: 'Ex: birth certificate',
    definitionPlaceholder: 'Definição do termo no mesmo idioma da origem...',
    contextPlaceholder: 'Ex: usado em documentos jurídicos na Colômbia',
    sourceLabelPlaceholder: 'Ex: Cabanellas 2023 / Cliente ACME',
    originalFile: 'Arquivo original',
    sourceManual: 'Manual',
    sourcePdf: 'PDF',
    sourceCsv: 'CSV',
    sourceTxt: 'TXT',
    sourceAi: 'IA',
    sourceLearning: 'Tradução',
    sourceWeb: 'Web',
    sourceClient: 'Cliente',
    uploadTitle: 'Enviar glossário',
    uploadConfirmTitle: 'Confirmar dados',
    tabFile: 'Arquivo',
    tabUrl: 'URL',
    tabPaste: 'Colar texto',
    uploadClickToSelect: 'Clique para selecionar arquivo',
    uploadHint: 'PDF, CSV ou TXT · sem limite de tamanho',
    uploadAnalyzing: 'Claude está analisando o arquivo…',
    urlFieldLabel: 'URL do glossário',
    urlFieldHint: 'Ex: https://www.justicia.ar/herramientas/glosario',
    analyzeUrl: 'Analisar URL',
    readingPage: 'Lendo página…',
    pageTitleLabel: 'Título',
    pasteFieldLabel: 'Conteúdo (colar de Claude Max, Excel, web, etc.)',
    pasteFieldHint: 'Detectado como CSV se tiver vírgulas + quebras de linha; senão, processado como texto livre',
    pastePlaceholder: 'source_term,source_lang,target_term,target_lang,entry_type\ncertidão de nascimento,pt,birth certificate,en,pair\n...',
    sourceName: 'Nome da fonte',
    sourceNamePlaceholder: 'Ex: Claude Max — Glossário jurídico',
    originalUrlOptional: 'URL original (opcional)',
    analyzeText: 'Analisar texto',
    analyzing: 'Analisando…',
    claudeHelpTitle: '💡 O que o Claude faz ao enviar:',
    claudeHelpDetectLangs: 'Detecta idiomas (origem / destino)',
    claudeHelpDetectType: 'Detecta tipo (par bilíngue ou monolíngue)',
    claudeHelpSuggestCategory: 'Sugere categoria adequada',
    claudeHelpSaveSource: 'Salva a fonte (arquivo / URL / label) em cada termo',
    claudeAnalyzedTpl: 'Claude analisou {file} ({chars} chars). Revise e edite se algo não bater.',
    destCategory: 'Categoria destino',
    contentType: 'Tipo de conteúdo',
    pairOption: 'Par bilíngue',
    monolingualOption: 'Monolíngue',
    srcLang: 'Idioma origem',
    tgtLang: 'Idioma destino',
    savedSource: 'Fonte salva em cada termo',
    changeSource: '← Trocar fonte',
    process: 'Processar',
    urlInvalid: 'URL inválida',
    urlEmpty: 'Digite uma URL',
    urlNoText: 'A página não retornou texto suficiente',
    pasteTooShort: 'Cole pelo menos 200 caracteres de conteúdo',
    urlErrorGeneric: 'Erro ao analisar a URL',
    detectError: 'Não foi possível detectar metadados',
    uploadErrorGeneric: 'Erro ao enviar',
    confSure: 'seguro',
    confProbable: 'provável',
    confUnsure: 'incerto',
    msgTermCreated: 'Termo criado',
    msgTermUpdated: 'Termo atualizado',
    msgTermDeleted: 'Termo excluído',
    msgSaveError: 'Erro ao salvar',
    msgBulkVerifiedTpl: '{n} termos verificados',
    msgBulkUnverifiedTpl: '{n} termos desmarcados',
    msgVerifyError: 'Erro ao verificar',
    msgBulkDeletedTpl: '{n} termos excluídos',
    msgDeleteError: 'Erro ao excluir',
    msgPdfDownloadedTpl: 'PDF baixado ({n} entradas)',
    msgPdfError: 'Erro ao exportar PDF',
    errorFetchEntries: 'Erro ao obter entradas',
    helpAria: 'Ajuda',
    langNameEs: 'Espanhol',
    langNameEn: 'Inglês',
    langNamePt: 'Português',
    langNameFr: 'Francês',
    langNameIt: 'Italiano',
    langNameDe: 'Alemão',
    fileReadError: 'Não foi possível ler o arquivo',
    urlReadErrorTpl: 'Não foi possível ler {url}',
    pasteLabelCsv: 'Texto colado (CSV)',
    pasteLabelText: 'Texto colado',
    noContent: 'Não há conteúdo para importar',
    charsCountTpl: '{n} caracteres',
    jobTitle: 'Processando arquivo',
    jobSuccess: 'Importação concluída',
    jobResultTpl: '{imported} termos importados · {duplicated} duplicados ignorados',
    jobTokensIn: 'Tokens de entrada',
    jobTokensOut: 'Tokens de saída',
    jobCacheHit: 'Acertos de cache',
    jobCostUsd: 'Custo USD',
    jobMethodModelTpl: 'Método: {method} · Modelo: {model}',
    jobError: 'Erro ao processar o arquivo',
    jobPreviewTpl: 'Prévia: {n} termos extraídos',
    jobColSource: 'Origem',
    jobColTarget: 'Destino / definição',
    jobShowingTpl: 'Mostrando 200 de {n}. Ao confirmar, todos são importados.',
    jobDiscard: 'Descartar',
    jobConfirm: 'Confirmar importação',
    jobClose: 'Fechar',
    stageQueued: 'Na fila',
    stageExtracting: 'Extraindo texto',
    stageParsing: 'Analisando',
    stageParsedTpl: 'Analisados {done}/{total} blocos',
    stageAwaiting: 'Aguardando confirmação do admin',
    stageInserting: 'Salvando termos',
    stageDone: 'Pronto',
    stageCancelled: 'Cancelado',
    stageError: 'Erro',
    catBackToGlossaries: 'Glossários',
    catTitle: 'Categorias de documentos',
    catSubtitle: 'Tipos de documento que classificam os termos do glossário global. As do sistema não podem ser excluídas.',
    catNew: 'Nova categoria',
    catEdit: 'Editar categoria',
    catCreated: 'Categoria criada',
    catUpdated: 'Categoria atualizada',
    catDeleted: 'Categoria excluída',
    catCannotDelete: 'Não é possível excluir: a categoria tem termos associados.',
    catConfirmDeleteTpl: 'Excluir a categoria "{name}"? Só é possível se não tiver termos associados.',
    catShowInactive: 'Mostrar inativas',
    catCountOne: '{n} categoria',
    catCountOther: '{n} categorias',
    catColKey: 'Chave',
    catColName: 'Nome (5 idiomas)',
    catColTerms: 'Termos',
    catColActive: 'Ativa',
    catColActions: 'Ações',
    catSystemTitle: 'Categoria do sistema: não pode ser excluída',
    catSystemBadge: 'sistema',
    catActivate: 'Ativar',
    catDeactivate: 'Desativar',
    catEditBtn: 'Editar',
    catDeleteBtn: 'Excluir',
    catEmpty: 'Ainda não há categorias. Crie a primeira para começar.',
    catFieldKey: 'Chave (slug)',
    catFieldKeyHint: 'Minúsculas, hífens ou _. Não pode ser alterada depois.',
    catKeyPlaceholder: 'ex.: medical_lab',
    catFieldNameTpl: 'Nome {lang}',
    catFieldDescription: 'Descrição (opcional)',
    catFieldIcon: 'Ícone (opcional)',
    catFieldIconHint: 'Emoji ou nome',
    catFieldOrder: 'Ordem',
    catActiveLabel: 'Ativa (disponível para classificar termos)',
    catSave: 'Salvar',
  },
  sharedComponents: {
    notificationBell: {
      ariaLabel: 'Notificações',
    },
    languageSelector: {
      tooltip: 'Mudar idioma',
    },
    professionalProfile: {
      associationSearchHint: 'Pesquise entre 85+ associações verificadas ou digite "Outra"',
      associationSearchPlaceholder: 'Pesquisar associação (ex: ATA, BDÜ, CTPCBA...)',
      noResults: 'Sem resultados',
    },
  },
  verifyPublic: {
    humanVerified: 'Verificado por humano',
    kmsSigned: 'Assinado com KMS',
    translationOnRecord: 'Tradução registrada',
    statusHashing: 'Verificando arquivo…',
    statusPurgedWithHash: 'Esta tradução foi concluída e assinada pelo tradutor acima. O arquivo original não está mais armazenado em nossos servidores, mas você pode enviar sua cópia abaixo para verificar se a assinatura confere — o arquivo é checado em seu navegador e nunca sai do seu dispositivo.',
    statusWithHash: 'Esta tradução foi concluída e assinada pelo tradutor acima. Para confirmar que o PDF que você recebeu é autêntico, envie-o abaixo — o arquivo é checado em seu navegador e nunca sai do seu dispositivo.',
    statusNoHash: 'Esta tradução foi concluída e assinada pelo tradutor acima. O conteúdo assinado está armazenado em nossos servidores e não foi alterado.',
    documentVerifiedTitle: 'Documento verificado',
    documentVerifiedDesc: 'O arquivo enviado corresponde exatamente à tradução assinada. Este documento não foi alterado.',
    fileMismatchTitle: 'Arquivo não confere',
    fileMismatchDesc: 'O arquivo enviado não corresponde à tradução assinada. Mesmo ações menores como salvar novamente ou comprimir podem causar divergência. Por favor solicite o arquivo assinado e tente novamente.',
    documentDetailsLabel: 'Detalhes do documento',
    documentField: 'Documento',
    orderField: 'Pedido',
    languagesField: 'Idiomas',
    pagesField: 'Páginas',
    verifiedByField: 'Verificado por',
    verifiedOnField: 'Verificado em',
    verifyIntegrityLabel: 'Verificar integridade do documento',
    computingHash: 'Calculando hash…',
    dropzoneTitlePurged: 'Envie sua cópia do PDF assinado',
    dropzoneTitle: 'Envie o PDF fornecido pelo tradutor',
    dropzoneHintPurged: 'O arquivo não está mais em nossos servidores. Seu hash permanece assinado em nosso banco de dados e é comparado com o seu apenas em seu navegador.',
    dropzoneHint: 'O arquivo é checado apenas em seu navegador. Nunca sai do seu dispositivo.',
    fileNotAvailableBox: 'A comparação direta de arquivo não está disponível para este registro. O conteúdo da tradução foi assinado criptograficamente no momento da verificação e permanece inalterado em nossos servidores.',
    disclaimerPurged: 'Zero-knowledge por design: o arquivo assinado não está mais em nossos servidores, mas sua impressão criptográfica fica armazenada permanentemente. Envie sua cópia para provar que confere com o arquivo que o tradutor assinou.',
    disclaimerWithHash: 'Esta página por si só confirma que uma tradução está registrada com este profissional. Ela não valida o arquivo em sua posse até que você o envie para comparação.',
    disclaimerNoHash: 'Esta página confirma que uma tradução está registrada com este profissional. A comparação por envio não está disponível para este registro; a integridade é garantida no nível do conteúdo.',
    saveBtn: 'Salvar esta verificação',
    verificationResultLabel: 'Resultado da verificação',
    exactMatchTitle: 'Correspondência exata confirmada',
    exactMatchDesc: 'O arquivo enviado é idêntico à tradução assinada.',
    certificationStatementLabel: 'Declaração de certificação',
    defaultCertStatement: 'Certifico que esta é uma tradução fiel e precisa do documento original, no melhor de meu conhecimento e habilidade.',
    verifiedDisclaimer: 'O arquivo enviado corresponde exatamente à tradução assinada emitida pelo tradutor. A EZDocuAI verifica apenas a integridade do arquivo. O tradutor é o único responsável pelo conteúdo e pela precisão desta tradução.',
    reverifyBtn: 'Re-verificar',
    fileMismatchResultTitle: 'Divergência de arquivo detectada',
    fileMismatchResultDesc: 'O arquivo enviado não corresponde à tradução assinada.',
    mismatchDisclaimer: 'A EZDocuAI não analisa o que mudou. Apenas verifica se o arquivo enviado é idêntico à tradução assinada.',
    inspectedCannotConfirmTitle: 'Não podemos confirmar este arquivo',
    inspectedCannotConfirmDesc: 'Nenhum hash de arquivo foi armazenado para esta verificação, portanto não podemos confirmar se o PDF que você enviou é o que o tradutor assinou. Solicite o arquivo assinado diretamente ao tradutor.',
    yourFileHashLabel: 'Hash do seu arquivo (SHA-256)',
    inspectedDisclaimer: 'Seu arquivo nunca saiu do seu navegador — apenas calculamos o SHA-256 localmente e o mantivemos em tela como comprovação. Um veredicto definitivo de correspondência ou não só é possível para verificações que armazenaram o hash do PDF assinado no momento da assinatura.',
    tryAgainBtn: 'Tentar novamente',
    contactTranslatorBtn: 'Contatar o tradutor',
    mailtoSubject: 'Divergência de verificação – {order}',
    mailtoBody: 'Prezado(a) {translator},\n\nTentei verificar uma tradução através da EZDocuAI e o arquivo enviado não conferiu com a versão assinada no registro.\n\nPedido: {order}\nDocumento: {document}\n\nVocê poderia fornecer uma nova cópia digital certificada?\n\nObrigado.',
    cryptographicDetails: 'Detalhes criptográficos',
    verificationIdLabel: 'ID de verificação',
    documentHashLabel: 'Hash do documento (SHA-256)',
    contentHashLabel: 'Hash do conteúdo (SHA-256)',
    localVerificationNote: 'Verificação local: o arquivo é checado em seu navegador e nunca enviado para nenhum servidor.',
    verificationIssuedAt: 'Verificação emitida em {date} às {time} UTC',
    poweredBy: 'Desenvolvido por',
    footerDisclaimer: 'A EZDocuAI é exclusivamente uma provedora de tecnologia. Não avaliamos o conteúdo do documento, a precisão da tradução ou a conformidade legal. Esta página apenas confirma a integridade técnica do arquivo digital.',
    zeroKnowledgeEncrypted: 'Criptografia Zero Knowledge',
    notFoundTitle: 'Verificação não encontrada',
    notFoundDesc: 'O certificado de verificação de tradução que você está procurando não existe ou o ID é inválido.',
    goToHome: 'Ir para EZDocuAI',
  },
};
